/*! Element Plus Icons Vue v2.3.1 */


// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/add-location.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent } from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var add_location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent({
  name: "AddLocation",
  __name: "add-location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M544 384h96a32 32 0 1 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0z"
      })
    ]));
  }
});

// src/components/add-location.vue
var add_location_default = add_location_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/aim.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent2 } from "vue";
import { createElementVNode as _createElementVNode2, openBlock as _openBlock2, createElementBlock as _createElementBlock2 } from "vue";
var aim_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent2({
  name: "Aim",
  __name: "aim",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock2(), _createElementBlock2("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode2("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode2("path", {
        fill: "currentColor",
        d: "M512 96a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V128a32 32 0 0 1 32-32m0 576a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V704a32 32 0 0 1 32-32M96 512a32 32 0 0 1 32-32h192a32 32 0 0 1 0 64H128a32 32 0 0 1-32-32m576 0a32 32 0 0 1 32-32h192a32 32 0 1 1 0 64H704a32 32 0 0 1-32-32"
      })
    ]));
  }
});

// src/components/aim.vue
var aim_default = aim_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/alarm-clock.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent3 } from "vue";
import { createElementVNode as _createElementVNode3, openBlock as _openBlock3, createElementBlock as _createElementBlock3 } from "vue";
var alarm_clock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent3({
  name: "AlarmClock",
  __name: "alarm-clock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock3(), _createElementBlock3("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode3("path", {
        fill: "currentColor",
        d: "M512 832a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
      }),
      _createElementVNode3("path", {
        fill: "currentColor",
        d: "m292.288 824.576 55.424 32-48 83.136a32 32 0 1 1-55.424-32zm439.424 0-55.424 32 48 83.136a32 32 0 1 0 55.424-32zM512 512h160a32 32 0 1 1 0 64H480a32 32 0 0 1-32-32V320a32 32 0 0 1 64 0zM90.496 312.256A160 160 0 0 1 312.32 90.496l-46.848 46.848a96 96 0 0 0-128 128L90.56 312.256zm835.264 0A160 160 0 0 0 704 90.496l46.848 46.848a96 96 0 0 1 128 128z"
      })
    ]));
  }
});

// src/components/alarm-clock.vue
var alarm_clock_default = alarm_clock_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/apple.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent4 } from "vue";
import { createElementVNode as _createElementVNode4, openBlock as _openBlock4, createElementBlock as _createElementBlock4 } from "vue";
var apple_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent4({
  name: "Apple",
  __name: "apple",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock4(), _createElementBlock4("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode4("path", {
        fill: "currentColor",
        d: "M599.872 203.776a189.44 189.44 0 0 1 64.384-4.672l2.624.128c31.168 1.024 51.2 4.096 79.488 16.32 37.632 16.128 74.496 45.056 111.488 89.344 96.384 115.264 82.752 372.8-34.752 521.728-7.68 9.728-32 41.6-30.72 39.936a426.624 426.624 0 0 1-30.08 35.776c-31.232 32.576-65.28 49.216-110.08 50.048-31.36.64-53.568-5.312-84.288-18.752l-6.528-2.88c-20.992-9.216-30.592-11.904-47.296-11.904-18.112 0-28.608 2.88-51.136 12.672l-6.464 2.816c-28.416 12.224-48.32 18.048-76.16 19.2-74.112 2.752-116.928-38.08-180.672-132.16-96.64-142.08-132.608-349.312-55.04-486.4 46.272-81.92 129.92-133.632 220.672-135.04 32.832-.576 60.288 6.848 99.648 22.72 27.136 10.88 34.752 13.76 37.376 14.272 16.256-20.16 27.776-36.992 34.56-50.24 13.568-26.304 27.2-59.968 40.704-100.8a32 32 0 1 1 60.8 20.224c-12.608 37.888-25.408 70.4-38.528 97.664zm-51.52 78.08c-14.528 17.792-31.808 37.376-51.904 58.816a32 32 0 1 1-46.72-43.776l12.288-13.248c-28.032-11.2-61.248-26.688-95.68-26.112-70.4 1.088-135.296 41.6-171.648 105.792C121.6 492.608 176 684.16 247.296 788.992c34.816 51.328 76.352 108.992 130.944 106.944 52.48-2.112 72.32-34.688 135.872-34.688 63.552 0 81.28 34.688 136.96 33.536 56.448-1.088 75.776-39.04 126.848-103.872 107.904-136.768 107.904-362.752 35.776-449.088-72.192-86.272-124.672-84.096-151.68-85.12-41.472-4.288-81.6 12.544-113.664 25.152z"
      })
    ]));
  }
});

// src/components/apple.vue
var apple_default = apple_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-down-bold.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent5 } from "vue";
import { createElementVNode as _createElementVNode5, openBlock as _openBlock5, createElementBlock as _createElementBlock5 } from "vue";
var arrow_down_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent5({
  name: "ArrowDownBold",
  __name: "arrow-down-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock5(), _createElementBlock5("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode5("path", {
        fill: "currentColor",
        d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"
      })
    ]));
  }
});

// src/components/arrow-down-bold.vue
var arrow_down_bold_default = arrow_down_bold_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-down.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent6 } from "vue";
import { createElementVNode as _createElementVNode6, openBlock as _openBlock6, createElementBlock as _createElementBlock6 } from "vue";
var arrow_down_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent6({
  name: "ArrowDown",
  __name: "arrow-down",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock6(), _createElementBlock6("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode6("path", {
        fill: "currentColor",
        d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
      })
    ]));
  }
});

// src/components/arrow-down.vue
var arrow_down_default = arrow_down_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-left-bold.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent7 } from "vue";
import { createElementVNode as _createElementVNode7, openBlock as _openBlock7, createElementBlock as _createElementBlock7 } from "vue";
var arrow_left_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent7({
  name: "ArrowLeftBold",
  __name: "arrow-left-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock7(), _createElementBlock7("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode7("path", {
        fill: "currentColor",
        d: "M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0z"
      })
    ]));
  }
});

// src/components/arrow-left-bold.vue
var arrow_left_bold_default = arrow_left_bold_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-left.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent8 } from "vue";
import { createElementVNode as _createElementVNode8, openBlock as _openBlock8, createElementBlock as _createElementBlock8 } from "vue";
var arrow_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent8({
  name: "ArrowLeft",
  __name: "arrow-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock8(), _createElementBlock8("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode8("path", {
        fill: "currentColor",
        d: "M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"
      })
    ]));
  }
});

// src/components/arrow-left.vue
var arrow_left_default = arrow_left_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-right-bold.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent9 } from "vue";
import { createElementVNode as _createElementVNode9, openBlock as _openBlock9, createElementBlock as _createElementBlock9 } from "vue";
var arrow_right_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent9({
  name: "ArrowRightBold",
  __name: "arrow-right-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock9(), _createElementBlock9("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode9("path", {
        fill: "currentColor",
        d: "M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0z"
      })
    ]));
  }
});

// src/components/arrow-right-bold.vue
var arrow_right_bold_default = arrow_right_bold_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-right.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent10 } from "vue";
import { createElementVNode as _createElementVNode10, openBlock as _openBlock10, createElementBlock as _createElementBlock10 } from "vue";
var arrow_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent10({
  name: "ArrowRight",
  __name: "arrow-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock10(), _createElementBlock10("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode10("path", {
        fill: "currentColor",
        d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
      })
    ]));
  }
});

// src/components/arrow-right.vue
var arrow_right_default = arrow_right_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-up-bold.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent11 } from "vue";
import { createElementVNode as _createElementVNode11, openBlock as _openBlock11, createElementBlock as _createElementBlock11 } from "vue";
var arrow_up_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent11({
  name: "ArrowUpBold",
  __name: "arrow-up-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock11(), _createElementBlock11("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode11("path", {
        fill: "currentColor",
        d: "M104.704 685.248a64 64 0 0 0 90.496 0l316.8-316.8 316.8 316.8a64 64 0 0 0 90.496-90.496L557.248 232.704a64 64 0 0 0-90.496 0L104.704 594.752a64 64 0 0 0 0 90.496z"
      })
    ]));
  }
});

// src/components/arrow-up-bold.vue
var arrow_up_bold_default = arrow_up_bold_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/arrow-up.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent12 } from "vue";
import { createElementVNode as _createElementVNode12, openBlock as _openBlock12, createElementBlock as _createElementBlock12 } from "vue";
var arrow_up_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent12({
  name: "ArrowUp",
  __name: "arrow-up",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock12(), _createElementBlock12("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode12("path", {
        fill: "currentColor",
        d: "m488.832 344.32-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0"
      })
    ]));
  }
});

// src/components/arrow-up.vue
var arrow_up_default = arrow_up_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/avatar.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent13 } from "vue";
import { createElementVNode as _createElementVNode13, openBlock as _openBlock13, createElementBlock as _createElementBlock13 } from "vue";
var avatar_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent13({
  name: "Avatar",
  __name: "avatar",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock13(), _createElementBlock13("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode13("path", {
        fill: "currentColor",
        d: "M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"
      })
    ]));
  }
});

// src/components/avatar.vue
var avatar_default = avatar_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/back.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent14 } from "vue";
import { createElementVNode as _createElementVNode14, openBlock as _openBlock14, createElementBlock as _createElementBlock14 } from "vue";
var back_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent14({
  name: "Back",
  __name: "back",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock14(), _createElementBlock14("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode14("path", {
        fill: "currentColor",
        d: "M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64"
      }),
      _createElementVNode14("path", {
        fill: "currentColor",
        d: "m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312z"
      })
    ]));
  }
});

// src/components/back.vue
var back_default = back_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/baseball.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent15 } from "vue";
import { createElementVNode as _createElementVNode15, openBlock as _openBlock15, createElementBlock as _createElementBlock15 } from "vue";
var baseball_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent15({
  name: "Baseball",
  __name: "baseball",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock15(), _createElementBlock15("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode15("path", {
        fill: "currentColor",
        d: "M195.2 828.8a448 448 0 1 1 633.6-633.6 448 448 0 0 1-633.6 633.6zm45.248-45.248a384 384 0 1 0 543.104-543.104 384 384 0 0 0-543.104 543.104"
      }),
      _createElementVNode15("path", {
        fill: "currentColor",
        d: "M497.472 96.896c22.784 4.672 44.416 9.472 64.896 14.528a256.128 256.128 0 0 0 350.208 350.208c5.056 20.48 9.856 42.112 14.528 64.896A320.128 320.128 0 0 1 497.472 96.896zM108.48 491.904a320.128 320.128 0 0 1 423.616 423.68c-23.04-3.648-44.992-7.424-65.728-11.52a256.128 256.128 0 0 0-346.496-346.432 1736.64 1736.64 0 0 1-11.392-65.728z"
      })
    ]));
  }
});

// src/components/baseball.vue
var baseball_default = baseball_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/basketball.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent16 } from "vue";
import { createElementVNode as _createElementVNode16, openBlock as _openBlock16, createElementBlock as _createElementBlock16 } from "vue";
var basketball_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent16({
  name: "Basketball",
  __name: "basketball",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock16(), _createElementBlock16("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode16("path", {
        fill: "currentColor",
        d: "M778.752 788.224a382.464 382.464 0 0 0 116.032-245.632 256.512 256.512 0 0 0-241.728-13.952 762.88 762.88 0 0 1 125.696 259.584zm-55.04 44.224a699.648 699.648 0 0 0-125.056-269.632 256.128 256.128 0 0 0-56.064 331.968 382.72 382.72 0 0 0 181.12-62.336m-254.08 61.248A320.128 320.128 0 0 1 557.76 513.6a715.84 715.84 0 0 0-48.192-48.128 320.128 320.128 0 0 1-379.264 88.384 382.4 382.4 0 0 0 110.144 229.696 382.4 382.4 0 0 0 229.184 110.08zM129.28 481.088a256.128 256.128 0 0 0 331.072-56.448 699.648 699.648 0 0 0-268.8-124.352 382.656 382.656 0 0 0-62.272 180.8m106.56-235.84a762.88 762.88 0 0 1 258.688 125.056 256.512 256.512 0 0 0-13.44-241.088A382.464 382.464 0 0 0 235.84 245.248zm318.08-114.944c40.576 89.536 37.76 193.92-8.448 281.344a779.84 779.84 0 0 1 66.176 66.112 320.832 320.832 0 0 1 282.112-8.128 382.4 382.4 0 0 0-110.144-229.12 382.4 382.4 0 0 0-229.632-110.208zM828.8 828.8a448 448 0 1 1-633.6-633.6 448 448 0 0 1 633.6 633.6"
      })
    ]));
  }
});

// src/components/basketball.vue
var basketball_default = basketball_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/bell-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent17 } from "vue";
import { createElementVNode as _createElementVNode17, openBlock as _openBlock17, createElementBlock as _createElementBlock17 } from "vue";
var bell_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent17({
  name: "BellFilled",
  __name: "bell-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock17(), _createElementBlock17("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode17("path", {
        fill: "currentColor",
        d: "M640 832a128 128 0 0 1-256 0zm192-64H134.4a38.4 38.4 0 0 1 0-76.8H192V448c0-154.88 110.08-284.16 256.32-313.6a64 64 0 1 1 127.36 0A320.128 320.128 0 0 1 832 448v243.2h57.6a38.4 38.4 0 0 1 0 76.8z"
      })
    ]));
  }
});

// src/components/bell-filled.vue
var bell_filled_default = bell_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/bell.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent18 } from "vue";
import { createElementVNode as _createElementVNode18, openBlock as _openBlock18, createElementBlock as _createElementBlock18 } from "vue";
var bell_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent18({
  name: "Bell",
  __name: "bell",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock18(), _createElementBlock18("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode18("path", {
        fill: "currentColor",
        d: "M512 64a64 64 0 0 1 64 64v64H448v-64a64 64 0 0 1 64-64"
      }),
      _createElementVNode18("path", {
        fill: "currentColor",
        d: "M256 768h512V448a256 256 0 1 0-512 0zm256-640a320 320 0 0 1 320 320v384H192V448a320 320 0 0 1 320-320"
      }),
      _createElementVNode18("path", {
        fill: "currentColor",
        d: "M96 768h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32m352 128h128a64 64 0 0 1-128 0"
      })
    ]));
  }
});

// src/components/bell.vue
var bell_default = bell_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/bicycle.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent19 } from "vue";
import { createElementVNode as _createElementVNode19, openBlock as _openBlock19, createElementBlock as _createElementBlock19 } from "vue";
var bicycle_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent19({
  name: "Bicycle",
  __name: "bicycle",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock19(), _createElementBlock19("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M256 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M288 672h320q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M768 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "M480 192a32 32 0 0 1 0-64h160a32 32 0 0 1 31.04 24.256l96 384a32 32 0 0 1-62.08 15.488L615.04 192zM96 384a32 32 0 0 1 0-64h128a32 32 0 0 1 30.336 21.888l64 192a32 32 0 1 1-60.672 20.224L200.96 384z"
      }),
      _createElementVNode19("path", {
        fill: "currentColor",
        d: "m373.376 599.808-42.752-47.616 320-288 42.752 47.616z"
      })
    ]));
  }
});

// src/components/bicycle.vue
var bicycle_default = bicycle_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/bottom-left.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent20 } from "vue";
import { createElementVNode as _createElementVNode20, openBlock as _openBlock20, createElementBlock as _createElementBlock20 } from "vue";
var bottom_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent20({
  name: "BottomLeft",
  __name: "bottom-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock20(), _createElementBlock20("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode20("path", {
        fill: "currentColor",
        d: "M256 768h416a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V352a32 32 0 0 1 64 0z"
      }),
      _createElementVNode20("path", {
        fill: "currentColor",
        d: "M246.656 822.656a32 32 0 0 1-45.312-45.312l544-544a32 32 0 0 1 45.312 45.312l-544 544z"
      })
    ]));
  }
});

// src/components/bottom-left.vue
var bottom_left_default = bottom_left_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/bottom-right.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent21 } from "vue";
import { createElementVNode as _createElementVNode21, openBlock as _openBlock21, createElementBlock as _createElementBlock21 } from "vue";
var bottom_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent21({
  name: "BottomRight",
  __name: "bottom-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock21(), _createElementBlock21("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode21("path", {
        fill: "currentColor",
        d: "M352 768a32 32 0 1 0 0 64h448a32 32 0 0 0 32-32V352a32 32 0 0 0-64 0v416z"
      }),
      _createElementVNode21("path", {
        fill: "currentColor",
        d: "M777.344 822.656a32 32 0 0 0 45.312-45.312l-544-544a32 32 0 0 0-45.312 45.312z"
      })
    ]));
  }
});

// src/components/bottom-right.vue
var bottom_right_default = bottom_right_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/bottom.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent22 } from "vue";
import { createElementVNode as _createElementVNode22, openBlock as _openBlock22, createElementBlock as _createElementBlock22 } from "vue";
var bottom_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent22({
  name: "Bottom",
  __name: "bottom",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock22(), _createElementBlock22("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode22("path", {
        fill: "currentColor",
        d: "M544 805.888V168a32 32 0 1 0-64 0v637.888L246.656 557.952a30.72 30.72 0 0 0-45.312 0 35.52 35.52 0 0 0 0 48.064l288 306.048a30.72 30.72 0 0 0 45.312 0l288-306.048a35.52 35.52 0 0 0 0-48 30.72 30.72 0 0 0-45.312 0L544 805.824z"
      })
    ]));
  }
});

// src/components/bottom.vue
var bottom_default = bottom_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/bowl.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent23 } from "vue";
import { createElementVNode as _createElementVNode23, openBlock as _openBlock23, createElementBlock as _createElementBlock23 } from "vue";
var bowl_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent23({
  name: "Bowl",
  __name: "bowl",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock23(), _createElementBlock23("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode23("path", {
        fill: "currentColor",
        d: "M714.432 704a351.744 351.744 0 0 0 148.16-256H161.408a351.744 351.744 0 0 0 148.16 256zM288 766.592A415.68 415.68 0 0 1 96 416a32 32 0 0 1 32-32h768a32 32 0 0 1 32 32 415.68 415.68 0 0 1-192 350.592V832a64 64 0 0 1-64 64H352a64 64 0 0 1-64-64zM493.248 320h-90.496l254.4-254.4a32 32 0 1 1 45.248 45.248zm187.328 0h-128l269.696-155.712a32 32 0 0 1 32 55.424zM352 768v64h320v-64z"
      })
    ]));
  }
});

// src/components/bowl.vue
var bowl_default = bowl_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/box.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent24 } from "vue";
import { createElementVNode as _createElementVNode24, openBlock as _openBlock24, createElementBlock as _createElementBlock24 } from "vue";
var box_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent24({
  name: "Box",
  __name: "box",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock24(), _createElementBlock24("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode24("path", {
        fill: "currentColor",
        d: "M317.056 128 128 344.064V896h768V344.064L706.944 128zm-14.528-64h418.944a32 32 0 0 1 24.064 10.88l206.528 236.096A32 32 0 0 1 960 332.032V928a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V332.032a32 32 0 0 1 7.936-21.12L278.4 75.008A32 32 0 0 1 302.528 64z"
      }),
      _createElementVNode24("path", {
        fill: "currentColor",
        d: "M64 320h896v64H64z"
      }),
      _createElementVNode24("path", {
        fill: "currentColor",
        d: "M448 327.872V640h128V327.872L526.08 128h-28.16zM448 64h128l64 256v352a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V320z"
      })
    ]));
  }
});

// src/components/box.vue
var box_default = box_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/briefcase.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent25 } from "vue";
import { createElementVNode as _createElementVNode25, openBlock as _openBlock25, createElementBlock as _createElementBlock25 } from "vue";
var briefcase_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent25({
  name: "Briefcase",
  __name: "briefcase",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock25(), _createElementBlock25("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode25("path", {
        fill: "currentColor",
        d: "M320 320V128h384v192h192v192H128V320zM128 576h768v320H128zm256-256h256.064V192H384z"
      })
    ]));
  }
});

// src/components/briefcase.vue
var briefcase_default = briefcase_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/brush-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent26 } from "vue";
import { createElementVNode as _createElementVNode26, openBlock as _openBlock26, createElementBlock as _createElementBlock26 } from "vue";
var brush_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent26({
  name: "BrushFilled",
  __name: "brush-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock26(), _createElementBlock26("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode26("path", {
        fill: "currentColor",
        d: "M608 704v160a96 96 0 0 1-192 0V704h-96a128 128 0 0 1-128-128h640a128 128 0 0 1-128 128zM192 512V128.064h640V512z"
      })
    ]));
  }
});

// src/components/brush-filled.vue
var brush_filled_default = brush_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/brush.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent27 } from "vue";
import { createElementVNode as _createElementVNode27, openBlock as _openBlock27, createElementBlock as _createElementBlock27 } from "vue";
var brush_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent27({
  name: "Brush",
  __name: "brush",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock27(), _createElementBlock27("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode27("path", {
        fill: "currentColor",
        d: "M896 448H128v192a64 64 0 0 0 64 64h192v192h256V704h192a64 64 0 0 0 64-64zm-770.752-64c0-47.552 5.248-90.24 15.552-128 14.72-54.016 42.496-107.392 83.2-160h417.28l-15.36 70.336L736 96h211.2c-24.832 42.88-41.92 96.256-51.2 160a663.872 663.872 0 0 0-6.144 128H960v256a128 128 0 0 1-128 128H704v160a32 32 0 0 1-32 32H352a32 32 0 0 1-32-32V768H192A128 128 0 0 1 64 640V384h61.248zm64 0h636.544c-2.048-45.824.256-91.584 6.848-137.216 4.48-30.848 10.688-59.776 18.688-86.784h-96.64l-221.12 141.248L561.92 160H256.512c-25.856 37.888-43.776 75.456-53.952 112.832-8.768 32.064-13.248 69.12-13.312 111.168z"
      })
    ]));
  }
});

// src/components/brush.vue
var brush_default = brush_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/burger.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent28 } from "vue";
import { createElementVNode as _createElementVNode28, openBlock as _openBlock28, createElementBlock as _createElementBlock28 } from "vue";
var burger_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent28({
  name: "Burger",
  __name: "burger",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock28(), _createElementBlock28("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode28("path", {
        fill: "currentColor",
        d: "M160 512a32 32 0 0 0-32 32v64a32 32 0 0 0 30.08 32H864a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zm736-58.56A96 96 0 0 1 960 544v64a96 96 0 0 1-51.968 85.312L855.36 833.6a96 96 0 0 1-89.856 62.272H258.496A96 96 0 0 1 168.64 833.6l-52.608-140.224A96 96 0 0 1 64 608v-64a96 96 0 0 1 64-90.56V448a384 384 0 1 1 768 5.44M832 448a320 320 0 0 0-640 0zM512 704H188.352l40.192 107.136a32 32 0 0 0 29.952 20.736h507.008a32 32 0 0 0 29.952-20.736L835.648 704z"
      })
    ]));
  }
});

// src/components/burger.vue
var burger_default = burger_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/calendar.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent29 } from "vue";
import { createElementVNode as _createElementVNode29, openBlock as _openBlock29, createElementBlock as _createElementBlock29 } from "vue";
var calendar_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent29({
  name: "Calendar",
  __name: "calendar",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock29(), _createElementBlock29("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode29("path", {
        fill: "currentColor",
        d: "M128 384v512h768V192H768v32a32 32 0 1 1-64 0v-32H320v32a32 32 0 0 1-64 0v-32H128v128h768v64zm192-256h384V96a32 32 0 1 1 64 0v32h160a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h160V96a32 32 0 0 1 64 0zm-32 384h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64"
      })
    ]));
  }
});

// src/components/calendar.vue
var calendar_default = calendar_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/camera-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent30 } from "vue";
import { createElementVNode as _createElementVNode30, openBlock as _openBlock30, createElementBlock as _createElementBlock30 } from "vue";
var camera_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent30({
  name: "CameraFilled",
  __name: "camera-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock30(), _createElementBlock30("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode30("path", {
        fill: "currentColor",
        d: "M160 224a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h704a64 64 0 0 0 64-64V288a64 64 0 0 0-64-64H748.416l-46.464-92.672A64 64 0 0 0 644.736 96H379.328a64 64 0 0 0-57.216 35.392L275.776 224zm352 435.2a115.2 115.2 0 1 0 0-230.4 115.2 115.2 0 0 0 0 230.4m0 140.8a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
      })
    ]));
  }
});

// src/components/camera-filled.vue
var camera_filled_default = camera_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/camera.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent31 } from "vue";
import { createElementVNode as _createElementVNode31, openBlock as _openBlock31, createElementBlock as _createElementBlock31 } from "vue";
var camera_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent31({
  name: "Camera",
  __name: "camera",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock31(), _createElementBlock31("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode31("path", {
        fill: "currentColor",
        d: "M896 256H128v576h768zm-199.424-64-32.064-64h-304.96l-32 64zM96 192h160l46.336-92.608A64 64 0 0 1 359.552 64h304.96a64 64 0 0 1 57.216 35.328L768.192 192H928a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32m416 512a160 160 0 1 0 0-320 160 160 0 0 0 0 320m0 64a224 224 0 1 1 0-448 224 224 0 0 1 0 448"
      })
    ]));
  }
});

// src/components/camera.vue
var camera_default = camera_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/caret-bottom.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent32 } from "vue";
import { createElementVNode as _createElementVNode32, openBlock as _openBlock32, createElementBlock as _createElementBlock32 } from "vue";
var caret_bottom_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent32({
  name: "CaretBottom",
  __name: "caret-bottom",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock32(), _createElementBlock32("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode32("path", {
        fill: "currentColor",
        d: "m192 384 320 384 320-384z"
      })
    ]));
  }
});

// src/components/caret-bottom.vue
var caret_bottom_default = caret_bottom_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/caret-left.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent33 } from "vue";
import { createElementVNode as _createElementVNode33, openBlock as _openBlock33, createElementBlock as _createElementBlock33 } from "vue";
var caret_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent33({
  name: "CaretLeft",
  __name: "caret-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock33(), _createElementBlock33("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode33("path", {
        fill: "currentColor",
        d: "M672 192 288 511.936 672 832z"
      })
    ]));
  }
});

// src/components/caret-left.vue
var caret_left_default = caret_left_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/caret-right.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent34 } from "vue";
import { createElementVNode as _createElementVNode34, openBlock as _openBlock34, createElementBlock as _createElementBlock34 } from "vue";
var caret_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent34({
  name: "CaretRight",
  __name: "caret-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock34(), _createElementBlock34("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode34("path", {
        fill: "currentColor",
        d: "M384 192v640l384-320.064z"
      })
    ]));
  }
});

// src/components/caret-right.vue
var caret_right_default = caret_right_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/caret-top.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent35 } from "vue";
import { createElementVNode as _createElementVNode35, openBlock as _openBlock35, createElementBlock as _createElementBlock35 } from "vue";
var caret_top_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent35({
  name: "CaretTop",
  __name: "caret-top",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock35(), _createElementBlock35("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode35("path", {
        fill: "currentColor",
        d: "M512 320 192 704h639.936z"
      })
    ]));
  }
});

// src/components/caret-top.vue
var caret_top_default = caret_top_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/cellphone.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent36 } from "vue";
import { createElementVNode as _createElementVNode36, openBlock as _openBlock36, createElementBlock as _createElementBlock36 } from "vue";
var cellphone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent36({
  name: "Cellphone",
  __name: "cellphone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock36(), _createElementBlock36("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode36("path", {
        fill: "currentColor",
        d: "M256 128a64 64 0 0 0-64 64v640a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h512a128 128 0 0 1 128 128v640a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V192A128 128 0 0 1 256 64m128 128h256a32 32 0 1 1 0 64H384a32 32 0 0 1 0-64m128 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
      })
    ]));
  }
});

// src/components/cellphone.vue
var cellphone_default = cellphone_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chat-dot-round.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent37 } from "vue";
import { createElementVNode as _createElementVNode37, openBlock as _openBlock37, createElementBlock as _createElementBlock37 } from "vue";
var chat_dot_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent37({
  name: "ChatDotRound",
  __name: "chat-dot-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock37(), _createElementBlock37("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode37("path", {
        fill: "currentColor",
        d: "m174.72 855.68 135.296-45.12 23.68 11.84C388.096 849.536 448.576 864 512 864c211.84 0 384-166.784 384-352S723.84 160 512 160 128 326.784 128 512c0 69.12 24.96 139.264 70.848 199.232l22.08 28.8-46.272 115.584zm-45.248 82.56A32 32 0 0 1 89.6 896l58.368-145.92C94.72 680.32 64 596.864 64 512 64 299.904 256 96 512 96s448 203.904 448 416-192 416-448 416a461.056 461.056 0 0 1-206.912-48.384l-175.616 58.56z"
      }),
      _createElementVNode37("path", {
        fill: "currentColor",
        d: "M512 563.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4"
      })
    ]));
  }
});

// src/components/chat-dot-round.vue
var chat_dot_round_default = chat_dot_round_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chat-dot-square.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent38 } from "vue";
import { createElementVNode as _createElementVNode38, openBlock as _openBlock38, createElementBlock as _createElementBlock38 } from "vue";
var chat_dot_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent38({
  name: "ChatDotSquare",
  __name: "chat-dot-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock38(), _createElementBlock38("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode38("path", {
        fill: "currentColor",
        d: "M273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.88zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
      }),
      _createElementVNode38("path", {
        fill: "currentColor",
        d: "M512 499.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4zm192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4zm-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4z"
      })
    ]));
  }
});

// src/components/chat-dot-square.vue
var chat_dot_square_default = chat_dot_square_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chat-line-round.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent39 } from "vue";
import { createElementVNode as _createElementVNode39, openBlock as _openBlock39, createElementBlock as _createElementBlock39 } from "vue";
var chat_line_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent39({
  name: "ChatLineRound",
  __name: "chat-line-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock39(), _createElementBlock39("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode39("path", {
        fill: "currentColor",
        d: "m174.72 855.68 135.296-45.12 23.68 11.84C388.096 849.536 448.576 864 512 864c211.84 0 384-166.784 384-352S723.84 160 512 160 128 326.784 128 512c0 69.12 24.96 139.264 70.848 199.232l22.08 28.8-46.272 115.584zm-45.248 82.56A32 32 0 0 1 89.6 896l58.368-145.92C94.72 680.32 64 596.864 64 512 64 299.904 256 96 512 96s448 203.904 448 416-192 416-448 416a461.056 461.056 0 0 1-206.912-48.384l-175.616 58.56z"
      }),
      _createElementVNode39("path", {
        fill: "currentColor",
        d: "M352 576h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m32-192h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/chat-line-round.vue
var chat_line_round_default = chat_line_round_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chat-line-square.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent40 } from "vue";
import { createElementVNode as _createElementVNode40, openBlock as _openBlock40, createElementBlock as _createElementBlock40 } from "vue";
var chat_line_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent40({
  name: "ChatLineSquare",
  __name: "chat-line-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock40(), _createElementBlock40("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode40("path", {
        fill: "currentColor",
        d: "M160 826.88 273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
      }),
      _createElementVNode40("path", {
        fill: "currentColor",
        d: "M352 512h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m0-192h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/chat-line-square.vue
var chat_line_square_default = chat_line_square_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chat-round.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent41 } from "vue";
import { createElementVNode as _createElementVNode41, openBlock as _openBlock41, createElementBlock as _createElementBlock41 } from "vue";
var chat_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent41({
  name: "ChatRound",
  __name: "chat-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock41(), _createElementBlock41("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode41("path", {
        fill: "currentColor",
        d: "m174.72 855.68 130.048-43.392 23.424 11.392C382.4 849.984 444.352 864 512 864c223.744 0 384-159.872 384-352 0-192.832-159.104-352-384-352S128 319.168 128 512a341.12 341.12 0 0 0 69.248 204.288l21.632 28.8-44.16 110.528zm-45.248 82.56A32 32 0 0 1 89.6 896l56.512-141.248A405.12 405.12 0 0 1 64 512C64 299.904 235.648 96 512 96s448 203.904 448 416-173.44 416-448 416c-79.68 0-150.848-17.152-211.712-46.72l-170.88 56.96z"
      })
    ]));
  }
});

// src/components/chat-round.vue
var chat_round_default = chat_round_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chat-square.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent42 } from "vue";
import { createElementVNode as _createElementVNode42, openBlock as _openBlock42, createElementBlock as _createElementBlock42 } from "vue";
var chat_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent42({
  name: "ChatSquare",
  __name: "chat-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock42(), _createElementBlock42("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode42("path", {
        fill: "currentColor",
        d: "M273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.88zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
      })
    ]));
  }
});

// src/components/chat-square.vue
var chat_square_default = chat_square_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/check.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent43 } from "vue";
import { createElementVNode as _createElementVNode43, openBlock as _openBlock43, createElementBlock as _createElementBlock43 } from "vue";
var check_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent43({
  name: "Check",
  __name: "check",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock43(), _createElementBlock43("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode43("path", {
        fill: "currentColor",
        d: "M406.656 706.944 195.84 496.256a32 32 0 1 0-45.248 45.248l256 256 512-512a32 32 0 0 0-45.248-45.248L406.592 706.944z"
      })
    ]));
  }
});

// src/components/check.vue
var check_default = check_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/checked.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent44 } from "vue";
import { createElementVNode as _createElementVNode44, openBlock as _openBlock44, createElementBlock as _createElementBlock44 } from "vue";
var checked_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent44({
  name: "Checked",
  __name: "checked",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock44(), _createElementBlock44("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode44("path", {
        fill: "currentColor",
        d: "M704 192h160v736H160V192h160.064v64H704zM311.616 537.28l-45.312 45.248L447.36 763.52l316.8-316.8-45.312-45.184L447.36 673.024zM384 192V96h256v96z"
      })
    ]));
  }
});

// src/components/checked.vue
var checked_default = checked_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/cherry.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent45 } from "vue";
import { createElementVNode as _createElementVNode45, openBlock as _openBlock45, createElementBlock as _createElementBlock45 } from "vue";
var cherry_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent45({
  name: "Cherry",
  __name: "cherry",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock45(), _createElementBlock45("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode45("path", {
        fill: "currentColor",
        d: "M261.056 449.6c13.824-69.696 34.88-128.96 63.36-177.728 23.744-40.832 61.12-88.64 112.256-143.872H320a32 32 0 0 1 0-64h384a32 32 0 1 1 0 64H554.752c14.912 39.168 41.344 86.592 79.552 141.76 47.36 68.48 84.8 106.752 106.304 114.304a224 224 0 1 1-84.992 14.784c-22.656-22.912-47.04-53.76-73.92-92.608-38.848-56.128-67.008-105.792-84.352-149.312-55.296 58.24-94.528 107.52-117.76 147.2-23.168 39.744-41.088 88.768-53.568 147.072a224.064 224.064 0 1 1-64.96-1.6zM288 832a160 160 0 1 0 0-320 160 160 0 0 0 0 320m448-64a160 160 0 1 0 0-320 160 160 0 0 0 0 320"
      })
    ]));
  }
});

// src/components/cherry.vue
var cherry_default = cherry_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chicken.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent46 } from "vue";
import { createElementVNode as _createElementVNode46, openBlock as _openBlock46, createElementBlock as _createElementBlock46 } from "vue";
var chicken_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent46({
  name: "Chicken",
  __name: "chicken",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock46(), _createElementBlock46("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode46("path", {
        fill: "currentColor",
        d: "M349.952 716.992 478.72 588.16a106.688 106.688 0 0 1-26.176-19.072 106.688 106.688 0 0 1-19.072-26.176L304.704 671.744c.768 3.072 1.472 6.144 2.048 9.216l2.048 31.936 31.872 1.984c3.136.64 6.208 1.28 9.28 2.112zm57.344 33.152a128 128 0 1 1-216.32 114.432l-1.92-32-32-1.92a128 128 0 1 1 114.432-216.32L416.64 469.248c-2.432-101.44 58.112-239.104 149.056-330.048 107.328-107.328 231.296-85.504 316.8 0 85.44 85.44 107.328 209.408 0 316.8-91.008 90.88-228.672 151.424-330.112 149.056L407.296 750.08zm90.496-226.304c49.536 49.536 233.344-7.04 339.392-113.088 78.208-78.208 63.232-163.072 0-226.304-63.168-63.232-148.032-78.208-226.24 0C504.896 290.496 448.32 474.368 497.792 523.84M244.864 708.928a64 64 0 1 0-59.84 59.84l56.32-3.52zm8.064 127.68a64 64 0 1 0 59.84-59.84l-56.32 3.52-3.52 56.32z"
      })
    ]));
  }
});

// src/components/chicken.vue
var chicken_default = chicken_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/chrome-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent47 } from "vue";
import { createElementVNode as _createElementVNode47, openBlock as _openBlock47, createElementBlock as _createElementBlock47 } from "vue";
var chrome_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent47({
  name: "ChromeFilled",
  __name: "chrome-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock47(), _createElementBlock47("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode47("path", {
        fill: "currentColor",
        d: "M938.67 512.01c0-44.59-6.82-87.6-19.54-128H682.67a212.372 212.372 0 0 1 42.67 128c.06 38.71-10.45 76.7-30.42 109.87l-182.91 316.8c235.65-.01 426.66-191.02 426.66-426.67z"
      }),
      _createElementVNode47("path", {
        fill: "currentColor",
        d: "M576.79 401.63a127.92 127.92 0 0 0-63.56-17.6c-22.36-.22-44.39 5.43-63.89 16.38s-35.79 26.82-47.25 46.02a128.005 128.005 0 0 0-2.16 127.44l1.24 2.13a127.906 127.906 0 0 0 46.36 46.61 127.907 127.907 0 0 0 63.38 17.44c22.29.2 44.24-5.43 63.68-16.33a127.94 127.94 0 0 0 47.16-45.79v-.01l1.11-1.92a127.984 127.984 0 0 0 .29-127.46 127.957 127.957 0 0 0-46.36-46.91"
      }),
      _createElementVNode47("path", {
        fill: "currentColor",
        d: "M394.45 333.96A213.336 213.336 0 0 1 512 298.67h369.58A426.503 426.503 0 0 0 512 85.34a425.598 425.598 0 0 0-171.74 35.98 425.644 425.644 0 0 0-142.62 102.22l118.14 204.63a213.397 213.397 0 0 1 78.67-94.21m117.56 604.72H512zm-97.25-236.73a213.284 213.284 0 0 1-89.54-86.81L142.48 298.6c-36.35 62.81-57.13 135.68-57.13 213.42 0 203.81 142.93 374.22 333.95 416.55h.04l118.19-204.71a213.315 213.315 0 0 1-122.77-21.91z"
      })
    ]));
  }
});

// src/components/chrome-filled.vue
var chrome_filled_default = chrome_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/circle-check-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent48 } from "vue";
import { createElementVNode as _createElementVNode48, openBlock as _openBlock48, createElementBlock as _createElementBlock48 } from "vue";
var circle_check_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent48({
  name: "CircleCheckFilled",
  __name: "circle-check-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock48(), _createElementBlock48("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode48("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
      })
    ]));
  }
});

// src/components/circle-check-filled.vue
var circle_check_filled_default = circle_check_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/circle-check.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent49 } from "vue";
import { createElementVNode as _createElementVNode49, openBlock as _openBlock49, createElementBlock as _createElementBlock49 } from "vue";
var circle_check_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent49({
  name: "CircleCheck",
  __name: "circle-check",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock49(), _createElementBlock49("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode49("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode49("path", {
        fill: "currentColor",
        d: "M745.344 361.344a32 32 0 0 1 45.312 45.312l-288 288a32 32 0 0 1-45.312 0l-160-160a32 32 0 1 1 45.312-45.312L480 626.752l265.344-265.408z"
      })
    ]));
  }
});

// src/components/circle-check.vue
var circle_check_default = circle_check_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/circle-close-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent50 } from "vue";
import { createElementVNode as _createElementVNode50, openBlock as _openBlock50, createElementBlock as _createElementBlock50 } from "vue";
var circle_close_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent50({
  name: "CircleCloseFilled",
  __name: "circle-close-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock50(), _createElementBlock50("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode50("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336z"
      })
    ]));
  }
});

// src/components/circle-close-filled.vue
var circle_close_filled_default = circle_close_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/circle-close.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent51 } from "vue";
import { createElementVNode as _createElementVNode51, openBlock as _openBlock51, createElementBlock as _createElementBlock51 } from "vue";
var circle_close_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent51({
  name: "CircleClose",
  __name: "circle-close",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock51(), _createElementBlock51("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode51("path", {
        fill: "currentColor",
        d: "m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"
      }),
      _createElementVNode51("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});

// src/components/circle-close.vue
var circle_close_default = circle_close_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/circle-plus-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent52 } from "vue";
import { createElementVNode as _createElementVNode52, openBlock as _openBlock52, createElementBlock as _createElementBlock52 } from "vue";
var circle_plus_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent52({
  name: "CirclePlusFilled",
  __name: "circle-plus-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock52(), _createElementBlock52("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode52("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-38.4 409.6H326.4a38.4 38.4 0 1 0 0 76.8h147.2v147.2a38.4 38.4 0 0 0 76.8 0V550.4h147.2a38.4 38.4 0 0 0 0-76.8H550.4V326.4a38.4 38.4 0 1 0-76.8 0v147.2z"
      })
    ]));
  }
});

// src/components/circle-plus-filled.vue
var circle_plus_filled_default = circle_plus_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/circle-plus.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent53 } from "vue";
import { createElementVNode as _createElementVNode53, openBlock as _openBlock53, createElementBlock as _createElementBlock53 } from "vue";
var circle_plus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent53({
  name: "CirclePlus",
  __name: "circle-plus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock53(), _createElementBlock53("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode53("path", {
        fill: "currentColor",
        d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
      }),
      _createElementVNode53("path", {
        fill: "currentColor",
        d: "M480 672V352a32 32 0 1 1 64 0v320a32 32 0 0 1-64 0"
      }),
      _createElementVNode53("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});

// src/components/circle-plus.vue
var circle_plus_default = circle_plus_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/clock.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent54 } from "vue";
import { createElementVNode as _createElementVNode54, openBlock as _openBlock54, createElementBlock as _createElementBlock54 } from "vue";
var clock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent54({
  name: "Clock",
  __name: "clock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock54(), _createElementBlock54("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode54("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode54("path", {
        fill: "currentColor",
        d: "M480 256a32 32 0 0 1 32 32v256a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
      }),
      _createElementVNode54("path", {
        fill: "currentColor",
        d: "M480 512h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/clock.vue
var clock_default = clock_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/close-bold.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent55 } from "vue";
import { createElementVNode as _createElementVNode55, openBlock as _openBlock55, createElementBlock as _createElementBlock55 } from "vue";
var close_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent55({
  name: "CloseBold",
  __name: "close-bold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock55(), _createElementBlock55("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode55("path", {
        fill: "currentColor",
        d: "M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
      })
    ]));
  }
});

// src/components/close-bold.vue
var close_bold_default = close_bold_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/close.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent56 } from "vue";
import { createElementVNode as _createElementVNode56, openBlock as _openBlock56, createElementBlock as _createElementBlock56 } from "vue";
var close_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent56({
  name: "Close",
  __name: "close",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock56(), _createElementBlock56("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode56("path", {
        fill: "currentColor",
        d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
      })
    ]));
  }
});

// src/components/close.vue
var close_default = close_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/cloudy.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent57 } from "vue";
import { createElementVNode as _createElementVNode57, openBlock as _openBlock57, createElementBlock as _createElementBlock57 } from "vue";
var cloudy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent57({
  name: "Cloudy",
  __name: "cloudy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock57(), _createElementBlock57("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode57("path", {
        fill: "currentColor",
        d: "M598.4 831.872H328.192a256 256 0 0 1-34.496-510.528A352 352 0 1 1 598.4 831.872m-271.36-64h272.256a288 288 0 1 0-248.512-417.664L335.04 381.44l-34.816 3.584a192 192 0 0 0 26.88 382.848z"
      })
    ]));
  }
});

// src/components/cloudy.vue
var cloudy_default = cloudy_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/coffee-cup.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent58 } from "vue";
import { createElementVNode as _createElementVNode58, openBlock as _openBlock58, createElementBlock as _createElementBlock58 } from "vue";
var coffee_cup_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent58({
  name: "CoffeeCup",
  __name: "coffee-cup",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock58(), _createElementBlock58("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode58("path", {
        fill: "currentColor",
        d: "M768 192a192 192 0 1 1-8 383.808A256.128 256.128 0 0 1 512 768H320A256 256 0 0 1 64 512V160a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v256a128 128 0 1 0 0-256M96 832h640a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-640v320a192 192 0 0 0 192 192h192a192 192 0 0 0 192-192V192z"
      })
    ]));
  }
});

// src/components/coffee-cup.vue
var coffee_cup_default = coffee_cup_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/coffee.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent59 } from "vue";
import { createElementVNode as _createElementVNode59, openBlock as _openBlock59, createElementBlock as _createElementBlock59 } from "vue";
var coffee_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent59({
  name: "Coffee",
  __name: "coffee",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock59(), _createElementBlock59("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode59("path", {
        fill: "currentColor",
        d: "M822.592 192h14.272a32 32 0 0 1 31.616 26.752l21.312 128A32 32 0 0 1 858.24 384h-49.344l-39.04 546.304A32 32 0 0 1 737.92 960H285.824a32 32 0 0 1-32-29.696L214.912 384H165.76a32 32 0 0 1-31.552-37.248l21.312-128A32 32 0 0 1 187.136 192h14.016l-6.72-93.696A32 32 0 0 1 226.368 64h571.008a32 32 0 0 1 31.936 34.304zm-64.128 0 4.544-64H260.736l4.544 64h493.184m-548.16 128H820.48l-10.688-64H214.208l-10.688 64h6.784m68.736 64 36.544 512H708.16l36.544-512z"
      })
    ]));
  }
});

// src/components/coffee.vue
var coffee_default = coffee_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/coin.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent60 } from "vue";
import { createElementVNode as _createElementVNode60, openBlock as _openBlock60, createElementBlock as _createElementBlock60 } from "vue";
var coin_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent60({
  name: "Coin",
  __name: "coin",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock60(), _createElementBlock60("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode60("path", {
        fill: "currentColor",
        d: "m161.92 580.736 29.888 58.88C171.328 659.776 160 681.728 160 704c0 82.304 155.328 160 352 160s352-77.696 352-160c0-22.272-11.392-44.16-31.808-64.32l30.464-58.432C903.936 615.808 928 657.664 928 704c0 129.728-188.544 224-416 224S96 833.728 96 704c0-46.592 24.32-88.576 65.92-123.264z"
      }),
      _createElementVNode60("path", {
        fill: "currentColor",
        d: "m161.92 388.736 29.888 58.88C171.328 467.84 160 489.792 160 512c0 82.304 155.328 160 352 160s352-77.696 352-160c0-22.272-11.392-44.16-31.808-64.32l30.464-58.432C903.936 423.808 928 465.664 928 512c0 129.728-188.544 224-416 224S96 641.728 96 512c0-46.592 24.32-88.576 65.92-123.264z"
      }),
      _createElementVNode60("path", {
        fill: "currentColor",
        d: "M512 544c-227.456 0-416-94.272-416-224S284.544 96 512 96s416 94.272 416 224-188.544 224-416 224m0-64c196.672 0 352-77.696 352-160S708.672 160 512 160s-352 77.696-352 160 155.328 160 352 160"
      })
    ]));
  }
});

// src/components/coin.vue
var coin_default = coin_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/cold-drink.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent61 } from "vue";
import { createElementVNode as _createElementVNode61, openBlock as _openBlock61, createElementBlock as _createElementBlock61 } from "vue";
var cold_drink_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent61({
  name: "ColdDrink",
  __name: "cold-drink",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock61(), _createElementBlock61("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode61("path", {
        fill: "currentColor",
        d: "M768 64a192 192 0 1 1-69.952 370.88L480 725.376V896h96a32 32 0 1 1 0 64H320a32 32 0 1 1 0-64h96V725.376L76.8 273.536a64 64 0 0 1-12.8-38.4v-10.688a32 32 0 0 1 32-32h71.808l-65.536-83.84a32 32 0 0 1 50.432-39.424l96.256 123.264h337.728A192.064 192.064 0 0 1 768 64M656.896 192.448H800a32 32 0 0 1 32 32v10.624a64 64 0 0 1-12.8 38.4l-80.448 107.2a128 128 0 1 0-81.92-188.16v-.064zm-357.888 64 129.472 165.76a32 32 0 0 1-50.432 39.36l-160.256-205.12H144l304 404.928 304-404.928z"
      })
    ]));
  }
});

// src/components/cold-drink.vue
var cold_drink_default = cold_drink_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/collection-tag.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent62 } from "vue";
import { createElementVNode as _createElementVNode62, openBlock as _openBlock62, createElementBlock as _createElementBlock62 } from "vue";
var collection_tag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent62({
  name: "CollectionTag",
  __name: "collection-tag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock62(), _createElementBlock62("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode62("path", {
        fill: "currentColor",
        d: "M256 128v698.88l196.032-156.864a96 96 0 0 1 119.936 0L768 826.816V128zm-32-64h576a32 32 0 0 1 32 32v797.44a32 32 0 0 1-51.968 24.96L531.968 720a32 32 0 0 0-39.936 0L243.968 918.4A32 32 0 0 1 192 893.44V96a32 32 0 0 1 32-32"
      })
    ]));
  }
});

// src/components/collection-tag.vue
var collection_tag_default = collection_tag_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/collection.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent63 } from "vue";
import { createElementVNode as _createElementVNode63, openBlock as _openBlock63, createElementBlock as _createElementBlock63 } from "vue";
var collection_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent63({
  name: "Collection",
  __name: "collection",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock63(), _createElementBlock63("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode63("path", {
        fill: "currentColor",
        d: "M192 736h640V128H256a64 64 0 0 0-64 64zm64-672h608a32 32 0 0 1 32 32v672a32 32 0 0 1-32 32H160l-32 57.536V192A128 128 0 0 1 256 64"
      }),
      _createElementVNode63("path", {
        fill: "currentColor",
        d: "M240 800a48 48 0 1 0 0 96h592v-96zm0-64h656v160a64 64 0 0 1-64 64H240a112 112 0 0 1 0-224m144-608v250.88l96-76.8 96 76.8V128zm-64-64h320v381.44a32 32 0 0 1-51.968 24.96L480 384l-108.032 86.4A32 32 0 0 1 320 445.44z"
      })
    ]));
  }
});

// src/components/collection.vue
var collection_default = collection_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/comment.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent64 } from "vue";
import { createElementVNode as _createElementVNode64, openBlock as _openBlock64, createElementBlock as _createElementBlock64 } from "vue";
var comment_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent64({
  name: "Comment",
  __name: "comment",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock64(), _createElementBlock64("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode64("path", {
        fill: "currentColor",
        d: "M736 504a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112M128 128v640h192v160l224-160h352V128z"
      })
    ]));
  }
});

// src/components/comment.vue
var comment_default = comment_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/compass.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent65 } from "vue";
import { createElementVNode as _createElementVNode65, openBlock as _openBlock65, createElementBlock as _createElementBlock65 } from "vue";
var compass_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent65({
  name: "Compass",
  __name: "compass",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock65(), _createElementBlock65("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode65("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode65("path", {
        fill: "currentColor",
        d: "M725.888 315.008C676.48 428.672 624 513.28 568.576 568.64c-55.424 55.424-139.968 107.904-253.568 157.312a12.8 12.8 0 0 1-16.896-16.832c49.536-113.728 102.016-198.272 157.312-253.632 55.36-55.296 139.904-107.776 253.632-157.312a12.8 12.8 0 0 1 16.832 16.832"
      })
    ]));
  }
});

// src/components/compass.vue
var compass_default = compass_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/connection.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent66 } from "vue";
import { createElementVNode as _createElementVNode66, openBlock as _openBlock66, createElementBlock as _createElementBlock66 } from "vue";
var connection_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent66({
  name: "Connection",
  __name: "connection",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock66(), _createElementBlock66("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode66("path", {
        fill: "currentColor",
        d: "M640 384v64H448a128 128 0 0 0-128 128v128a128 128 0 0 0 128 128h320a128 128 0 0 0 128-128V576a128 128 0 0 0-64-110.848V394.88c74.56 26.368 128 97.472 128 181.056v128a192 192 0 0 1-192 192H448a192 192 0 0 1-192-192V576a192 192 0 0 1 192-192z"
      }),
      _createElementVNode66("path", {
        fill: "currentColor",
        d: "M384 640v-64h192a128 128 0 0 0 128-128V320a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v128a128 128 0 0 0 64 110.848v70.272A192.064 192.064 0 0 1 64 448V320a192 192 0 0 1 192-192h320a192 192 0 0 1 192 192v128a192 192 0 0 1-192 192z"
      })
    ]));
  }
});

// src/components/connection.vue
var connection_default = connection_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/coordinate.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent67 } from "vue";
import { createElementVNode as _createElementVNode67, openBlock as _openBlock67, createElementBlock as _createElementBlock67 } from "vue";
var coordinate_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent67({
  name: "Coordinate",
  __name: "coordinate",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock67(), _createElementBlock67("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode67("path", {
        fill: "currentColor",
        d: "M480 512h64v320h-64z"
      }),
      _createElementVNode67("path", {
        fill: "currentColor",
        d: "M192 896h640a64 64 0 0 0-64-64H256a64 64 0 0 0-64 64m64-128h512a128 128 0 0 1 128 128v64H128v-64a128 128 0 0 1 128-128m256-256a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
      })
    ]));
  }
});

// src/components/coordinate.vue
var coordinate_default = coordinate_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/copy-document.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent68 } from "vue";
import { createElementVNode as _createElementVNode68, openBlock as _openBlock68, createElementBlock as _createElementBlock68 } from "vue";
var copy_document_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent68({
  name: "CopyDocument",
  __name: "copy-document",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock68(), _createElementBlock68("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode68("path", {
        fill: "currentColor",
        d: "M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64z"
      }),
      _createElementVNode68("path", {
        fill: "currentColor",
        d: "M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64"
      })
    ]));
  }
});

// src/components/copy-document.vue
var copy_document_default = copy_document_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/cpu.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent69 } from "vue";
import { createElementVNode as _createElementVNode69, openBlock as _openBlock69, createElementBlock as _createElementBlock69 } from "vue";
var cpu_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent69({
  name: "Cpu",
  __name: "cpu",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock69(), _createElementBlock69("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode69("path", {
        fill: "currentColor",
        d: "M320 256a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h384a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128H320a128 128 0 0 1-128-128V320a128 128 0 0 1 128-128"
      }),
      _createElementVNode69("path", {
        fill: "currentColor",
        d: "M512 64a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m-320 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 896a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m160 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m-320 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32M64 512a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0-160a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0 320a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m896-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0 320a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32"
      })
    ]));
  }
});

// src/components/cpu.vue
var cpu_default = cpu_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/credit-card.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent70 } from "vue";
import { createElementVNode as _createElementVNode70, openBlock as _openBlock70, createElementBlock as _createElementBlock70 } from "vue";
var credit_card_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent70({
  name: "CreditCard",
  __name: "credit-card",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock70(), _createElementBlock70("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode70("path", {
        fill: "currentColor",
        d: "M896 324.096c0-42.368-2.496-55.296-9.536-68.48a52.352 52.352 0 0 0-22.144-22.08c-13.12-7.04-26.048-9.536-68.416-9.536H228.096c-42.368 0-55.296 2.496-68.48 9.536a52.352 52.352 0 0 0-22.08 22.144c-7.04 13.12-9.536 26.048-9.536 68.416v375.808c0 42.368 2.496 55.296 9.536 68.48a52.352 52.352 0 0 0 22.144 22.08c13.12 7.04 26.048 9.536 68.416 9.536h567.808c42.368 0 55.296-2.496 68.48-9.536a52.352 52.352 0 0 0 22.08-22.144c7.04-13.12 9.536-26.048 9.536-68.416zm64 0v375.808c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-11.136-20.864-17.088-41.6-17.088-98.56V324.032c0-57.088 5.952-77.76 17.088-98.56 11.136-20.928 27.52-37.312 48.384-48.448 20.864-11.136 41.6-17.088 98.56-17.088H795.84c57.088 0 77.76 5.952 98.56 17.088 20.928 11.136 37.312 27.52 48.448 48.384 11.136 20.864 17.088 41.6 17.088 98.56z"
      }),
      _createElementVNode70("path", {
        fill: "currentColor",
        d: "M64 320h896v64H64zm0 128h896v64H64zm128 192h256v64H192z"
      })
    ]));
  }
});

// src/components/credit-card.vue
var credit_card_default = credit_card_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/crop.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent71 } from "vue";
import { createElementVNode as _createElementVNode71, openBlock as _openBlock71, createElementBlock as _createElementBlock71 } from "vue";
var crop_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent71({
  name: "Crop",
  __name: "crop",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock71(), _createElementBlock71("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode71("path", {
        fill: "currentColor",
        d: "M256 768h672a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V96a32 32 0 0 1 64 0z"
      }),
      _createElementVNode71("path", {
        fill: "currentColor",
        d: "M832 224v704a32 32 0 1 1-64 0V256H96a32 32 0 0 1 0-64h704a32 32 0 0 1 32 32"
      })
    ]));
  }
});

// src/components/crop.vue
var crop_default = crop_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/d-arrow-left.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent72 } from "vue";
import { createElementVNode as _createElementVNode72, openBlock as _openBlock72, createElementBlock as _createElementBlock72 } from "vue";
var d_arrow_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent72({
  name: "DArrowLeft",
  __name: "d-arrow-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock72(), _createElementBlock72("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode72("path", {
        fill: "currentColor",
        d: "M529.408 149.376a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L259.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L197.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224zm256 0a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L515.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L453.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224z"
      })
    ]));
  }
});

// src/components/d-arrow-left.vue
var d_arrow_left_default = d_arrow_left_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/d-arrow-right.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent73 } from "vue";
import { createElementVNode as _createElementVNode73, openBlock as _openBlock73, createElementBlock as _createElementBlock73 } from "vue";
var d_arrow_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent73({
  name: "DArrowRight",
  __name: "d-arrow-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock73(), _createElementBlock73("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode73("path", {
        fill: "currentColor",
        d: "M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688m-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z"
      })
    ]));
  }
});

// src/components/d-arrow-right.vue
var d_arrow_right_default = d_arrow_right_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/d-caret.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent74 } from "vue";
import { createElementVNode as _createElementVNode74, openBlock as _openBlock74, createElementBlock as _createElementBlock74 } from "vue";
var d_caret_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent74({
  name: "DCaret",
  __name: "d-caret",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock74(), _createElementBlock74("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode74("path", {
        fill: "currentColor",
        d: "m512 128 288 320H224zM224 576h576L512 896z"
      })
    ]));
  }
});

// src/components/d-caret.vue
var d_caret_default = d_caret_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/data-analysis.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent75 } from "vue";
import { createElementVNode as _createElementVNode75, openBlock as _openBlock75, createElementBlock as _createElementBlock75 } from "vue";
var data_analysis_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent75({
  name: "DataAnalysis",
  __name: "data-analysis",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock75(), _createElementBlock75("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode75("path", {
        fill: "currentColor",
        d: "m665.216 768 110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32l110.848-192H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32zM832 192H192v512h640zM352 448a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0v-64a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v128a32 32 0 0 1-64 0V416a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V352a32 32 0 0 1 32-32"
      })
    ]));
  }
});

// src/components/data-analysis.vue
var data_analysis_default = data_analysis_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/data-board.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent76 } from "vue";
import { createElementVNode as _createElementVNode76, openBlock as _openBlock76, createElementBlock as _createElementBlock76 } from "vue";
var data_board_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent76({
  name: "DataBoard",
  __name: "data-board",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock76(), _createElementBlock76("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode76("path", {
        fill: "currentColor",
        d: "M32 128h960v64H32z"
      }),
      _createElementVNode76("path", {
        fill: "currentColor",
        d: "M192 192v512h640V192zm-64-64h768v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
      }),
      _createElementVNode76("path", {
        fill: "currentColor",
        d: "M322.176 960H248.32l144.64-250.56 55.424 32zm453.888 0h-73.856L576 741.44l55.424-32z"
      })
    ]));
  }
});

// src/components/data-board.vue
var data_board_default = data_board_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/data-line.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent77 } from "vue";
import { createElementVNode as _createElementVNode77, openBlock as _openBlock77, createElementBlock as _createElementBlock77 } from "vue";
var data_line_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent77({
  name: "DataLine",
  __name: "data-line",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock77(), _createElementBlock77("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode77("path", {
        fill: "currentColor",
        d: "M359.168 768H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32H665.216l110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32zM832 192H192v512h640zM342.656 534.656a32 32 0 1 1-45.312-45.312L444.992 341.76l125.44 94.08L679.04 300.032a32 32 0 1 1 49.92 39.936L581.632 524.224 451.008 426.24 342.656 534.592z"
      })
    ]));
  }
});

// src/components/data-line.vue
var data_line_default = data_line_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/delete-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent78 } from "vue";
import { createElementVNode as _createElementVNode78, openBlock as _openBlock78, createElementBlock as _createElementBlock78 } from "vue";
var delete_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent78({
  name: "DeleteFilled",
  __name: "delete-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock78(), _createElementBlock78("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode78("path", {
        fill: "currentColor",
        d: "M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64zm64 0h192v-64H416zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32m192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32"
      })
    ]));
  }
});

// src/components/delete-filled.vue
var delete_filled_default = delete_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/delete-location.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent79 } from "vue";
import { createElementVNode as _createElementVNode79, openBlock as _openBlock79, createElementBlock as _createElementBlock79 } from "vue";
var delete_location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent79({
  name: "DeleteLocation",
  __name: "delete-location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock79(), _createElementBlock79("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode79("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode79("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      _createElementVNode79("path", {
        fill: "currentColor",
        d: "M384 384h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/delete-location.vue
var delete_location_default = delete_location_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/delete.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent80 } from "vue";
import { createElementVNode as _createElementVNode80, openBlock as _openBlock80, createElementBlock as _createElementBlock80 } from "vue";
var delete_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent80({
  name: "Delete",
  __name: "delete",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock80(), _createElementBlock80("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode80("path", {
        fill: "currentColor",
        d: "M160 256H96a32 32 0 0 1 0-64h256V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64h-64v672a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32zm448-64v-64H416v64zM224 896h576V256H224zm192-128a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32m192 0a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32"
      })
    ]));
  }
});

// src/components/delete.vue
var delete_default = delete_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/dessert.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent81 } from "vue";
import { createElementVNode as _createElementVNode81, openBlock as _openBlock81, createElementBlock as _createElementBlock81 } from "vue";
var dessert_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent81({
  name: "Dessert",
  __name: "dessert",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock81(), _createElementBlock81("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode81("path", {
        fill: "currentColor",
        d: "M128 416v-48a144 144 0 0 1 168.64-141.888 224.128 224.128 0 0 1 430.72 0A144 144 0 0 1 896 368v48a384 384 0 0 1-352 382.72V896h-64v-97.28A384 384 0 0 1 128 416m287.104-32.064h193.792a143.808 143.808 0 0 1 58.88-132.736 160.064 160.064 0 0 0-311.552 0 143.808 143.808 0 0 1 58.88 132.8zm-72.896 0a72 72 0 1 0-140.48 0h140.48m339.584 0h140.416a72 72 0 1 0-140.48 0zM512 736a320 320 0 0 0 318.4-288.064H193.6A320 320 0 0 0 512 736M384 896.064h256a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64"
      })
    ]));
  }
});

// src/components/dessert.vue
var dessert_default = dessert_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/discount.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent82 } from "vue";
import { createElementVNode as _createElementVNode82, openBlock as _openBlock82, createElementBlock as _createElementBlock82 } from "vue";
var discount_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent82({
  name: "Discount",
  __name: "discount",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock82(), _createElementBlock82("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode82("path", {
        fill: "currentColor",
        d: "M224 704h576V318.336L552.512 115.84a64 64 0 0 0-81.024 0L224 318.336zm0 64v128h576V768zM593.024 66.304l259.2 212.096A32 32 0 0 1 864 303.168V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.168a32 32 0 0 1 11.712-24.768l259.2-212.096a128 128 0 0 1 162.112 0"
      }),
      _createElementVNode82("path", {
        fill: "currentColor",
        d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      })
    ]));
  }
});

// src/components/discount.vue
var discount_default = discount_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/dish-dot.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent83 } from "vue";
import { createElementVNode as _createElementVNode83, openBlock as _openBlock83, createElementBlock as _createElementBlock83 } from "vue";
var dish_dot_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent83({
  name: "DishDot",
  __name: "dish-dot",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock83(), _createElementBlock83("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode83("path", {
        fill: "currentColor",
        d: "m384.064 274.56.064-50.688A128 128 0 0 1 512.128 96c70.528 0 127.68 57.152 127.68 127.68v50.752A448.192 448.192 0 0 1 955.392 768H68.544A448.192 448.192 0 0 1 384 274.56zM96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-128h768a384 384 0 1 0-768 0m447.808-448v-32.32a63.68 63.68 0 0 0-63.68-63.68 64 64 0 0 0-64 63.936V256z"
      })
    ]));
  }
});

// src/components/dish-dot.vue
var dish_dot_default = dish_dot_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/dish.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent84 } from "vue";
import { createElementVNode as _createElementVNode84, openBlock as _openBlock84, createElementBlock as _createElementBlock84 } from "vue";
var dish_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent84({
  name: "Dish",
  __name: "dish",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock84(), _createElementBlock84("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode84("path", {
        fill: "currentColor",
        d: "M480 257.152V192h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64h-96v65.152A448 448 0 0 1 955.52 768H68.48A448 448 0 0 1 480 257.152M128 704h768a384 384 0 1 0-768 0M96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64"
      })
    ]));
  }
});

// src/components/dish.vue
var dish_default = dish_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/document-add.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent85 } from "vue";
import { createElementVNode as _createElementVNode85, openBlock as _openBlock85, createElementBlock as _createElementBlock85 } from "vue";
var document_add_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent85({
  name: "DocumentAdd",
  __name: "document-add",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock85(), _createElementBlock85("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode85("path", {
        fill: "currentColor",
        d: "M832 384H576V128H192v768h640zm-26.496-64L640 154.496V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m320 512V448h64v128h128v64H544v128h-64V640H352v-64z"
      })
    ]));
  }
});

// src/components/document-add.vue
var document_add_default = document_add_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/document-checked.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent86 } from "vue";
import { createElementVNode as _createElementVNode86, openBlock as _openBlock86, createElementBlock as _createElementBlock86 } from "vue";
var document_checked_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent86({
  name: "DocumentChecked",
  __name: "document-checked",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock86(), _createElementBlock86("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode86("path", {
        fill: "currentColor",
        d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m318.4 582.144 180.992-180.992L704.64 510.4 478.4 736.64 320 578.304l45.248-45.312z"
      })
    ]));
  }
});

// src/components/document-checked.vue
var document_checked_default = document_checked_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/document-copy.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent87 } from "vue";
import { createElementVNode as _createElementVNode87, openBlock as _openBlock87, createElementBlock as _createElementBlock87 } from "vue";
var document_copy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent87({
  name: "DocumentCopy",
  __name: "document-copy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock87(), _createElementBlock87("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode87("path", {
        fill: "currentColor",
        d: "M128 320v576h576V320zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32M960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32M256 672h320v64H256zm0-192h320v64H256z"
      })
    ]));
  }
});

// src/components/document-copy.vue
var document_copy_default = document_copy_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/document-delete.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent88 } from "vue";
import { createElementVNode as _createElementVNode88, openBlock as _openBlock88, createElementBlock as _createElementBlock88 } from "vue";
var document_delete_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent88({
  name: "DocumentDelete",
  __name: "document-delete",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock88(), _createElementBlock88("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode88("path", {
        fill: "currentColor",
        d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m308.992 546.304-90.496-90.624 45.248-45.248 90.56 90.496 90.496-90.432 45.248 45.248-90.496 90.56 90.496 90.496-45.248 45.248-90.496-90.496-90.56 90.496-45.248-45.248 90.496-90.496z"
      })
    ]));
  }
});

// src/components/document-delete.vue
var document_delete_default = document_delete_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/document-remove.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent89 } from "vue";
import { createElementVNode as _createElementVNode89, openBlock as _openBlock89, createElementBlock as _createElementBlock89 } from "vue";
var document_remove_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent89({
  name: "DocumentRemove",
  __name: "document-remove",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock89(), _createElementBlock89("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode89("path", {
        fill: "currentColor",
        d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m192 512h320v64H352z"
      })
    ]));
  }
});

// src/components/document-remove.vue
var document_remove_default = document_remove_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/document.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent90 } from "vue";
import { createElementVNode as _createElementVNode90, openBlock as _openBlock90, createElementBlock as _createElementBlock90 } from "vue";
var document_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent90({
  name: "Document",
  __name: "document",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock90(), _createElementBlock90("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode90("path", {
        fill: "currentColor",
        d: "M832 384H576V128H192v768h640zm-26.496-64L640 154.496V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h160v64H320zm0 384h384v64H320z"
      })
    ]));
  }
});

// src/components/document.vue
var document_default = document_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/download.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent91 } from "vue";
import { createElementVNode as _createElementVNode91, openBlock as _openBlock91, createElementBlock as _createElementBlock91 } from "vue";
var download_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent91({
  name: "Download",
  __name: "download",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock91(), _createElementBlock91("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode91("path", {
        fill: "currentColor",
        d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-253.696 236.288-236.352 45.248 45.248L508.8 704 192 387.2l45.248-45.248L480 584.704V128h64z"
      })
    ]));
  }
});

// src/components/download.vue
var download_default = download_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/drizzling.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent92 } from "vue";
import { createElementVNode as _createElementVNode92, openBlock as _openBlock92, createElementBlock as _createElementBlock92 } from "vue";
var drizzling_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent92({
  name: "Drizzling",
  __name: "drizzling",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock92(), _createElementBlock92("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode92("path", {
        fill: "currentColor",
        d: "m739.328 291.328-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 97.28 78.72 175.936 175.808 175.936h400a192 192 0 0 0 35.776-380.672zM959.552 480a256 256 0 0 1-256 256h-400A239.808 239.808 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 959.552 480M288 800h64v64h-64zm192 0h64v64h-64zm-96 96h64v64h-64zm192 0h64v64h-64zm96-96h64v64h-64z"
      })
    ]));
  }
});

// src/components/drizzling.vue
var drizzling_default = drizzling_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/edit-pen.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent93 } from "vue";
import { createElementVNode as _createElementVNode93, openBlock as _openBlock93, createElementBlock as _createElementBlock93 } from "vue";
var edit_pen_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent93({
  name: "EditPen",
  __name: "edit-pen",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock93(), _createElementBlock93("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode93("path", {
        fill: "currentColor",
        d: "m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"
      })
    ]));
  }
});

// src/components/edit-pen.vue
var edit_pen_default = edit_pen_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/edit.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent94 } from "vue";
import { createElementVNode as _createElementVNode94, openBlock as _openBlock94, createElementBlock as _createElementBlock94 } from "vue";
var edit_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent94({
  name: "Edit",
  __name: "edit",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock94(), _createElementBlock94("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode94("path", {
        fill: "currentColor",
        d: "M832 512a32 32 0 1 1 64 0v352a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h352a32 32 0 0 1 0 64H192v640h640z"
      }),
      _createElementVNode94("path", {
        fill: "currentColor",
        d: "m469.952 554.24 52.8-7.552L847.104 222.4a32 32 0 1 0-45.248-45.248L477.44 501.44l-7.552 52.8zm422.4-422.4a96 96 0 0 1 0 135.808l-331.84 331.84a32 32 0 0 1-18.112 9.088L436.8 623.68a32 32 0 0 1-36.224-36.224l15.104-105.6a32 32 0 0 1 9.024-18.112l331.904-331.84a96 96 0 0 1 135.744 0z"
      })
    ]));
  }
});

// src/components/edit.vue
var edit_default = edit_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/eleme-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent95 } from "vue";
import { createElementVNode as _createElementVNode95, openBlock as _openBlock95, createElementBlock as _createElementBlock95 } from "vue";
var eleme_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent95({
  name: "ElemeFilled",
  __name: "eleme-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock95(), _createElementBlock95("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode95("path", {
        fill: "currentColor",
        d: "M176 64h672c61.824 0 112 50.176 112 112v672a112 112 0 0 1-112 112H176A112 112 0 0 1 64 848V176c0-61.824 50.176-112 112-112m150.528 173.568c-152.896 99.968-196.544 304.064-97.408 456.96a330.688 330.688 0 0 0 456.96 96.64c9.216-5.888 17.6-11.776 25.152-18.56a18.24 18.24 0 0 0 4.224-24.32L700.352 724.8a47.552 47.552 0 0 0-65.536-14.272A234.56 234.56 0 0 1 310.592 641.6C240 533.248 271.104 387.968 379.456 316.48a234.304 234.304 0 0 1 276.352 15.168c1.664.832 2.56 2.56 3.392 4.224 5.888 8.384 3.328 19.328-5.12 25.216L456.832 489.6a47.552 47.552 0 0 0-14.336 65.472l16 24.384c5.888 8.384 16.768 10.88 25.216 5.056l308.224-199.936a19.584 19.584 0 0 0 6.72-23.488v-.896c-4.992-9.216-10.048-17.6-15.104-26.88-99.968-151.168-304.064-194.88-456.96-95.744zM786.88 504.704l-62.208 40.32c-8.32 5.888-10.88 16.768-4.992 25.216L760 632.32c5.888 8.448 16.768 11.008 25.152 5.12l31.104-20.16a55.36 55.36 0 0 0 16-76.48l-20.224-31.04a19.52 19.52 0 0 0-25.152-5.12z"
      })
    ]));
  }
});

// src/components/eleme-filled.vue
var eleme_filled_default = eleme_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/eleme.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent96 } from "vue";
import { createElementVNode as _createElementVNode96, openBlock as _openBlock96, createElementBlock as _createElementBlock96 } from "vue";
var eleme_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent96({
  name: "Eleme",
  __name: "eleme",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock96(), _createElementBlock96("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode96("path", {
        fill: "currentColor",
        d: "M300.032 188.8c174.72-113.28 408-63.36 522.24 109.44 5.76 10.56 11.52 20.16 17.28 30.72v.96a22.4 22.4 0 0 1-7.68 26.88l-352.32 228.48c-9.6 6.72-22.08 3.84-28.8-5.76l-18.24-27.84a54.336 54.336 0 0 1 16.32-74.88l225.6-146.88c9.6-6.72 12.48-19.2 5.76-28.8-.96-1.92-1.92-3.84-3.84-4.8a267.84 267.84 0 0 0-315.84-17.28c-123.84 81.6-159.36 247.68-78.72 371.52a268.096 268.096 0 0 0 370.56 78.72 54.336 54.336 0 0 1 74.88 16.32l17.28 26.88c5.76 9.6 3.84 21.12-4.8 27.84-8.64 7.68-18.24 14.4-28.8 21.12a377.92 377.92 0 0 1-522.24-110.4c-113.28-174.72-63.36-408 111.36-522.24zm526.08 305.28a22.336 22.336 0 0 1 28.8 5.76l23.04 35.52a63.232 63.232 0 0 1-18.24 87.36l-35.52 23.04c-9.6 6.72-22.08 3.84-28.8-5.76l-46.08-71.04c-6.72-9.6-3.84-22.08 5.76-28.8l71.04-46.08z"
      })
    ]));
  }
});

// src/components/eleme.vue
var eleme_default = eleme_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/element-plus.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent97 } from "vue";
import { createElementVNode as _createElementVNode97, openBlock as _openBlock97, createElementBlock as _createElementBlock97 } from "vue";
var element_plus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent97({
  name: "ElementPlus",
  __name: "element-plus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock97(), _createElementBlock97("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode97("path", {
        fill: "currentColor",
        d: "M839.7 734.7c0 33.3-17.9 41-17.9 41S519.7 949.8 499.2 960c-10.2 5.1-20.5 5.1-30.7 0 0 0-314.9-184.3-325.1-192-5.1-5.1-10.2-12.8-12.8-20.5V368.6c0-17.9 20.5-28.2 20.5-28.2L466 158.6c12.8-5.1 25.6-5.1 38.4 0 0 0 279 161.3 309.8 179.2 17.9 7.7 28.2 25.6 25.6 46.1-.1-5-.1 317.5-.1 350.8M714.2 371.2c-64-35.8-217.6-125.4-217.6-125.4-7.7-5.1-20.5-5.1-30.7 0L217.6 389.1s-17.9 10.2-17.9 23v297c0 5.1 5.1 12.8 7.7 17.9 7.7 5.1 256 148.5 256 148.5 7.7 5.1 17.9 5.1 25.6 0 15.4-7.7 250.9-145.9 250.9-145.9s12.8-5.1 12.8-30.7v-74.2l-276.5 169v-64c0-17.9 7.7-30.7 20.5-46.1L745 535c5.1-7.7 10.2-20.5 10.2-30.7v-66.6l-279 169v-69.1c0-15.4 5.1-30.7 17.9-38.4l220.1-128zM919 135.7c0-5.1-5.1-7.7-7.7-7.7h-58.9V66.6c0-5.1-5.1-5.1-10.2-5.1l-30.7 5.1c-5.1 0-5.1 2.6-5.1 5.1V128h-56.3c-5.1 0-5.1 5.1-7.7 5.1v38.4h69.1v64c0 5.1 5.1 5.1 10.2 5.1l30.7-5.1c5.1 0 5.1-2.6 5.1-5.1v-56.3h64l-2.5-38.4z"
      })
    ]));
  }
});

// src/components/element-plus.vue
var element_plus_default = element_plus_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/expand.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent98 } from "vue";
import { createElementVNode as _createElementVNode98, openBlock as _openBlock98, createElementBlock as _createElementBlock98 } from "vue";
var expand_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent98({
  name: "Expand",
  __name: "expand",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock98(), _createElementBlock98("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode98("path", {
        fill: "currentColor",
        d: "M128 192h768v128H128zm0 256h512v128H128zm0 256h768v128H128zm576-352 192 160-192 128z"
      })
    ]));
  }
});

// src/components/expand.vue
var expand_default = expand_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/failed.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent99 } from "vue";
import { createElementVNode as _createElementVNode99, openBlock as _openBlock99, createElementBlock as _createElementBlock99 } from "vue";
var failed_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent99({
  name: "Failed",
  __name: "failed",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock99(), _createElementBlock99("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode99("path", {
        fill: "currentColor",
        d: "m557.248 608 135.744-135.744-45.248-45.248-135.68 135.744-135.808-135.68-45.248 45.184L466.752 608l-135.68 135.68 45.184 45.312L512 653.248l135.744 135.744 45.248-45.248L557.312 608zM704 192h160v736H160V192h160v64h384zm-320 0V96h256v96z"
      })
    ]));
  }
});

// src/components/failed.vue
var failed_default = failed_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/female.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent100 } from "vue";
import { createElementVNode as _createElementVNode100, openBlock as _openBlock100, createElementBlock as _createElementBlock100 } from "vue";
var female_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent100({
  name: "Female",
  __name: "female",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock100(), _createElementBlock100("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode100("path", {
        fill: "currentColor",
        d: "M512 640a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      _createElementVNode100("path", {
        fill: "currentColor",
        d: "M512 640q32 0 32 32v256q0 32-32 32t-32-32V672q0-32 32-32"
      }),
      _createElementVNode100("path", {
        fill: "currentColor",
        d: "M352 800h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/female.vue
var female_default = female_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/files.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent101 } from "vue";
import { createElementVNode as _createElementVNode101, openBlock as _openBlock101, createElementBlock as _createElementBlock101 } from "vue";
var files_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent101({
  name: "Files",
  __name: "files",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock101(), _createElementBlock101("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode101("path", {
        fill: "currentColor",
        d: "M128 384v448h768V384zm-32-64h832a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32m64-128h704v64H160zm96-128h512v64H256z"
      })
    ]));
  }
});

// src/components/files.vue
var files_default = files_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/film.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent102 } from "vue";
import { createElementVNode as _createElementVNode102, openBlock as _openBlock102, createElementBlock as _createElementBlock102 } from "vue";
var film_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent102({
  name: "Film",
  __name: "film",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock102(), _createElementBlock102("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode102("path", {
        fill: "currentColor",
        d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
      }),
      _createElementVNode102("path", {
        fill: "currentColor",
        d: "M320 288V128h64v352h256V128h64v160h160v64H704v128h160v64H704v128h160v64H704v160h-64V544H384v352h-64V736H128v-64h192V544H128v-64h192V352H128v-64z"
      })
    ]));
  }
});

// src/components/film.vue
var film_default = film_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/filter.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent103 } from "vue";
import { createElementVNode as _createElementVNode103, openBlock as _openBlock103, createElementBlock as _createElementBlock103 } from "vue";
var filter_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent103({
  name: "Filter",
  __name: "filter",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock103(), _createElementBlock103("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode103("path", {
        fill: "currentColor",
        d: "M384 523.392V928a32 32 0 0 0 46.336 28.608l192-96A32 32 0 0 0 640 832V523.392l280.768-343.104a32 32 0 1 0-49.536-40.576l-288 352A32 32 0 0 0 576 512v300.224l-128 64V512a32 32 0 0 0-7.232-20.288L195.52 192H704a32 32 0 1 0 0-64H128a32 32 0 0 0-24.768 52.288z"
      })
    ]));
  }
});

// src/components/filter.vue
var filter_default = filter_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/finished.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent104 } from "vue";
import { createElementVNode as _createElementVNode104, openBlock as _openBlock104, createElementBlock as _createElementBlock104 } from "vue";
var finished_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent104({
  name: "Finished",
  __name: "finished",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock104(), _createElementBlock104("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode104("path", {
        fill: "currentColor",
        d: "M280.768 753.728 691.456 167.04a32 32 0 1 1 52.416 36.672L314.24 817.472a32 32 0 0 1-45.44 7.296l-230.4-172.8a32 32 0 0 1 38.4-51.2l203.968 152.96zM736 448a32 32 0 1 1 0-64h192a32 32 0 1 1 0 64zM608 640a32 32 0 0 1 0-64h319.936a32 32 0 1 1 0 64zM480 832a32 32 0 1 1 0-64h447.936a32 32 0 1 1 0 64z"
      })
    ]));
  }
});

// src/components/finished.vue
var finished_default = finished_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/first-aid-kit.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent105 } from "vue";
import { createElementVNode as _createElementVNode105, openBlock as _openBlock105, createElementBlock as _createElementBlock105 } from "vue";
var first_aid_kit_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent105({
  name: "FirstAidKit",
  __name: "first-aid-kit",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock105(), _createElementBlock105("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode105("path", {
        fill: "currentColor",
        d: "M192 256a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
      }),
      _createElementVNode105("path", {
        fill: "currentColor",
        d: "M544 512h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0zM352 128v64h320v-64zm-32-64h384a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H320a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      })
    ]));
  }
});

// src/components/first-aid-kit.vue
var first_aid_kit_default = first_aid_kit_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/flag.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent106 } from "vue";
import { createElementVNode as _createElementVNode106, openBlock as _openBlock106, createElementBlock as _createElementBlock106 } from "vue";
var flag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent106({
  name: "Flag",
  __name: "flag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock106(), _createElementBlock106("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode106("path", {
        fill: "currentColor",
        d: "M288 128h608L736 384l160 256H288v320h-96V64h96z"
      })
    ]));
  }
});

// src/components/flag.vue
var flag_default = flag_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/fold.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent107 } from "vue";
import { createElementVNode as _createElementVNode107, openBlock as _openBlock107, createElementBlock as _createElementBlock107 } from "vue";
var fold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent107({
  name: "Fold",
  __name: "fold",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock107(), _createElementBlock107("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode107("path", {
        fill: "currentColor",
        d: "M896 192H128v128h768zm0 256H384v128h512zm0 256H128v128h768zM320 384 128 512l192 128z"
      })
    ]));
  }
});

// src/components/fold.vue
var fold_default = fold_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/folder-add.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent108 } from "vue";
import { createElementVNode as _createElementVNode108, openBlock as _openBlock108, createElementBlock as _createElementBlock108 } from "vue";
var folder_add_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent108({
  name: "FolderAdd",
  __name: "folder-add",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock108(), _createElementBlock108("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode108("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m384 416V416h64v128h128v64H544v128h-64V608H352v-64z"
      })
    ]));
  }
});

// src/components/folder-add.vue
var folder_add_default = folder_add_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/folder-checked.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent109 } from "vue";
import { createElementVNode as _createElementVNode109, openBlock as _openBlock109, createElementBlock as _createElementBlock109 } from "vue";
var folder_checked_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent109({
  name: "FolderChecked",
  __name: "folder-checked",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock109(), _createElementBlock109("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode109("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m414.08 502.144 180.992-180.992L736.32 494.4 510.08 720.64l-158.4-158.336 45.248-45.312z"
      })
    ]));
  }
});

// src/components/folder-checked.vue
var folder_checked_default = folder_checked_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/folder-delete.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent110 } from "vue";
import { createElementVNode as _createElementVNode110, openBlock as _openBlock110, createElementBlock as _createElementBlock110 } from "vue";
var folder_delete_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent110({
  name: "FolderDelete",
  __name: "folder-delete",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock110(), _createElementBlock110("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode110("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m370.752 448-90.496-90.496 45.248-45.248L512 530.752l90.496-90.496 45.248 45.248L557.248 576l90.496 90.496-45.248 45.248L512 621.248l-90.496 90.496-45.248-45.248z"
      })
    ]));
  }
});

// src/components/folder-delete.vue
var folder_delete_default = folder_delete_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/folder-opened.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent111 } from "vue";
import { createElementVNode as _createElementVNode111, openBlock as _openBlock111, createElementBlock as _createElementBlock111 } from "vue";
var folder_opened_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent111({
  name: "FolderOpened",
  __name: "folder-opened",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock111(), _createElementBlock111("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode111("path", {
        fill: "currentColor",
        d: "M878.08 448H241.92l-96 384h636.16l96-384zM832 384v-64H485.76L357.504 192H128v448l57.92-231.744A32 32 0 0 1 216.96 384zm-24.96 512H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h287.872l128.384 128H864a32 32 0 0 1 32 32v96h23.04a32 32 0 0 1 31.04 39.744l-112 448A32 32 0 0 1 807.04 896"
      })
    ]));
  }
});

// src/components/folder-opened.vue
var folder_opened_default = folder_opened_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/folder-remove.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent112 } from "vue";
import { createElementVNode as _createElementVNode112, openBlock as _openBlock112, createElementBlock as _createElementBlock112 } from "vue";
var folder_remove_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent112({
  name: "FolderRemove",
  __name: "folder-remove",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock112(), _createElementBlock112("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode112("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m256 416h320v64H352z"
      })
    ]));
  }
});

// src/components/folder-remove.vue
var folder_remove_default = folder_remove_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/folder.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent113 } from "vue";
import { createElementVNode as _createElementVNode113, openBlock as _openBlock113, createElementBlock as _createElementBlock113 } from "vue";
var folder_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent113({
  name: "Folder",
  __name: "folder",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock113(), _createElementBlock113("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode113("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32"
      })
    ]));
  }
});

// src/components/folder.vue
var folder_default = folder_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/food.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent114 } from "vue";
import { createElementVNode as _createElementVNode114, openBlock as _openBlock114, createElementBlock as _createElementBlock114 } from "vue";
var food_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent114({
  name: "Food",
  __name: "food",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock114(), _createElementBlock114("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode114("path", {
        fill: "currentColor",
        d: "M128 352.576V352a288 288 0 0 1 491.072-204.224 192 192 0 0 1 274.24 204.48 64 64 0 0 1 57.216 74.24C921.6 600.512 850.048 710.656 736 756.992V800a96 96 0 0 1-96 96H384a96 96 0 0 1-96-96v-43.008c-114.048-46.336-185.6-156.48-214.528-330.496A64 64 0 0 1 128 352.64zm64-.576h64a160 160 0 0 1 320 0h64a224 224 0 0 0-448 0m128 0h192a96 96 0 0 0-192 0m439.424 0h68.544A128.256 128.256 0 0 0 704 192c-15.36 0-29.952 2.688-43.52 7.616 11.328 18.176 20.672 37.76 27.84 58.304A64.128 64.128 0 0 1 759.424 352M672 768H352v32a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32zm-342.528-64h365.056c101.504-32.64 165.76-124.928 192.896-288H136.576c27.136 163.072 91.392 255.36 192.896 288"
      })
    ]));
  }
});

// src/components/food.vue
var food_default = food_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/football.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent115 } from "vue";
import { createElementVNode as _createElementVNode115, openBlock as _openBlock115, createElementBlock as _createElementBlock115 } from "vue";
var football_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent115({
  name: "Football",
  __name: "football",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock115(), _createElementBlock115("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode115("path", {
        fill: "currentColor",
        d: "M512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-64a384 384 0 1 0 0-768 384 384 0 0 0 0 768"
      }),
      _createElementVNode115("path", {
        fill: "currentColor",
        d: "M186.816 268.288c16-16.384 31.616-31.744 46.976-46.08 17.472 30.656 39.808 58.112 65.984 81.28l-32.512 56.448a385.984 385.984 0 0 1-80.448-91.648zm653.696-5.312a385.92 385.92 0 0 1-83.776 96.96l-32.512-56.384a322.923 322.923 0 0 0 68.48-85.76c15.552 14.08 31.488 29.12 47.808 45.184zM465.984 445.248l11.136-63.104a323.584 323.584 0 0 0 69.76 0l11.136 63.104a387.968 387.968 0 0 1-92.032 0m-62.72-12.8A381.824 381.824 0 0 1 320 396.544l32-55.424a319.885 319.885 0 0 0 62.464 27.712l-11.2 63.488zm300.8-35.84a381.824 381.824 0 0 1-83.328 35.84l-11.2-63.552A319.885 319.885 0 0 0 672 341.184l32 55.424zm-520.768 364.8a385.92 385.92 0 0 1 83.968-97.28l32.512 56.32c-26.88 23.936-49.856 52.352-67.52 84.032-16-13.44-32.32-27.712-48.96-43.072zm657.536.128a1442.759 1442.759 0 0 1-49.024 43.072 321.408 321.408 0 0 0-67.584-84.16l32.512-56.32c33.216 27.456 61.696 60.352 84.096 97.408zM465.92 578.752a387.968 387.968 0 0 1 92.032 0l-11.136 63.104a323.584 323.584 0 0 0-69.76 0zm-62.72 12.8 11.2 63.552a319.885 319.885 0 0 0-62.464 27.712L320 627.392a381.824 381.824 0 0 1 83.264-35.84zm300.8 35.84-32 55.424a318.272 318.272 0 0 0-62.528-27.712l11.2-63.488c29.44 8.64 57.28 20.736 83.264 35.776z"
      })
    ]));
  }
});

// src/components/football.vue
var football_default = football_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/fork-spoon.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent116 } from "vue";
import { createElementVNode as _createElementVNode116, openBlock as _openBlock116, createElementBlock as _createElementBlock116 } from "vue";
var fork_spoon_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent116({
  name: "ForkSpoon",
  __name: "fork-spoon",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock116(), _createElementBlock116("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode116("path", {
        fill: "currentColor",
        d: "M256 410.304V96a32 32 0 0 1 64 0v314.304a96 96 0 0 0 64-90.56V96a32 32 0 0 1 64 0v223.744a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.544a160 160 0 0 1-128-156.8V96a32 32 0 0 1 64 0v223.744a96 96 0 0 0 64 90.56zM672 572.48C581.184 552.128 512 446.848 512 320c0-141.44 85.952-256 192-256s192 114.56 192 256c0 126.848-69.184 232.128-160 252.48V928a32 32 0 1 1-64 0zM704 512c66.048 0 128-82.56 128-192s-61.952-192-128-192-128 82.56-128 192 61.952 192 128 192"
      })
    ]));
  }
});

// src/components/fork-spoon.vue
var fork_spoon_default = fork_spoon_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/fries.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent117 } from "vue";
import { createElementVNode as _createElementVNode117, openBlock as _openBlock117, createElementBlock as _createElementBlock117 } from "vue";
var fries_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent117({
  name: "Fries",
  __name: "fries",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock117(), _createElementBlock117("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode117("path", {
        fill: "currentColor",
        d: "M608 224v-64a32 32 0 0 0-64 0v336h26.88A64 64 0 0 0 608 484.096zm101.12 160A64 64 0 0 0 672 395.904V384h64V224a32 32 0 1 0-64 0v160zm74.88 0a92.928 92.928 0 0 1 91.328 110.08l-60.672 323.584A96 96 0 0 1 720.32 896H303.68a96 96 0 0 1-94.336-78.336L148.672 494.08A92.928 92.928 0 0 1 240 384h-16V224a96 96 0 0 1 188.608-25.28A95.744 95.744 0 0 1 480 197.44V160a96 96 0 0 1 188.608-25.28A96 96 0 0 1 800 224v160zM670.784 512a128 128 0 0 1-99.904 48H453.12a128 128 0 0 1-99.84-48H352v-1.536a128.128 128.128 0 0 1-9.984-14.976L314.88 448H240a28.928 28.928 0 0 0-28.48 34.304L241.088 640h541.824l29.568-157.696A28.928 28.928 0 0 0 784 448h-74.88l-27.136 47.488A132.405 132.405 0 0 1 672 510.464V512zM480 288a32 32 0 0 0-64 0v196.096A64 64 0 0 0 453.12 496H480zm-128 96V224a32 32 0 0 0-64 0v160zh-37.12A64 64 0 0 1 352 395.904zm-98.88 320 19.072 101.888A32 32 0 0 0 303.68 832h416.64a32 32 0 0 0 31.488-26.112L770.88 704z"
      })
    ]));
  }
});

// src/components/fries.vue
var fries_default = fries_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/full-screen.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent118 } from "vue";
import { createElementVNode as _createElementVNode118, openBlock as _openBlock118, createElementBlock as _createElementBlock118 } from "vue";
var full_screen_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent118({
  name: "FullScreen",
  __name: "full-screen",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock118(), _createElementBlock118("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode118("path", {
        fill: "currentColor",
        d: "m160 96.064 192 .192a32 32 0 0 1 0 64l-192-.192V352a32 32 0 0 1-64 0V96h64zm0 831.872V928H96V672a32 32 0 1 1 64 0v191.936l192-.192a32 32 0 1 1 0 64zM864 96.064V96h64v256a32 32 0 1 1-64 0V160.064l-192 .192a32 32 0 1 1 0-64l192-.192zm0 831.872-192-.192a32 32 0 0 1 0-64l192 .192V672a32 32 0 1 1 64 0v256h-64z"
      })
    ]));
  }
});

// src/components/full-screen.vue
var full_screen_default = full_screen_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/goblet-full.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent119 } from "vue";
import { createElementVNode as _createElementVNode119, openBlock as _openBlock119, createElementBlock as _createElementBlock119 } from "vue";
var goblet_full_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent119({
  name: "GobletFull",
  __name: "goblet-full",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock119(), _createElementBlock119("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode119("path", {
        fill: "currentColor",
        d: "M256 320h512c0-78.592-12.608-142.4-36.928-192h-434.24C269.504 192.384 256 256.256 256 320m503.936 64H264.064a256.128 256.128 0 0 0 495.872 0zM544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320c0-85.632 21.312-170.944 64-256h512c42.688 64.32 64 149.632 64 256a320 320 0 0 1-288 318.4"
      })
    ]));
  }
});

// src/components/goblet-full.vue
var goblet_full_default = goblet_full_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/goblet-square-full.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent120 } from "vue";
import { createElementVNode as _createElementVNode120, openBlock as _openBlock120, createElementBlock as _createElementBlock120 } from "vue";
var goblet_square_full_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent120({
  name: "GobletSquareFull",
  __name: "goblet-square-full",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock120(), _createElementBlock120("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode120("path", {
        fill: "currentColor",
        d: "M256 270.912c10.048 6.72 22.464 14.912 28.992 18.624a220.16 220.16 0 0 0 114.752 30.72c30.592 0 49.408-9.472 91.072-41.152l.64-.448c52.928-40.32 82.368-55.04 132.288-54.656 55.552.448 99.584 20.8 142.72 57.408l1.536 1.28V128H256v142.912zm.96 76.288C266.368 482.176 346.88 575.872 512 576c157.44.064 237.952-85.056 253.248-209.984a952.32 952.32 0 0 1-40.192-35.712c-32.704-27.776-63.36-41.92-101.888-42.24-31.552-.256-50.624 9.28-93.12 41.6l-.576.448c-52.096 39.616-81.024 54.208-129.792 54.208-54.784 0-100.48-13.376-142.784-37.056zM480 638.848C250.624 623.424 192 442.496 192 319.68V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.816-58.624 303.68-288 318.912V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96z"
      })
    ]));
  }
});

// src/components/goblet-square-full.vue
var goblet_square_full_default = goblet_square_full_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/goblet-square.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent121 } from "vue";
import { createElementVNode as _createElementVNode121, openBlock as _openBlock121, createElementBlock as _createElementBlock121 } from "vue";
var goblet_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent121({
  name: "GobletSquare",
  __name: "goblet-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock121(), _createElementBlock121("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode121("path", {
        fill: "currentColor",
        d: "M544 638.912V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.848C250.624 623.424 192 442.496 192 319.68V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.816-58.624 303.68-288 318.912M256 319.68c0 149.568 80 256.192 256 256.256C688.128 576 768 469.568 768 320V128H256z"
      })
    ]));
  }
});

// src/components/goblet-square.vue
var goblet_square_default = goblet_square_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/goblet.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent122 } from "vue";
import { createElementVNode as _createElementVNode122, openBlock as _openBlock122, createElementBlock as _createElementBlock122 } from "vue";
var goblet_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent122({
  name: "Goblet",
  __name: "goblet",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock122(), _createElementBlock122("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode122("path", {
        fill: "currentColor",
        d: "M544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320c0-85.632 21.312-170.944 64-256h512c42.688 64.32 64 149.632 64 256a320 320 0 0 1-288 318.4M256 320a256 256 0 1 0 512 0c0-78.592-12.608-142.4-36.928-192h-434.24C269.504 192.384 256 256.256 256 320"
      })
    ]));
  }
});

// src/components/goblet.vue
var goblet_default = goblet_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/gold-medal.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent123 } from "vue";
import { createElementVNode as _createElementVNode123, openBlock as _openBlock123, createElementBlock as _createElementBlock123 } from "vue";
var gold_medal_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent123({
  name: "GoldMedal",
  __name: "gold-medal",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock123(), _createElementBlock123("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode123("path", {
        fill: "currentColor",
        d: "m772.13 452.84 53.86-351.81c1.32-10.01-1.17-18.68-7.49-26.02S804.35 64 795.01 64H228.99v-.01h-.06c-9.33 0-17.15 3.67-23.49 11.01s-8.83 16.01-7.49 26.02l53.87 351.89C213.54 505.73 193.59 568.09 192 640c2 90.67 33.17 166.17 93.5 226.5S421.33 957.99 512 960c90.67-2 166.17-33.17 226.5-93.5 60.33-60.34 91.49-135.83 93.5-226.5-1.59-71.94-21.56-134.32-59.87-187.16zM640.01 128h117.02l-39.01 254.02c-20.75-10.64-40.74-19.73-59.94-27.28-5.92-3-11.95-5.8-18.08-8.41V128h.01zM576 128v198.76c-13.18-2.58-26.74-4.43-40.67-5.55-8.07-.8-15.85-1.2-23.33-1.2-10.54 0-21.09.66-31.64 1.96a359.844 359.844 0 0 0-32.36 4.79V128zm-192 0h.04v218.3c-6.22 2.66-12.34 5.5-18.36 8.56-19.13 7.54-39.02 16.6-59.66 27.16L267.01 128zm308.99 692.99c-48 48-108.33 73-180.99 75.01-72.66-2.01-132.99-27.01-180.99-75.01S258.01 712.66 256 640c2.01-72.66 27.01-132.99 75.01-180.99 19.67-19.67 41.41-35.47 65.22-47.41 38.33-15.04 71.15-23.92 98.44-26.65 5.07-.41 10.2-.7 15.39-.88.63-.01 1.28-.03 1.91-.03.66 0 1.35.03 2.02.04 5.11.17 10.15.46 15.13.86 27.4 2.71 60.37 11.65 98.91 26.79 23.71 11.93 45.36 27.69 64.96 47.29 48 48 73 108.33 75.01 180.99-2.01 72.65-27.01 132.98-75.01 180.98z"
      }),
      _createElementVNode123("path", {
        fill: "currentColor",
        d: "M544 480H416v64h64v192h-64v64h192v-64h-64z"
      })
    ]));
  }
});

// src/components/gold-medal.vue
var gold_medal_default = gold_medal_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/goods-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent124 } from "vue";
import { createElementVNode as _createElementVNode124, openBlock as _openBlock124, createElementBlock as _createElementBlock124 } from "vue";
var goods_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent124({
  name: "GoodsFilled",
  __name: "goods-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock124(), _createElementBlock124("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode124("path", {
        fill: "currentColor",
        d: "M192 352h640l64 544H128zm128 224h64V448h-64zm320 0h64V448h-64zM384 288h-64a192 192 0 1 1 384 0h-64a128 128 0 1 0-256 0"
      })
    ]));
  }
});

// src/components/goods-filled.vue
var goods_filled_default = goods_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/goods.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent125 } from "vue";
import { createElementVNode as _createElementVNode125, openBlock as _openBlock125, createElementBlock as _createElementBlock125 } from "vue";
var goods_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent125({
  name: "Goods",
  __name: "goods",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock125(), _createElementBlock125("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode125("path", {
        fill: "currentColor",
        d: "M320 288v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4h131.072a32 32 0 0 1 31.808 28.8l57.6 576a32 32 0 0 1-31.808 35.2H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320zm64 0h256v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4zm-64 64H217.92l-51.2 512h690.56l-51.264-512H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0z"
      })
    ]));
  }
});

// src/components/goods.vue
var goods_default = goods_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/grape.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent126 } from "vue";
import { createElementVNode as _createElementVNode126, openBlock as _openBlock126, createElementBlock as _createElementBlock126 } from "vue";
var grape_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent126({
  name: "Grape",
  __name: "grape",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock126(), _createElementBlock126("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode126("path", {
        fill: "currentColor",
        d: "M544 195.2a160 160 0 0 1 96 60.8 160 160 0 1 1 146.24 254.976 160 160 0 0 1-128 224 160 160 0 1 1-292.48 0 160 160 0 0 1-128-224A160 160 0 1 1 384 256a160 160 0 0 1 96-60.8V128h-64a32 32 0 0 1 0-64h192a32 32 0 0 1 0 64h-64zM512 448a96 96 0 1 0 0-192 96 96 0 0 0 0 192m-256 0a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
      })
    ]));
  }
});

// src/components/grape.vue
var grape_default = grape_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/grid.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent127 } from "vue";
import { createElementVNode as _createElementVNode127, openBlock as _openBlock127, createElementBlock as _createElementBlock127 } from "vue";
var grid_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent127({
  name: "Grid",
  __name: "grid",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock127(), _createElementBlock127("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode127("path", {
        fill: "currentColor",
        d: "M640 384v256H384V384zm64 0h192v256H704zm-64 512H384V704h256zm64 0V704h192v192zm-64-768v192H384V128zm64 0h192v192H704zM320 384v256H128V384zm0 512H128V704h192zm0-768v192H128V128z"
      })
    ]));
  }
});

// src/components/grid.vue
var grid_default = grid_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/guide.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent128 } from "vue";
import { createElementVNode as _createElementVNode128, openBlock as _openBlock128, createElementBlock as _createElementBlock128 } from "vue";
var guide_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent128({
  name: "Guide",
  __name: "guide",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock128(), _createElementBlock128("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode128("path", {
        fill: "currentColor",
        d: "M640 608h-64V416h64zm0 160v160a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V768h64v128h128V768zM384 608V416h64v192zm256-352h-64V128H448v128h-64V96a32 32 0 0 1 32-32h192a32 32 0 0 1 32 32z"
      }),
      _createElementVNode128("path", {
        fill: "currentColor",
        d: "m220.8 256-71.232 80 71.168 80H768V256H220.8zm-14.4-64H800a32 32 0 0 1 32 32v224a32 32 0 0 1-32 32H206.4a32 32 0 0 1-23.936-10.752l-99.584-112a32 32 0 0 1 0-42.496l99.584-112A32 32 0 0 1 206.4 192m678.784 496-71.104 80H266.816V608h547.2l71.168 80zm-56.768-144H234.88a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h593.6a32 32 0 0 0 23.936-10.752l99.584-112a32 32 0 0 0 0-42.496l-99.584-112A32 32 0 0 0 828.48 544z"
      })
    ]));
  }
});

// src/components/guide.vue
var guide_default = guide_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/handbag.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent129 } from "vue";
import { createElementVNode as _createElementVNode129, openBlock as _openBlock129, createElementBlock as _createElementBlock129 } from "vue";
var handbag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent129({
  name: "Handbag",
  __name: "handbag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock129(), _createElementBlock129("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode129("path", {
        fill: "currentColor",
        d: "M887.01 264.99c-6-5.99-13.67-8.99-23.01-8.99H704c-1.34-54.68-20.01-100.01-56-136s-81.32-54.66-136-56c-54.68 1.34-100.01 20.01-136 56s-54.66 81.32-56 136H160c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.67-8.99 23.01v640c0 9.35 2.99 17.02 8.99 23.01S150.66 960 160 960h704c9.35 0 17.02-2.99 23.01-8.99S896 937.34 896 928V288c0-9.35-2.99-17.02-8.99-23.01M421.5 165.5c24.32-24.34 54.49-36.84 90.5-37.5 35.99.68 66.16 13.18 90.5 37.5s36.84 54.49 37.5 90.5H384c.68-35.99 13.18-66.16 37.5-90.5M832 896H192V320h128v128h64V320h256v128h64V320h128z"
      })
    ]));
  }
});

// src/components/handbag.vue
var handbag_default = handbag_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/headset.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent130 } from "vue";
import { createElementVNode as _createElementVNode130, openBlock as _openBlock130, createElementBlock as _createElementBlock130 } from "vue";
var headset_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent130({
  name: "Headset",
  __name: "headset",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock130(), _createElementBlock130("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode130("path", {
        fill: "currentColor",
        d: "M896 529.152V512a384 384 0 1 0-768 0v17.152A128 128 0 0 1 320 640v128a128 128 0 1 1-256 0V512a448 448 0 1 1 896 0v256a128 128 0 1 1-256 0V640a128 128 0 0 1 192-110.848M896 640a64 64 0 0 0-128 0v128a64 64 0 0 0 128 0zm-768 0v128a64 64 0 0 0 128 0V640a64 64 0 1 0-128 0"
      })
    ]));
  }
});

// src/components/headset.vue
var headset_default = headset_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/help-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent131 } from "vue";
import { createElementVNode as _createElementVNode131, openBlock as _openBlock131, createElementBlock as _createElementBlock131 } from "vue";
var help_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent131({
  name: "HelpFilled",
  __name: "help-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock131(), _createElementBlock131("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode131("path", {
        fill: "currentColor",
        d: "M926.784 480H701.312A192.512 192.512 0 0 0 544 322.688V97.216A416.064 416.064 0 0 1 926.784 480m0 64A416.064 416.064 0 0 1 544 926.784V701.312A192.512 192.512 0 0 0 701.312 544zM97.28 544h225.472A192.512 192.512 0 0 0 480 701.312v225.472A416.064 416.064 0 0 1 97.216 544zm0-64A416.064 416.064 0 0 1 480 97.216v225.472A192.512 192.512 0 0 0 322.688 480H97.216z"
      })
    ]));
  }
});

// src/components/help-filled.vue
var help_filled_default = help_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/help.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent132 } from "vue";
import { createElementVNode as _createElementVNode132, openBlock as _openBlock132, createElementBlock as _createElementBlock132 } from "vue";
var help_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent132({
  name: "Help",
  __name: "help",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock132(), _createElementBlock132("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode132("path", {
        fill: "currentColor",
        d: "m759.936 805.248-90.944-91.008A254.912 254.912 0 0 1 512 768a254.912 254.912 0 0 1-156.992-53.76l-90.944 91.008A382.464 382.464 0 0 0 512 896c94.528 0 181.12-34.176 247.936-90.752m45.312-45.312A382.464 382.464 0 0 0 896 512c0-94.528-34.176-181.12-90.752-247.936l-91.008 90.944C747.904 398.4 768 452.864 768 512c0 59.136-20.096 113.6-53.76 156.992l91.008 90.944zm-45.312-541.184A382.464 382.464 0 0 0 512 128c-94.528 0-181.12 34.176-247.936 90.752l90.944 91.008A254.912 254.912 0 0 1 512 256c59.136 0 113.6 20.096 156.992 53.76l90.944-91.008zm-541.184 45.312A382.464 382.464 0 0 0 128 512c0 94.528 34.176 181.12 90.752 247.936l91.008-90.944A254.912 254.912 0 0 1 256 512c0-59.136 20.096-113.6 53.76-156.992zm417.28 394.496a194.56 194.56 0 0 0 22.528-22.528C686.912 602.56 704 559.232 704 512a191.232 191.232 0 0 0-67.968-146.56A191.296 191.296 0 0 0 512 320a191.232 191.232 0 0 0-146.56 67.968C337.088 421.44 320 464.768 320 512a191.232 191.232 0 0 0 67.968 146.56C421.44 686.912 464.768 704 512 704c47.296 0 90.56-17.088 124.032-45.44zM512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});

// src/components/help.vue
var help_default = help_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/hide.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent133 } from "vue";
import { createElementVNode as _createElementVNode133, openBlock as _openBlock133, createElementBlock as _createElementBlock133 } from "vue";
var hide_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent133({
  name: "Hide",
  __name: "hide",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock133(), _createElementBlock133("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode133("path", {
        fill: "currentColor",
        d: "M876.8 156.8c0-9.6-3.2-16-9.6-22.4-6.4-6.4-12.8-9.6-22.4-9.6-9.6 0-16 3.2-22.4 9.6L736 220.8c-64-32-137.6-51.2-224-60.8-160 16-288 73.6-377.6 176C44.8 438.4 0 496 0 512s48 73.6 134.4 176c22.4 25.6 44.8 48 73.6 67.2l-86.4 89.6c-6.4 6.4-9.6 12.8-9.6 22.4 0 9.6 3.2 16 9.6 22.4 6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6l704-710.4c3.2-6.4 6.4-12.8 6.4-22.4Zm-646.4 528c-76.8-70.4-128-128-153.6-172.8 28.8-48 80-105.6 153.6-172.8C304 272 400 230.4 512 224c64 3.2 124.8 19.2 176 44.8l-54.4 54.4C598.4 300.8 560 288 512 288c-64 0-115.2 22.4-160 64s-64 96-64 160c0 48 12.8 89.6 35.2 124.8L256 707.2c-9.6-6.4-19.2-16-25.6-22.4Zm140.8-96c-12.8-22.4-19.2-48-19.2-76.8 0-44.8 16-83.2 48-112 32-28.8 67.2-48 112-48 28.8 0 54.4 6.4 73.6 19.2zM889.599 336c-12.8-16-28.8-28.8-41.6-41.6l-48 48c73.6 67.2 124.8 124.8 150.4 169.6-28.8 48-80 105.6-153.6 172.8-73.6 67.2-172.8 108.8-284.8 115.2-51.2-3.2-99.2-12.8-140.8-28.8l-48 48c57.6 22.4 118.4 38.4 188.8 44.8 160-16 288-73.6 377.6-176C979.199 585.6 1024 528 1024 512s-48.001-73.6-134.401-176Z"
      }),
      _createElementVNode133("path", {
        fill: "currentColor",
        d: "M511.998 672c-12.8 0-25.6-3.2-38.4-6.4l-51.2 51.2c28.8 12.8 57.6 19.2 89.6 19.2 64 0 115.2-22.4 160-64 41.6-41.6 64-96 64-160 0-32-6.4-64-19.2-89.6l-51.2 51.2c3.2 12.8 6.4 25.6 6.4 38.4 0 44.8-16 83.2-48 112-32 28.8-67.2 48-112 48Z"
      })
    ]));
  }
});

// src/components/hide.vue
var hide_default = hide_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/histogram.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent134 } from "vue";
import { createElementVNode as _createElementVNode134, openBlock as _openBlock134, createElementBlock as _createElementBlock134 } from "vue";
var histogram_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent134({
  name: "Histogram",
  __name: "histogram",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock134(), _createElementBlock134("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode134("path", {
        fill: "currentColor",
        d: "M416 896V128h192v768zm-288 0V448h192v448zm576 0V320h192v576z"
      })
    ]));
  }
});

// src/components/histogram.vue
var histogram_default = histogram_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/home-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent135 } from "vue";
import { createElementVNode as _createElementVNode135, openBlock as _openBlock135, createElementBlock as _createElementBlock135 } from "vue";
var home_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent135({
  name: "HomeFilled",
  __name: "home-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock135(), _createElementBlock135("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode135("path", {
        fill: "currentColor",
        d: "M512 128 128 447.936V896h255.936V640H640v256h255.936V447.936z"
      })
    ]));
  }
});

// src/components/home-filled.vue
var home_filled_default = home_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/hot-water.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent136 } from "vue";
import { createElementVNode as _createElementVNode136, openBlock as _openBlock136, createElementBlock as _createElementBlock136 } from "vue";
var hot_water_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent136({
  name: "HotWater",
  __name: "hot-water",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock136(), _createElementBlock136("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode136("path", {
        fill: "currentColor",
        d: "M273.067 477.867h477.866V409.6H273.067zm0 68.266v51.2A187.733 187.733 0 0 0 460.8 785.067h102.4a187.733 187.733 0 0 0 187.733-187.734v-51.2H273.067zm-34.134-204.8h546.134a34.133 34.133 0 0 1 34.133 34.134v221.866a256 256 0 0 1-256 256H460.8a256 256 0 0 1-256-256V375.467a34.133 34.133 0 0 1 34.133-34.134zM512 34.133a34.133 34.133 0 0 1 34.133 34.134v170.666a34.133 34.133 0 0 1-68.266 0V68.267A34.133 34.133 0 0 1 512 34.133zM375.467 102.4a34.133 34.133 0 0 1 34.133 34.133v102.4a34.133 34.133 0 0 1-68.267 0v-102.4a34.133 34.133 0 0 1 34.134-34.133m273.066 0a34.133 34.133 0 0 1 34.134 34.133v102.4a34.133 34.133 0 1 1-68.267 0v-102.4a34.133 34.133 0 0 1 34.133-34.133M170.667 921.668h682.666a34.133 34.133 0 1 1 0 68.267H170.667a34.133 34.133 0 1 1 0-68.267z"
      })
    ]));
  }
});

// src/components/hot-water.vue
var hot_water_default = hot_water_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/house.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent137 } from "vue";
import { createElementVNode as _createElementVNode137, openBlock as _openBlock137, createElementBlock as _createElementBlock137 } from "vue";
var house_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent137({
  name: "House",
  __name: "house",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock137(), _createElementBlock137("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode137("path", {
        fill: "currentColor",
        d: "M192 413.952V896h640V413.952L512 147.328zM139.52 374.4l352-293.312a32 32 0 0 1 40.96 0l352 293.312A32 32 0 0 1 896 398.976V928a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V398.976a32 32 0 0 1 11.52-24.576"
      })
    ]));
  }
});

// src/components/house.vue
var house_default = house_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/ice-cream-round.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent138 } from "vue";
import { createElementVNode as _createElementVNode138, openBlock as _openBlock138, createElementBlock as _createElementBlock138 } from "vue";
var ice_cream_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent138({
  name: "IceCreamRound",
  __name: "ice-cream-round",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock138(), _createElementBlock138("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode138("path", {
        fill: "currentColor",
        d: "m308.352 489.344 226.304 226.304a32 32 0 0 0 45.248 0L783.552 512A192 192 0 1 0 512 240.448L308.352 444.16a32 32 0 0 0 0 45.248zm135.744 226.304L308.352 851.392a96 96 0 0 1-135.744-135.744l135.744-135.744-45.248-45.248a96 96 0 0 1 0-135.808L466.752 195.2A256 256 0 0 1 828.8 557.248L625.152 760.96a96 96 0 0 1-135.808 0l-45.248-45.248zM398.848 670.4 353.6 625.152 217.856 760.896a32 32 0 0 0 45.248 45.248zm248.96-384.64a32 32 0 0 1 0 45.248L466.624 512a32 32 0 1 1-45.184-45.248l180.992-181.056a32 32 0 0 1 45.248 0zm90.496 90.496a32 32 0 0 1 0 45.248L557.248 602.496A32 32 0 1 1 512 557.248l180.992-180.992a32 32 0 0 1 45.312 0z"
      })
    ]));
  }
});

// src/components/ice-cream-round.vue
var ice_cream_round_default = ice_cream_round_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/ice-cream-square.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent139 } from "vue";
import { createElementVNode as _createElementVNode139, openBlock as _openBlock139, createElementBlock as _createElementBlock139 } from "vue";
var ice_cream_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent139({
  name: "IceCreamSquare",
  __name: "ice-cream-square",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock139(), _createElementBlock139("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode139("path", {
        fill: "currentColor",
        d: "M416 640h256a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H352a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32zm192 64v160a96 96 0 0 1-192 0V704h-64a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96h320a96 96 0 0 1 96 96v448a96 96 0 0 1-96 96zm-64 0h-64v160a32 32 0 1 0 64 0z"
      })
    ]));
  }
});

// src/components/ice-cream-square.vue
var ice_cream_square_default = ice_cream_square_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/ice-cream.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent140 } from "vue";
import { createElementVNode as _createElementVNode140, openBlock as _openBlock140, createElementBlock as _createElementBlock140 } from "vue";
var ice_cream_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent140({
  name: "IceCream",
  __name: "ice-cream",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock140(), _createElementBlock140("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode140("path", {
        fill: "currentColor",
        d: "M128.64 448a208 208 0 0 1 193.536-191.552 224 224 0 0 1 445.248 15.488A208.128 208.128 0 0 1 894.784 448H896L548.8 983.68a32 32 0 0 1-53.248.704L128 448zm64.256 0h286.208a144 144 0 0 0-286.208 0zm351.36 0h286.272a144 144 0 0 0-286.272 0zm-294.848 64 271.808 396.608L778.24 512H249.408zM511.68 352.64a207.872 207.872 0 0 1 189.184-96.192 160 160 0 0 0-314.752 5.632c52.608 12.992 97.28 46.08 125.568 90.56"
      })
    ]));
  }
});

// src/components/ice-cream.vue
var ice_cream_default = ice_cream_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/ice-drink.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent141 } from "vue";
import { createElementVNode as _createElementVNode141, openBlock as _openBlock141, createElementBlock as _createElementBlock141 } from "vue";
var ice_drink_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent141({
  name: "IceDrink",
  __name: "ice-drink",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock141(), _createElementBlock141("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode141("path", {
        fill: "currentColor",
        d: "M512 448v128h239.68l16.064-128zm-64 0H256.256l16.064 128H448zm64-255.36V384h247.744A256.128 256.128 0 0 0 512 192.64m-64 8.064A256.448 256.448 0 0 0 264.256 384H448zm64-72.064A320.128 320.128 0 0 1 825.472 384H896a32 32 0 1 1 0 64h-64v1.92l-56.96 454.016A64 64 0 0 1 711.552 960H312.448a64 64 0 0 1-63.488-56.064L192 449.92V448h-64a32 32 0 0 1 0-64h70.528A320.384 320.384 0 0 1 448 135.04V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H544a32 32 0 0 0-32 32zM743.68 640H280.32l32.128 256h399.104z"
      })
    ]));
  }
});

// src/components/ice-drink.vue
var ice_drink_default = ice_drink_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/ice-tea.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent142 } from "vue";
import { createElementVNode as _createElementVNode142, openBlock as _openBlock142, createElementBlock as _createElementBlock142 } from "vue";
var ice_tea_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent142({
  name: "IceTea",
  __name: "ice-tea",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock142(), _createElementBlock142("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode142("path", {
        fill: "currentColor",
        d: "M197.696 259.648a320.128 320.128 0 0 1 628.608 0A96 96 0 0 1 896 352v64a96 96 0 0 1-71.616 92.864l-49.408 395.072A64 64 0 0 1 711.488 960H312.512a64 64 0 0 1-63.488-56.064l-49.408-395.072A96 96 0 0 1 128 416v-64a96 96 0 0 1 69.696-92.352M264.064 256h495.872a256.128 256.128 0 0 0-495.872 0m495.424 256H264.512l48 384h398.976zM224 448h576a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H224a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32m160 192h64v64h-64zm192 64h64v64h-64zm-128 64h64v64h-64zm64-192h64v64h-64z"
      })
    ]));
  }
});

// src/components/ice-tea.vue
var ice_tea_default = ice_tea_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/info-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent143 } from "vue";
import { createElementVNode as _createElementVNode143, openBlock as _openBlock143, createElementBlock as _createElementBlock143 } from "vue";
var info_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent143({
  name: "InfoFilled",
  __name: "info-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock143(), _createElementBlock143("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode143("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64m67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344M590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"
      })
    ]));
  }
});

// src/components/info-filled.vue
var info_filled_default = info_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/iphone.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent144 } from "vue";
import { createElementVNode as _createElementVNode144, openBlock as _openBlock144, createElementBlock as _createElementBlock144 } from "vue";
var iphone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent144({
  name: "Iphone",
  __name: "iphone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock144(), _createElementBlock144("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode144("path", {
        fill: "currentColor",
        d: "M224 768v96.064a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V768zm0-64h576V160a64 64 0 0 0-64-64H288a64 64 0 0 0-64 64zm32 288a96 96 0 0 1-96-96V128a96 96 0 0 1 96-96h512a96 96 0 0 1 96 96v768a96 96 0 0 1-96 96zm304-144a48 48 0 1 1-96 0 48 48 0 0 1 96 0"
      })
    ]));
  }
});

// src/components/iphone.vue
var iphone_default = iphone_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/key.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent145 } from "vue";
import { createElementVNode as _createElementVNode145, openBlock as _openBlock145, createElementBlock as _createElementBlock145 } from "vue";
var key_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent145({
  name: "Key",
  __name: "key",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock145(), _createElementBlock145("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode145("path", {
        fill: "currentColor",
        d: "M448 456.064V96a32 32 0 0 1 32-32.064L672 64a32 32 0 0 1 0 64H512v128h160a32 32 0 0 1 0 64H512v128a256 256 0 1 1-64 8.064M512 896a192 192 0 1 0 0-384 192 192 0 0 0 0 384"
      })
    ]));
  }
});

// src/components/key.vue
var key_default = key_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/knife-fork.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent146 } from "vue";
import { createElementVNode as _createElementVNode146, openBlock as _openBlock146, createElementBlock as _createElementBlock146 } from "vue";
var knife_fork_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent146({
  name: "KnifeFork",
  __name: "knife-fork",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock146(), _createElementBlock146("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode146("path", {
        fill: "currentColor",
        d: "M256 410.56V96a32 32 0 0 1 64 0v314.56A96 96 0 0 0 384 320V96a32 32 0 0 1 64 0v224a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.8A160 160 0 0 1 128 320V96a32 32 0 0 1 64 0v224a96 96 0 0 0 64 90.56m384-250.24V544h126.72c-3.328-78.72-12.928-147.968-28.608-207.744-14.336-54.528-46.848-113.344-98.112-175.872zM640 608v320a32 32 0 1 1-64 0V64h64c85.312 89.472 138.688 174.848 160 256 21.312 81.152 32 177.152 32 288z"
      })
    ]));
  }
});

// src/components/knife-fork.vue
var knife_fork_default = knife_fork_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/lightning.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent147 } from "vue";
import { createElementVNode as _createElementVNode147, openBlock as _openBlock147, createElementBlock as _createElementBlock147 } from "vue";
var lightning_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent147({
  name: "Lightning",
  __name: "lightning",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock147(), _createElementBlock147("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode147("path", {
        fill: "currentColor",
        d: "M288 671.36v64.128A239.808 239.808 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 736 734.016v-64.768a192 192 0 0 0 3.328-377.92l-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 91.968 70.464 167.36 160.256 175.232z"
      }),
      _createElementVNode147("path", {
        fill: "currentColor",
        d: "M416 736a32 32 0 0 1-27.776-47.872l128-224a32 32 0 1 1 55.552 31.744L471.168 672H608a32 32 0 0 1 27.776 47.872l-128 224a32 32 0 1 1-55.68-31.744L552.96 736z"
      })
    ]));
  }
});

// src/components/lightning.vue
var lightning_default = lightning_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/link.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent148 } from "vue";
import { createElementVNode as _createElementVNode148, openBlock as _openBlock148, createElementBlock as _createElementBlock148 } from "vue";
var link_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent148({
  name: "Link",
  __name: "link",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock148(), _createElementBlock148("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode148("path", {
        fill: "currentColor",
        d: "M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152z"
      })
    ]));
  }
});

// src/components/link.vue
var link_default = link_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/list.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent149 } from "vue";
import { createElementVNode as _createElementVNode149, openBlock as _openBlock149, createElementBlock as _createElementBlock149 } from "vue";
var list_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent149({
  name: "List",
  __name: "list",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock149(), _createElementBlock149("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode149("path", {
        fill: "currentColor",
        d: "M704 192h160v736H160V192h160v64h384zM288 512h448v-64H288zm0 256h448v-64H288zm96-576V96h256v96z"
      })
    ]));
  }
});

// src/components/list.vue
var list_default = list_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/loading.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent150 } from "vue";
import { createElementVNode as _createElementVNode150, openBlock as _openBlock150, createElementBlock as _createElementBlock150 } from "vue";
var loading_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent150({
  name: "Loading",
  __name: "loading",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock150(), _createElementBlock150("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode150("path", {
        fill: "currentColor",
        d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
      })
    ]));
  }
});

// src/components/loading.vue
var loading_default = loading_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/location-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent151 } from "vue";
import { createElementVNode as _createElementVNode151, openBlock as _openBlock151, createElementBlock as _createElementBlock151 } from "vue";
var location_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent151({
  name: "LocationFilled",
  __name: "location-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock151(), _createElementBlock151("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode151("path", {
        fill: "currentColor",
        d: "M512 928c23.936 0 117.504-68.352 192.064-153.152C803.456 661.888 864 535.808 864 416c0-189.632-155.84-320-352-320S160 226.368 160 416c0 120.32 60.544 246.4 159.936 359.232C394.432 859.84 488 928 512 928m0-435.2a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 140.8a204.8 204.8 0 1 1 0-409.6 204.8 204.8 0 0 1 0 409.6"
      })
    ]));
  }
});

// src/components/location-filled.vue
var location_filled_default = location_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/location-information.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent152 } from "vue";
import { createElementVNode as _createElementVNode152, openBlock as _openBlock152, createElementBlock as _createElementBlock152 } from "vue";
var location_information_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent152({
  name: "LocationInformation",
  __name: "location-information",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock152(), _createElementBlock152("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode152("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      _createElementVNode152("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      _createElementVNode152("path", {
        fill: "currentColor",
        d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
      })
    ]));
  }
});

// src/components/location-information.vue
var location_information_default = location_information_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/location.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent153 } from "vue";
import { createElementVNode as _createElementVNode153, openBlock as _openBlock153, createElementBlock as _createElementBlock153 } from "vue";
var location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent153({
  name: "Location",
  __name: "location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock153(), _createElementBlock153("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode153("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      _createElementVNode153("path", {
        fill: "currentColor",
        d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
      })
    ]));
  }
});

// src/components/location.vue
var location_default = location_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/lock.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent154 } from "vue";
import { createElementVNode as _createElementVNode154, openBlock as _openBlock154, createElementBlock as _createElementBlock154 } from "vue";
var lock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent154({
  name: "Lock",
  __name: "lock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock154(), _createElementBlock154("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode154("path", {
        fill: "currentColor",
        d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
      }),
      _createElementVNode154("path", {
        fill: "currentColor",
        d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m192-160v-64a192 192 0 1 0-384 0v64zM512 64a256 256 0 0 1 256 256v128H256V320A256 256 0 0 1 512 64"
      })
    ]));
  }
});

// src/components/lock.vue
var lock_default = lock_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/lollipop.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent155 } from "vue";
import { createElementVNode as _createElementVNode155, openBlock as _openBlock155, createElementBlock as _createElementBlock155 } from "vue";
var lollipop_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent155({
  name: "Lollipop",
  __name: "lollipop",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock155(), _createElementBlock155("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode155("path", {
        fill: "currentColor",
        d: "M513.28 448a64 64 0 1 1 76.544 49.728A96 96 0 0 0 768 448h64a160 160 0 0 1-320 0zm-126.976-29.696a256 256 0 1 0 43.52-180.48A256 256 0 0 1 832 448h-64a192 192 0 0 0-381.696-29.696m105.664 249.472L285.696 874.048a96 96 0 0 1-135.68-135.744l206.208-206.272a320 320 0 1 1 135.744 135.744zm-54.464-36.032a321.92 321.92 0 0 1-45.248-45.248L195.2 783.552a32 32 0 1 0 45.248 45.248l197.056-197.12z"
      })
    ]));
  }
});

// src/components/lollipop.vue
var lollipop_default = lollipop_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/magic-stick.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent156 } from "vue";
import { createElementVNode as _createElementVNode156, openBlock as _openBlock156, createElementBlock as _createElementBlock156 } from "vue";
var magic_stick_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent156({
  name: "MagicStick",
  __name: "magic-stick",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock156(), _createElementBlock156("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode156("path", {
        fill: "currentColor",
        d: "M512 64h64v192h-64zm0 576h64v192h-64zM160 480v-64h192v64zm576 0v-64h192v64zM249.856 199.04l45.248-45.184L430.848 289.6 385.6 334.848 249.856 199.104zM657.152 606.4l45.248-45.248 135.744 135.744-45.248 45.248zM114.048 923.2 68.8 877.952l316.8-316.8 45.248 45.248zM702.4 334.848 657.152 289.6l135.744-135.744 45.248 45.248z"
      })
    ]));
  }
});

// src/components/magic-stick.vue
var magic_stick_default = magic_stick_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/magnet.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent157 } from "vue";
import { createElementVNode as _createElementVNode157, openBlock as _openBlock157, createElementBlock as _createElementBlock157 } from "vue";
var magnet_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent157({
  name: "Magnet",
  __name: "magnet",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock157(), _createElementBlock157("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode157("path", {
        fill: "currentColor",
        d: "M832 320V192H704v320a192 192 0 1 1-384 0V192H192v128h128v64H192v128a320 320 0 0 0 640 0V384H704v-64zM640 512V128h256v384a384 384 0 1 1-768 0V128h256v384a128 128 0 1 0 256 0"
      })
    ]));
  }
});

// src/components/magnet.vue
var magnet_default = magnet_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/male.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent158 } from "vue";
import { createElementVNode as _createElementVNode158, openBlock as _openBlock158, createElementBlock as _createElementBlock158 } from "vue";
var male_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent158({
  name: "Male",
  __name: "male",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock158(), _createElementBlock158("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode158("path", {
        fill: "currentColor",
        d: "M399.5 849.5a225 225 0 1 0 0-450 225 225 0 0 0 0 450m0 56.25a281.25 281.25 0 1 1 0-562.5 281.25 281.25 0 0 1 0 562.5m253.125-787.5h225q28.125 0 28.125 28.125T877.625 174.5h-225q-28.125 0-28.125-28.125t28.125-28.125"
      }),
      _createElementVNode158("path", {
        fill: "currentColor",
        d: "M877.625 118.25q28.125 0 28.125 28.125v225q0 28.125-28.125 28.125T849.5 371.375v-225q0-28.125 28.125-28.125"
      }),
      _createElementVNode158("path", {
        fill: "currentColor",
        d: "M604.813 458.9 565.1 419.131l292.613-292.668 39.825 39.824z"
      })
    ]));
  }
});

// src/components/male.vue
var male_default = male_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/management.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent159 } from "vue";
import { createElementVNode as _createElementVNode159, openBlock as _openBlock159, createElementBlock as _createElementBlock159 } from "vue";
var management_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent159({
  name: "Management",
  __name: "management",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock159(), _createElementBlock159("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode159("path", {
        fill: "currentColor",
        d: "M576 128v288l96-96 96 96V128h128v768H320V128zm-448 0h128v768H128z"
      })
    ]));
  }
});

// src/components/management.vue
var management_default = management_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/map-location.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent160 } from "vue";
import { createElementVNode as _createElementVNode160, openBlock as _openBlock160, createElementBlock as _createElementBlock160 } from "vue";
var map_location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent160({
  name: "MapLocation",
  __name: "map-location",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock160(), _createElementBlock160("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode160("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      _createElementVNode160("path", {
        fill: "currentColor",
        d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256m345.6 192L960 960H672v-64H352v64H64l102.4-256zm-68.928 0H235.328l-76.8 192h706.944z"
      })
    ]));
  }
});

// src/components/map-location.vue
var map_location_default = map_location_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/medal.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent161 } from "vue";
import { createElementVNode as _createElementVNode161, openBlock as _openBlock161, createElementBlock as _createElementBlock161 } from "vue";
var medal_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent161({
  name: "Medal",
  __name: "medal",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock161(), _createElementBlock161("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode161("path", {
        fill: "currentColor",
        d: "M512 896a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      _createElementVNode161("path", {
        fill: "currentColor",
        d: "M576 128H448v200a286.72 286.72 0 0 1 64-8c19.52 0 40.832 2.688 64 8zm64 0v219.648c24.448 9.088 50.56 20.416 78.4 33.92L757.44 128zm-256 0H266.624l39.04 253.568c27.84-13.504 53.888-24.832 78.336-33.92V128zM229.312 64h565.376a32 32 0 0 1 31.616 36.864L768 480c-113.792-64-199.104-96-256-96-56.896 0-142.208 32-256 96l-58.304-379.136A32 32 0 0 1 229.312 64"
      })
    ]));
  }
});

// src/components/medal.vue
var medal_default = medal_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/memo.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent162 } from "vue";
import { createElementVNode as _createElementVNode162, openBlock as _openBlock162, createElementBlock as _createElementBlock162 } from "vue";
var memo_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent162({
  name: "Memo",
  __name: "memo",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock162(), _createElementBlock162("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode162("path", {
        fill: "currentColor",
        d: "M480 320h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32"
      }),
      _createElementVNode162("path", {
        fill: "currentColor",
        d: "M887.01 72.99C881.01 67 873.34 64 864 64H160c-9.35 0-17.02 3-23.01 8.99C131 78.99 128 86.66 128 96v832c0 9.35 2.99 17.02 8.99 23.01S150.66 960 160 960h704c9.35 0 17.02-2.99 23.01-8.99S896 937.34 896 928V96c0-9.35-3-17.02-8.99-23.01M192 896V128h96v768zm640 0H352V128h480z"
      }),
      _createElementVNode162("path", {
        fill: "currentColor",
        d: "M480 512h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32m0 192h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32"
      })
    ]));
  }
});

// src/components/memo.vue
var memo_default = memo_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/menu.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent163 } from "vue";
import { createElementVNode as _createElementVNode163, openBlock as _openBlock163, createElementBlock as _createElementBlock163 } from "vue";
var menu_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent163({
  name: "Menu",
  __name: "menu",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock163(), _createElementBlock163("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode163("path", {
        fill: "currentColor",
        d: "M160 448a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32zM160 896a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32z"
      })
    ]));
  }
});

// src/components/menu.vue
var menu_default = menu_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/message-box.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent164 } from "vue";
import { createElementVNode as _createElementVNode164, openBlock as _openBlock164, createElementBlock as _createElementBlock164 } from "vue";
var message_box_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent164({
  name: "MessageBox",
  __name: "message-box",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock164(), _createElementBlock164("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode164("path", {
        fill: "currentColor",
        d: "M288 384h448v64H288zm96-128h256v64H384zM131.456 512H384v128h256V512h252.544L721.856 192H302.144zM896 576H704v128H320V576H128v256h768zM275.776 128h472.448a32 32 0 0 1 28.608 17.664l179.84 359.552A32 32 0 0 1 960 519.552V864a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V519.552a32 32 0 0 1 3.392-14.336l179.776-359.552A32 32 0 0 1 275.776 128z"
      })
    ]));
  }
});

// src/components/message-box.vue
var message_box_default = message_box_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/message.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent165 } from "vue";
import { createElementVNode as _createElementVNode165, openBlock as _openBlock165, createElementBlock as _createElementBlock165 } from "vue";
var message_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent165({
  name: "Message",
  __name: "message",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock165(), _createElementBlock165("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode165("path", {
        fill: "currentColor",
        d: "M128 224v512a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V224zm0-64h768a64 64 0 0 1 64 64v512a128 128 0 0 1-128 128H192A128 128 0 0 1 64 736V224a64 64 0 0 1 64-64"
      }),
      _createElementVNode165("path", {
        fill: "currentColor",
        d: "M904 224 656.512 506.88a192 192 0 0 1-289.024 0L120 224zm-698.944 0 210.56 240.704a128 128 0 0 0 192.704 0L818.944 224H205.056"
      })
    ]));
  }
});

// src/components/message.vue
var message_default = message_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/mic.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent166 } from "vue";
import { createElementVNode as _createElementVNode166, openBlock as _openBlock166, createElementBlock as _createElementBlock166 } from "vue";
var mic_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent166({
  name: "Mic",
  __name: "mic",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock166(), _createElementBlock166("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode166("path", {
        fill: "currentColor",
        d: "M480 704h160a64 64 0 0 0 64-64v-32h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-32a64 64 0 0 0-64-64H384a64 64 0 0 0-64 64v32h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v32a64 64 0 0 0 64 64zm64 64v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768h-96a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64h256a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128z"
      })
    ]));
  }
});

// src/components/mic.vue
var mic_default = mic_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/microphone.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent167 } from "vue";
import { createElementVNode as _createElementVNode167, openBlock as _openBlock167, createElementBlock as _createElementBlock167 } from "vue";
var microphone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent167({
  name: "Microphone",
  __name: "microphone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock167(), _createElementBlock167("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode167("path", {
        fill: "currentColor",
        d: "M512 128a128 128 0 0 0-128 128v256a128 128 0 1 0 256 0V256a128 128 0 0 0-128-128m0-64a192 192 0 0 1 192 192v256a192 192 0 1 1-384 0V256A192 192 0 0 1 512 64m-32 832v-64a288 288 0 0 1-288-288v-32a32 32 0 0 1 64 0v32a224 224 0 0 0 224 224h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64z"
      })
    ]));
  }
});

// src/components/microphone.vue
var microphone_default = microphone_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/milk-tea.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent168 } from "vue";
import { createElementVNode as _createElementVNode168, openBlock as _openBlock168, createElementBlock as _createElementBlock168 } from "vue";
var milk_tea_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent168({
  name: "MilkTea",
  __name: "milk-tea",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock168(), _createElementBlock168("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode168("path", {
        fill: "currentColor",
        d: "M416 128V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H512a32 32 0 0 0-32 32v32h320a96 96 0 0 1 11.712 191.296l-39.68 581.056A64 64 0 0 1 708.224 960H315.776a64 64 0 0 1-63.872-59.648l-39.616-581.056A96 96 0 0 1 224 128zM276.48 320l39.296 576h392.448l4.8-70.784a224.064 224.064 0 0 1 30.016-439.808L747.52 320zM224 256h576a32 32 0 1 0 0-64H224a32 32 0 0 0 0 64m493.44 503.872 21.12-309.12a160 160 0 0 0-21.12 309.12"
      })
    ]));
  }
});

// src/components/milk-tea.vue
var milk_tea_default = milk_tea_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/minus.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent169 } from "vue";
import { createElementVNode as _createElementVNode169, openBlock as _openBlock169, createElementBlock as _createElementBlock169 } from "vue";
var minus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent169({
  name: "Minus",
  __name: "minus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock169(), _createElementBlock169("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode169("path", {
        fill: "currentColor",
        d: "M128 544h768a32 32 0 1 0 0-64H128a32 32 0 0 0 0 64"
      })
    ]));
  }
});

// src/components/minus.vue
var minus_default = minus_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/money.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent170 } from "vue";
import { createElementVNode as _createElementVNode170, openBlock as _openBlock170, createElementBlock as _createElementBlock170 } from "vue";
var money_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent170({
  name: "Money",
  __name: "money",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock170(), _createElementBlock170("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode170("path", {
        fill: "currentColor",
        d: "M256 640v192h640V384H768v-64h150.976c14.272 0 19.456 1.472 24.64 4.288a29.056 29.056 0 0 1 12.16 12.096c2.752 5.184 4.224 10.368 4.224 24.64v493.952c0 14.272-1.472 19.456-4.288 24.64a29.056 29.056 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H233.024c-14.272 0-19.456-1.472-24.64-4.288a29.056 29.056 0 0 1-12.16-12.096c-2.688-5.184-4.224-10.368-4.224-24.576V640z"
      }),
      _createElementVNode170("path", {
        fill: "currentColor",
        d: "M768 192H128v448h640zm64-22.976v493.952c0 14.272-1.472 19.456-4.288 24.64a29.056 29.056 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H105.024c-14.272 0-19.456-1.472-24.64-4.288a29.056 29.056 0 0 1-12.16-12.096C65.536 682.432 64 677.248 64 663.04V169.024c0-14.272 1.472-19.456 4.288-24.64a29.056 29.056 0 0 1 12.096-12.16C85.568 129.536 90.752 128 104.96 128h685.952c14.272 0 19.456 1.472 24.64 4.288a29.056 29.056 0 0 1 12.16 12.096c2.752 5.184 4.224 10.368 4.224 24.64z"
      }),
      _createElementVNode170("path", {
        fill: "currentColor",
        d: "M448 576a160 160 0 1 1 0-320 160 160 0 0 1 0 320m0-64a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
      })
    ]));
  }
});

// src/components/money.vue
var money_default = money_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/monitor.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent171 } from "vue";
import { createElementVNode as _createElementVNode171, openBlock as _openBlock171, createElementBlock as _createElementBlock171 } from "vue";
var monitor_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent171({
  name: "Monitor",
  __name: "monitor",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock171(), _createElementBlock171("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode171("path", {
        fill: "currentColor",
        d: "M544 768v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768H192A128 128 0 0 1 64 640V256a128 128 0 0 1 128-128h640a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128zM192 192a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64z"
      })
    ]));
  }
});

// src/components/monitor.vue
var monitor_default = monitor_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/moon-night.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent172 } from "vue";
import { createElementVNode as _createElementVNode172, openBlock as _openBlock172, createElementBlock as _createElementBlock172 } from "vue";
var moon_night_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent172({
  name: "MoonNight",
  __name: "moon-night",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock172(), _createElementBlock172("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode172("path", {
        fill: "currentColor",
        d: "M384 512a448 448 0 0 1 215.872-383.296A384 384 0 0 0 213.76 640h188.8A448.256 448.256 0 0 1 384 512M171.136 704a448 448 0 0 1 636.992-575.296A384 384 0 0 0 499.328 704h-328.32z"
      }),
      _createElementVNode172("path", {
        fill: "currentColor",
        d: "M32 640h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m128 128h384a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m160 127.68 224 .256a32 32 0 0 1 32 32V928a32 32 0 0 1-32 32l-224-.384a32 32 0 0 1-32-32v-.064a32 32 0 0 1 32-32z"
      })
    ]));
  }
});

// src/components/moon-night.vue
var moon_night_default = moon_night_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/moon.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent173 } from "vue";
import { createElementVNode as _createElementVNode173, openBlock as _openBlock173, createElementBlock as _createElementBlock173 } from "vue";
var moon_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent173({
  name: "Moon",
  __name: "moon",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock173(), _createElementBlock173("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode173("path", {
        fill: "currentColor",
        d: "M240.448 240.448a384 384 0 1 0 559.424 525.696 448 448 0 0 1-542.016-542.08 390.592 390.592 0 0 0-17.408 16.384zm181.056 362.048a384 384 0 0 0 525.632 16.384A448 448 0 1 1 405.056 76.8a384 384 0 0 0 16.448 525.696"
      })
    ]));
  }
});

// src/components/moon.vue
var moon_default = moon_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/more-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent174 } from "vue";
import { createElementVNode as _createElementVNode174, openBlock as _openBlock174, createElementBlock as _createElementBlock174 } from "vue";
var more_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent174({
  name: "MoreFilled",
  __name: "more-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock174(), _createElementBlock174("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode174("path", {
        fill: "currentColor",
        d: "M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224"
      })
    ]));
  }
});

// src/components/more-filled.vue
var more_filled_default = more_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/more.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent175 } from "vue";
import { createElementVNode as _createElementVNode175, openBlock as _openBlock175, createElementBlock as _createElementBlock175 } from "vue";
var more_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent175({
  name: "More",
  __name: "more",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock175(), _createElementBlock175("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode175("path", {
        fill: "currentColor",
        d: "M176 416a112 112 0 1 0 0 224 112 112 0 0 0 0-224m0 64a48 48 0 1 1 0 96 48 48 0 0 1 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96"
      })
    ]));
  }
});

// src/components/more.vue
var more_default = more_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/mostly-cloudy.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent176 } from "vue";
import { createElementVNode as _createElementVNode176, openBlock as _openBlock176, createElementBlock as _createElementBlock176 } from "vue";
var mostly_cloudy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent176({
  name: "MostlyCloudy",
  __name: "mostly-cloudy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock176(), _createElementBlock176("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode176("path", {
        fill: "currentColor",
        d: "M737.216 357.952 704 349.824l-11.776-32a192.064 192.064 0 0 0-367.424 23.04l-8.96 39.04-39.04 8.96A192.064 192.064 0 0 0 320 768h368a207.808 207.808 0 0 0 207.808-208 208.32 208.32 0 0 0-158.592-202.048m15.168-62.208A272.32 272.32 0 0 1 959.744 560a271.808 271.808 0 0 1-271.552 272H320a256 256 0 0 1-57.536-505.536 256.128 256.128 0 0 1 489.92-30.72"
      })
    ]));
  }
});

// src/components/mostly-cloudy.vue
var mostly_cloudy_default = mostly_cloudy_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/mouse.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent177 } from "vue";
import { createElementVNode as _createElementVNode177, openBlock as _openBlock177, createElementBlock as _createElementBlock177 } from "vue";
var mouse_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent177({
  name: "Mouse",
  __name: "mouse",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock177(), _createElementBlock177("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode177("path", {
        fill: "currentColor",
        d: "M438.144 256c-68.352 0-92.736 4.672-117.76 18.112-20.096 10.752-35.52 26.176-46.272 46.272C260.672 345.408 256 369.792 256 438.144v275.712c0 68.352 4.672 92.736 18.112 117.76 10.752 20.096 26.176 35.52 46.272 46.272C345.408 891.328 369.792 896 438.144 896h147.712c68.352 0 92.736-4.672 117.76-18.112 20.096-10.752 35.52-26.176 46.272-46.272C763.328 806.592 768 782.208 768 713.856V438.144c0-68.352-4.672-92.736-18.112-117.76a110.464 110.464 0 0 0-46.272-46.272C678.592 260.672 654.208 256 585.856 256zm0-64h147.712c85.568 0 116.608 8.96 147.904 25.6 31.36 16.768 55.872 41.344 72.576 72.64C823.104 321.536 832 352.576 832 438.08v275.84c0 85.504-8.96 116.544-25.6 147.84a174.464 174.464 0 0 1-72.64 72.576C702.464 951.104 671.424 960 585.92 960H438.08c-85.504 0-116.544-8.96-147.84-25.6a174.464 174.464 0 0 1-72.64-72.704c-16.768-31.296-25.664-62.336-25.664-147.84v-275.84c0-85.504 8.96-116.544 25.6-147.84a174.464 174.464 0 0 1 72.768-72.576c31.232-16.704 62.272-25.6 147.776-25.6z"
      }),
      _createElementVNode177("path", {
        fill: "currentColor",
        d: "M512 320q32 0 32 32v128q0 32-32 32t-32-32V352q0-32 32-32m32-96a32 32 0 0 1-64 0v-64a32 32 0 0 0-32-32h-96a32 32 0 0 1 0-64h96a96 96 0 0 1 96 96z"
      })
    ]));
  }
});

// src/components/mouse.vue
var mouse_default = mouse_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/mug.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent178 } from "vue";
import { createElementVNode as _createElementVNode178, openBlock as _openBlock178, createElementBlock as _createElementBlock178 } from "vue";
var mug_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent178({
  name: "Mug",
  __name: "mug",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock178(), _createElementBlock178("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode178("path", {
        fill: "currentColor",
        d: "M736 800V160H160v640a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64m64-544h63.552a96 96 0 0 1 96 96v224a96 96 0 0 1-96 96H800v128a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V128a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v288h63.552a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32z"
      })
    ]));
  }
});

// src/components/mug.vue
var mug_default = mug_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/mute-notification.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent179 } from "vue";
import { createElementVNode as _createElementVNode179, openBlock as _openBlock179, createElementBlock as _createElementBlock179 } from "vue";
var mute_notification_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent179({
  name: "MuteNotification",
  __name: "mute-notification",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock179(), _createElementBlock179("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode179("path", {
        fill: "currentColor",
        d: "m241.216 832 63.616-64H768V448c0-42.368-10.24-82.304-28.48-117.504l46.912-47.232C815.36 331.392 832 387.84 832 448v320h96a32 32 0 1 1 0 64zm-90.24 0H96a32 32 0 1 1 0-64h96V448a320.128 320.128 0 0 1 256-313.6V128a64 64 0 1 1 128 0v6.4a319.552 319.552 0 0 1 171.648 97.088l-45.184 45.44A256 256 0 0 0 256 448v278.336L151.04 832zM448 896h128a64 64 0 0 1-128 0"
      }),
      _createElementVNode179("path", {
        fill: "currentColor",
        d: "M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056l-704 708.544z"
      })
    ]));
  }
});

// src/components/mute-notification.vue
var mute_notification_default = mute_notification_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/mute.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent180 } from "vue";
import { createElementVNode as _createElementVNode180, openBlock as _openBlock180, createElementBlock as _createElementBlock180 } from "vue";
var mute_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent180({
  name: "Mute",
  __name: "mute",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock180(), _createElementBlock180("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode180("path", {
        fill: "currentColor",
        d: "m412.16 592.128-45.44 45.44A191.232 191.232 0 0 1 320 512V256a192 192 0 1 1 384 0v44.352l-64 64V256a128 128 0 1 0-256 0v256c0 30.336 10.56 58.24 28.16 80.128m51.968 38.592A128 128 0 0 0 640 512v-57.152l64-64V512a192 192 0 0 1-287.68 166.528zM314.88 779.968l46.144-46.08A222.976 222.976 0 0 0 480 768h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64h64v-64c-61.44 0-118.4-19.2-165.12-52.032M266.752 737.6A286.976 286.976 0 0 1 192 544v-32a32 32 0 0 1 64 0v32c0 56.832 21.184 108.8 56.064 148.288z"
      }),
      _createElementVNode180("path", {
        fill: "currentColor",
        d: "M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056l-704 708.544z"
      })
    ]));
  }
});

// src/components/mute.vue
var mute_default = mute_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/no-smoking.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent181 } from "vue";
import { createElementVNode as _createElementVNode181, openBlock as _openBlock181, createElementBlock as _createElementBlock181 } from "vue";
var no_smoking_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent181({
  name: "NoSmoking",
  __name: "no-smoking",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock181(), _createElementBlock181("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode181("path", {
        fill: "currentColor",
        d: "M440.256 576H256v128h56.256l-64 64H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32h280.256zm143.488 128H704V583.744L775.744 512H928a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H519.744zM768 576v128h128V576zm-29.696-207.552 45.248 45.248-497.856 497.856-45.248-45.248zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
      })
    ]));
  }
});

// src/components/no-smoking.vue
var no_smoking_default = no_smoking_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/notebook.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent182 } from "vue";
import { createElementVNode as _createElementVNode182, openBlock as _openBlock182, createElementBlock as _createElementBlock182 } from "vue";
var notebook_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent182({
  name: "Notebook",
  __name: "notebook",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock182(), _createElementBlock182("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode182("path", {
        fill: "currentColor",
        d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      _createElementVNode182("path", {
        fill: "currentColor",
        d: "M672 128h64v768h-64zM96 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/notebook.vue
var notebook_default = notebook_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/notification.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent183 } from "vue";
import { createElementVNode as _createElementVNode183, openBlock as _openBlock183, createElementBlock as _createElementBlock183 } from "vue";
var notification_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent183({
  name: "Notification",
  __name: "notification",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock183(), _createElementBlock183("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode183("path", {
        fill: "currentColor",
        d: "M512 128v64H256a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V512h64v256a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V256a128 128 0 0 1 128-128z"
      }),
      _createElementVNode183("path", {
        fill: "currentColor",
        d: "M768 384a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      })
    ]));
  }
});

// src/components/notification.vue
var notification_default = notification_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/odometer.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent184 } from "vue";
import { createElementVNode as _createElementVNode184, openBlock as _openBlock184, createElementBlock as _createElementBlock184 } from "vue";
var odometer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent184({
  name: "Odometer",
  __name: "odometer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock184(), _createElementBlock184("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode184("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode184("path", {
        fill: "currentColor",
        d: "M192 512a320 320 0 1 1 640 0 32 32 0 1 1-64 0 256 256 0 1 0-512 0 32 32 0 0 1-64 0"
      }),
      _createElementVNode184("path", {
        fill: "currentColor",
        d: "M570.432 627.84A96 96 0 1 1 509.568 608l60.992-187.776A32 32 0 1 1 631.424 440l-60.992 187.776zM502.08 734.464a32 32 0 1 0 19.84-60.928 32 32 0 0 0-19.84 60.928"
      })
    ]));
  }
});

// src/components/odometer.vue
var odometer_default = odometer_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/office-building.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent185 } from "vue";
import { createElementVNode as _createElementVNode185, openBlock as _openBlock185, createElementBlock as _createElementBlock185 } from "vue";
var office_building_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent185({
  name: "OfficeBuilding",
  __name: "office-building",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock185(), _createElementBlock185("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode185("path", {
        fill: "currentColor",
        d: "M192 128v704h384V128zm-32-64h448a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      _createElementVNode185("path", {
        fill: "currentColor",
        d: "M256 256h256v64H256zm0 192h256v64H256zm0 192h256v64H256zm384-128h128v64H640zm0 128h128v64H640zM64 832h896v64H64z"
      }),
      _createElementVNode185("path", {
        fill: "currentColor",
        d: "M640 384v448h192V384zm-32-64h256a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H608a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32"
      })
    ]));
  }
});

// src/components/office-building.vue
var office_building_default = office_building_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/open.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent186 } from "vue";
import { createElementVNode as _createElementVNode186, openBlock as _openBlock186, createElementBlock as _createElementBlock186 } from "vue";
var open_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent186({
  name: "Open",
  __name: "open",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock186(), _createElementBlock186("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode186("path", {
        fill: "currentColor",
        d: "M329.956 257.138a254.862 254.862 0 0 0 0 509.724h364.088a254.862 254.862 0 0 0 0-509.724zm0-72.818h364.088a327.68 327.68 0 1 1 0 655.36H329.956a327.68 327.68 0 1 1 0-655.36z"
      }),
      _createElementVNode186("path", {
        fill: "currentColor",
        d: "M694.044 621.227a109.227 109.227 0 1 0 0-218.454 109.227 109.227 0 0 0 0 218.454m0 72.817a182.044 182.044 0 1 1 0-364.088 182.044 182.044 0 0 1 0 364.088"
      })
    ]));
  }
});

// src/components/open.vue
var open_default = open_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/operation.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent187 } from "vue";
import { createElementVNode as _createElementVNode187, openBlock as _openBlock187, createElementBlock as _createElementBlock187 } from "vue";
var operation_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent187({
  name: "Operation",
  __name: "operation",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock187(), _createElementBlock187("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode187("path", {
        fill: "currentColor",
        d: "M389.44 768a96.064 96.064 0 0 1 181.12 0H896v64H570.56a96.064 96.064 0 0 1-181.12 0H128v-64zm192-288a96.064 96.064 0 0 1 181.12 0H896v64H762.56a96.064 96.064 0 0 1-181.12 0H128v-64zm-320-288a96.064 96.064 0 0 1 181.12 0H896v64H442.56a96.064 96.064 0 0 1-181.12 0H128v-64z"
      })
    ]));
  }
});

// src/components/operation.vue
var operation_default = operation_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/opportunity.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent188 } from "vue";
import { createElementVNode as _createElementVNode188, openBlock as _openBlock188, createElementBlock as _createElementBlock188 } from "vue";
var opportunity_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent188({
  name: "Opportunity",
  __name: "opportunity",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock188(), _createElementBlock188("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode188("path", {
        fill: "currentColor",
        d: "M384 960v-64h192.064v64zm448-544a350.656 350.656 0 0 1-128.32 271.424C665.344 719.04 640 763.776 640 813.504V832H320v-14.336c0-48-19.392-95.36-57.216-124.992a351.552 351.552 0 0 1-128.448-344.256c25.344-136.448 133.888-248.128 269.76-276.48A352.384 352.384 0 0 1 832 416m-544 32c0-132.288 75.904-224 192-224v-64c-154.432 0-256 122.752-256 288z"
      })
    ]));
  }
});

// src/components/opportunity.vue
var opportunity_default = opportunity_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/orange.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent189 } from "vue";
import { createElementVNode as _createElementVNode189, openBlock as _openBlock189, createElementBlock as _createElementBlock189 } from "vue";
var orange_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent189({
  name: "Orange",
  __name: "orange",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock189(), _createElementBlock189("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode189("path", {
        fill: "currentColor",
        d: "M544 894.72a382.336 382.336 0 0 0 215.936-89.472L577.024 622.272c-10.24 6.016-21.248 10.688-33.024 13.696v258.688zm261.248-134.784A382.336 382.336 0 0 0 894.656 544H635.968c-3.008 11.776-7.68 22.848-13.696 33.024l182.976 182.912zM894.656 480a382.336 382.336 0 0 0-89.408-215.936L622.272 446.976c6.016 10.24 10.688 21.248 13.696 33.024h258.688zm-134.72-261.248A382.336 382.336 0 0 0 544 129.344v258.688c11.776 3.008 22.848 7.68 33.024 13.696zM480 129.344a382.336 382.336 0 0 0-215.936 89.408l182.912 182.976c10.24-6.016 21.248-10.688 33.024-13.696zm-261.248 134.72A382.336 382.336 0 0 0 129.344 480h258.688c3.008-11.776 7.68-22.848 13.696-33.024zM129.344 544a382.336 382.336 0 0 0 89.408 215.936l182.976-182.912A127.232 127.232 0 0 1 388.032 544zm134.72 261.248A382.336 382.336 0 0 0 480 894.656V635.968a127.232 127.232 0 0 1-33.024-13.696zM512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-384a64 64 0 1 0 0-128 64 64 0 0 0 0 128"
      })
    ]));
  }
});

// src/components/orange.vue
var orange_default = orange_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/paperclip.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent190 } from "vue";
import { createElementVNode as _createElementVNode190, openBlock as _openBlock190, createElementBlock as _createElementBlock190 } from "vue";
var paperclip_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent190({
  name: "Paperclip",
  __name: "paperclip",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock190(), _createElementBlock190("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode190("path", {
        fill: "currentColor",
        d: "M602.496 240.448A192 192 0 1 1 874.048 512l-316.8 316.8A256 256 0 0 1 195.2 466.752L602.496 59.456l45.248 45.248L240.448 512A192 192 0 0 0 512 783.552l316.8-316.8a128 128 0 1 0-181.056-181.056L353.6 579.904a32 32 0 1 0 45.248 45.248l294.144-294.144 45.312 45.248L444.096 670.4a96 96 0 1 1-135.744-135.744l294.144-294.208z"
      })
    ]));
  }
});

// src/components/paperclip.vue
var paperclip_default = paperclip_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/partly-cloudy.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent191 } from "vue";
import { createElementVNode as _createElementVNode191, openBlock as _openBlock191, createElementBlock as _createElementBlock191 } from "vue";
var partly_cloudy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent191({
  name: "PartlyCloudy",
  __name: "partly-cloudy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock191(), _createElementBlock191("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode191("path", {
        fill: "currentColor",
        d: "M598.4 895.872H328.192a256 256 0 0 1-34.496-510.528A352 352 0 1 1 598.4 895.872m-271.36-64h272.256a288 288 0 1 0-248.512-417.664L335.04 445.44l-34.816 3.584a192 192 0 0 0 26.88 382.848z"
      }),
      _createElementVNode191("path", {
        fill: "currentColor",
        d: "M139.84 501.888a256 256 0 1 1 417.856-277.12c-17.728 2.176-38.208 8.448-61.504 18.816A192 192 0 1 0 189.12 460.48a6003.84 6003.84 0 0 0-49.28 41.408z"
      })
    ]));
  }
});

// src/components/partly-cloudy.vue
var partly_cloudy_default = partly_cloudy_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/pear.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent192 } from "vue";
import { createElementVNode as _createElementVNode192, openBlock as _openBlock192, createElementBlock as _createElementBlock192 } from "vue";
var pear_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent192({
  name: "Pear",
  __name: "pear",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock192(), _createElementBlock192("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode192("path", {
        fill: "currentColor",
        d: "M542.336 258.816a443.255 443.255 0 0 0-9.024 25.088 32 32 0 1 1-60.8-20.032l1.088-3.328a162.688 162.688 0 0 0-122.048 131.392l-17.088 102.72-20.736 15.36C256.192 552.704 224 610.88 224 672c0 120.576 126.4 224 288 224s288-103.424 288-224c0-61.12-32.192-119.296-89.728-161.92l-20.736-15.424-17.088-102.72a162.688 162.688 0 0 0-130.112-133.12zm-40.128-66.56c7.936-15.552 16.576-30.08 25.92-43.776 23.296-33.92 49.408-59.776 78.528-77.12a32 32 0 1 1 32.704 55.04c-20.544 12.224-40.064 31.552-58.432 58.304a316.608 316.608 0 0 0-9.792 15.104 226.688 226.688 0 0 1 164.48 181.568l12.8 77.248C819.456 511.36 864 587.392 864 672c0 159.04-157.568 288-352 288S160 831.04 160 672c0-84.608 44.608-160.64 115.584-213.376l12.8-77.248a226.624 226.624 0 0 1 213.76-189.184z"
      })
    ]));
  }
});

// src/components/pear.vue
var pear_default = pear_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/phone-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent193 } from "vue";
import { createElementVNode as _createElementVNode193, openBlock as _openBlock193, createElementBlock as _createElementBlock193 } from "vue";
var phone_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent193({
  name: "PhoneFilled",
  __name: "phone-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock193(), _createElementBlock193("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode193("path", {
        fill: "currentColor",
        d: "M199.232 125.568 90.624 379.008a32 32 0 0 0 6.784 35.2l512.384 512.384a32 32 0 0 0 35.2 6.784l253.44-108.608a32 32 0 0 0 10.048-52.032L769.6 633.92a32 32 0 0 0-36.928-5.952l-130.176 65.088-271.488-271.552 65.024-130.176a32 32 0 0 0-5.952-36.928L251.2 115.52a32 32 0 0 0-51.968 10.048z"
      })
    ]));
  }
});

// src/components/phone-filled.vue
var phone_filled_default = phone_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/phone.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent194 } from "vue";
import { createElementVNode as _createElementVNode194, openBlock as _openBlock194, createElementBlock as _createElementBlock194 } from "vue";
var phone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent194({
  name: "Phone",
  __name: "phone",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock194(), _createElementBlock194("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode194("path", {
        fill: "currentColor",
        d: "M79.36 432.256 591.744 944.64a32 32 0 0 0 35.2 6.784l253.44-108.544a32 32 0 0 0 9.984-52.032l-153.856-153.92a32 32 0 0 0-36.928-6.016l-69.888 34.944L358.08 394.24l35.008-69.888a32 32 0 0 0-5.952-36.928L233.152 133.568a32 32 0 0 0-52.032 10.048L72.512 397.056a32 32 0 0 0 6.784 35.2zm60.48-29.952 81.536-190.08L325.568 316.48l-24.64 49.216-20.608 41.216 32.576 32.64 271.552 271.552 32.64 32.64 41.216-20.672 49.28-24.576 104.192 104.128-190.08 81.472L139.84 402.304zM512 320v-64a256 256 0 0 1 256 256h-64a192 192 0 0 0-192-192m0-192V64a448 448 0 0 1 448 448h-64a384 384 0 0 0-384-384"
      })
    ]));
  }
});

// src/components/phone.vue
var phone_default = phone_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/picture-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent195 } from "vue";
import { createElementVNode as _createElementVNode195, openBlock as _openBlock195, createElementBlock as _createElementBlock195 } from "vue";
var picture_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent195({
  name: "PictureFilled",
  __name: "picture-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock195(), _createElementBlock195("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode195("path", {
        fill: "currentColor",
        d: "M96 896a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h832a32 32 0 0 1 32 32v704a32 32 0 0 1-32 32zm315.52-228.48-68.928-68.928a32 32 0 0 0-45.248 0L128 768.064h778.688l-242.112-290.56a32 32 0 0 0-49.216 0L458.752 665.408a32 32 0 0 1-47.232 2.112M256 384a96 96 0 1 0 192.064-.064A96 96 0 0 0 256 384"
      })
    ]));
  }
});

// src/components/picture-filled.vue
var picture_filled_default = picture_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/picture-rounded.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent196 } from "vue";
import { createElementVNode as _createElementVNode196, openBlock as _openBlock196, createElementBlock as _createElementBlock196 } from "vue";
var picture_rounded_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent196({
  name: "PictureRounded",
  __name: "picture-rounded",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock196(), _createElementBlock196("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode196("path", {
        fill: "currentColor",
        d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768m0-64a448 448 0 1 1 0 896 448 448 0 0 1 0-896"
      }),
      _createElementVNode196("path", {
        fill: "currentColor",
        d: "M640 288q64 0 64 64t-64 64q-64 0-64-64t64-64M214.656 790.656l-45.312-45.312 185.664-185.6a96 96 0 0 1 123.712-10.24l138.24 98.688a32 32 0 0 0 39.872-2.176L906.688 422.4l42.624 47.744L699.52 693.696a96 96 0 0 1-119.808 6.592l-138.24-98.752a32 32 0 0 0-41.152 3.456l-185.664 185.6z"
      })
    ]));
  }
});

// src/components/picture-rounded.vue
var picture_rounded_default = picture_rounded_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/picture.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent197 } from "vue";
import { createElementVNode as _createElementVNode197, openBlock as _openBlock197, createElementBlock as _createElementBlock197 } from "vue";
var picture_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent197({
  name: "Picture",
  __name: "picture",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock197(), _createElementBlock197("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode197("path", {
        fill: "currentColor",
        d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
      }),
      _createElementVNode197("path", {
        fill: "currentColor",
        d: "M384 288q64 0 64 64t-64 64q-64 0-64-64t64-64M185.408 876.992l-50.816-38.912L350.72 556.032a96 96 0 0 1 134.592-17.856l1.856 1.472 122.88 99.136a32 32 0 0 0 44.992-4.864l216-269.888 49.92 39.936-215.808 269.824-.256.32a96 96 0 0 1-135.04 14.464l-122.88-99.072-.64-.512a32 32 0 0 0-44.8 5.952z"
      })
    ]));
  }
});

// src/components/picture.vue
var picture_default = picture_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/pie-chart.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent198 } from "vue";
import { createElementVNode as _createElementVNode198, openBlock as _openBlock198, createElementBlock as _createElementBlock198 } from "vue";
var pie_chart_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent198({
  name: "PieChart",
  __name: "pie-chart",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock198(), _createElementBlock198("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode198("path", {
        fill: "currentColor",
        d: "M448 68.48v64.832A384.128 384.128 0 0 0 512 896a384.128 384.128 0 0 0 378.688-320h64.768A448.128 448.128 0 0 1 64 512 448.128 448.128 0 0 1 448 68.48z"
      }),
      _createElementVNode198("path", {
        fill: "currentColor",
        d: "M576 97.28V448h350.72A384.064 384.064 0 0 0 576 97.28zM512 64V33.152A448 448 0 0 1 990.848 512H512z"
      })
    ]));
  }
});

// src/components/pie-chart.vue
var pie_chart_default = pie_chart_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/place.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent199 } from "vue";
import { createElementVNode as _createElementVNode199, openBlock as _openBlock199, createElementBlock as _createElementBlock199 } from "vue";
var place_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent199({
  name: "Place",
  __name: "place",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock199(), _createElementBlock199("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode199("path", {
        fill: "currentColor",
        d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
      }),
      _createElementVNode199("path", {
        fill: "currentColor",
        d: "M512 512a32 32 0 0 1 32 32v256a32 32 0 1 1-64 0V544a32 32 0 0 1 32-32"
      }),
      _createElementVNode199("path", {
        fill: "currentColor",
        d: "M384 649.088v64.96C269.76 732.352 192 771.904 192 800c0 37.696 139.904 96 320 96s320-58.304 320-96c0-28.16-77.76-67.648-192-85.952v-64.96C789.12 671.04 896 730.368 896 800c0 88.32-171.904 160-384 160s-384-71.68-384-160c0-69.696 106.88-128.96 256-150.912"
      })
    ]));
  }
});

// src/components/place.vue
var place_default = place_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/platform.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent200 } from "vue";
import { createElementVNode as _createElementVNode200, openBlock as _openBlock200, createElementBlock as _createElementBlock200 } from "vue";
var platform_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent200({
  name: "Platform",
  __name: "platform",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock200(), _createElementBlock200("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode200("path", {
        fill: "currentColor",
        d: "M448 832v-64h128v64h192v64H256v-64zM128 704V128h768v576z"
      })
    ]));
  }
});

// src/components/platform.vue
var platform_default = platform_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/plus.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent201 } from "vue";
import { createElementVNode as _createElementVNode201, openBlock as _openBlock201, createElementBlock as _createElementBlock201 } from "vue";
var plus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent201({
  name: "Plus",
  __name: "plus",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock201(), _createElementBlock201("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode201("path", {
        fill: "currentColor",
        d: "M480 480V128a32 32 0 0 1 64 0v352h352a32 32 0 1 1 0 64H544v352a32 32 0 1 1-64 0V544H128a32 32 0 0 1 0-64z"
      })
    ]));
  }
});

// src/components/plus.vue
var plus_default = plus_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/pointer.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent202 } from "vue";
import { createElementVNode as _createElementVNode202, openBlock as _openBlock202, createElementBlock as _createElementBlock202 } from "vue";
var pointer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent202({
  name: "Pointer",
  __name: "pointer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock202(), _createElementBlock202("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode202("path", {
        fill: "currentColor",
        d: "M511.552 128c-35.584 0-64.384 28.8-64.384 64.448v516.48L274.048 570.88a94.272 94.272 0 0 0-112.896-3.456 44.416 44.416 0 0 0-8.96 62.208L332.8 870.4A64 64 0 0 0 384 896h512V575.232a64 64 0 0 0-45.632-61.312l-205.952-61.76A96 96 0 0 1 576 360.192V192.448C576 156.8 547.2 128 511.552 128M359.04 556.8l24.128 19.2V192.448a128.448 128.448 0 1 1 256.832 0v167.744a32 32 0 0 0 22.784 30.656l206.016 61.76A128 128 0 0 1 960 575.232V896a64 64 0 0 1-64 64H384a128 128 0 0 1-102.4-51.2L101.056 668.032A108.416 108.416 0 0 1 128 512.512a158.272 158.272 0 0 1 185.984 8.32z"
      })
    ]));
  }
});

// src/components/pointer.vue
var pointer_default = pointer_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/position.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent203 } from "vue";
import { createElementVNode as _createElementVNode203, openBlock as _openBlock203, createElementBlock as _createElementBlock203 } from "vue";
var position_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent203({
  name: "Position",
  __name: "position",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock203(), _createElementBlock203("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode203("path", {
        fill: "currentColor",
        d: "m249.6 417.088 319.744 43.072 39.168 310.272L845.12 178.88 249.6 417.088zm-129.024 47.168a32 32 0 0 1-7.68-61.44l777.792-311.04a32 32 0 0 1 41.6 41.6l-310.336 775.68a32 32 0 0 1-61.44-7.808L512 516.992l-391.424-52.736z"
      })
    ]));
  }
});

// src/components/position.vue
var position_default = position_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/postcard.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent204 } from "vue";
import { createElementVNode as _createElementVNode204, openBlock as _openBlock204, createElementBlock as _createElementBlock204 } from "vue";
var postcard_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent204({
  name: "Postcard",
  __name: "postcard",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock204(), _createElementBlock204("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode204("path", {
        fill: "currentColor",
        d: "M160 224a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V256a32 32 0 0 0-32-32zm0-64h704a96 96 0 0 1 96 96v512a96 96 0 0 1-96 96H160a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96"
      }),
      _createElementVNode204("path", {
        fill: "currentColor",
        d: "M704 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128M288 448h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32m0 128h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/postcard.vue
var postcard_default = postcard_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/pouring.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent205 } from "vue";
import { createElementVNode as _createElementVNode205, openBlock as _openBlock205, createElementBlock as _createElementBlock205 } from "vue";
var pouring_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent205({
  name: "Pouring",
  __name: "pouring",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock205(), _createElementBlock205("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode205("path", {
        fill: "currentColor",
        d: "m739.328 291.328-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 97.28 78.72 175.936 175.808 175.936h400a192 192 0 0 0 35.776-380.672zM959.552 480a256 256 0 0 1-256 256h-400A239.808 239.808 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 959.552 480M224 800a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32"
      })
    ]));
  }
});

// src/components/pouring.vue
var pouring_default = pouring_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/present.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent206 } from "vue";
import { createElementVNode as _createElementVNode206, openBlock as _openBlock206, createElementBlock as _createElementBlock206 } from "vue";
var present_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent206({
  name: "Present",
  __name: "present",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock206(), _createElementBlock206("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M480 896V640H192v-64h288V320H192v576zm64 0h288V320H544v256h288v64H544zM128 256h768v672a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
      }),
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M96 256h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
      }),
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M416 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      _createElementVNode206("path", {
        fill: "currentColor",
        d: "M608 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      })
    ]));
  }
});

// src/components/present.vue
var present_default = present_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/price-tag.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent207 } from "vue";
import { createElementVNode as _createElementVNode207, openBlock as _openBlock207, createElementBlock as _createElementBlock207 } from "vue";
var price_tag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent207({
  name: "PriceTag",
  __name: "price-tag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock207(), _createElementBlock207("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode207("path", {
        fill: "currentColor",
        d: "M224 318.336V896h576V318.336L552.512 115.84a64 64 0 0 0-81.024 0zM593.024 66.304l259.2 212.096A32 32 0 0 1 864 303.168V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.168a32 32 0 0 1 11.712-24.768l259.2-212.096a128 128 0 0 1 162.112 0z"
      }),
      _createElementVNode207("path", {
        fill: "currentColor",
        d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      })
    ]));
  }
});

// src/components/price-tag.vue
var price_tag_default = price_tag_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/printer.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent208 } from "vue";
import { createElementVNode as _createElementVNode208, openBlock as _openBlock208, createElementBlock as _createElementBlock208 } from "vue";
var printer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent208({
  name: "Printer",
  __name: "printer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock208(), _createElementBlock208("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode208("path", {
        fill: "currentColor",
        d: "M256 768H105.024c-14.272 0-19.456-1.472-24.64-4.288a29.056 29.056 0 0 1-12.16-12.096C65.536 746.432 64 741.248 64 727.04V379.072c0-42.816 4.48-58.304 12.8-73.984 8.384-15.616 20.672-27.904 36.288-36.288 15.68-8.32 31.168-12.8 73.984-12.8H256V64h512v192h68.928c42.816 0 58.304 4.48 73.984 12.8 15.616 8.384 27.904 20.672 36.288 36.288 8.32 15.68 12.8 31.168 12.8 73.984v347.904c0 14.272-1.472 19.456-4.288 24.64a29.056 29.056 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H768v192H256zm64-192v320h384V576zm-64 128V512h512v192h128V379.072c0-29.376-1.408-36.48-5.248-43.776a23.296 23.296 0 0 0-10.048-10.048c-7.232-3.84-14.4-5.248-43.776-5.248H187.072c-29.376 0-36.48 1.408-43.776 5.248a23.296 23.296 0 0 0-10.048 10.048c-3.84 7.232-5.248 14.4-5.248 43.776V704zm64-448h384V128H320zm-64 128h64v64h-64zm128 0h64v64h-64z"
      })
    ]));
  }
});

// src/components/printer.vue
var printer_default = printer_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/promotion.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent209 } from "vue";
import { createElementVNode as _createElementVNode209, openBlock as _openBlock209, createElementBlock as _createElementBlock209 } from "vue";
var promotion_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent209({
  name: "Promotion",
  __name: "promotion",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock209(), _createElementBlock209("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode209("path", {
        fill: "currentColor",
        d: "m64 448 832-320-128 704-446.08-243.328L832 192 242.816 545.472zm256 512V657.024L512 768z"
      })
    ]));
  }
});

// src/components/promotion.vue
var promotion_default = promotion_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/quartz-watch.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent210 } from "vue";
import { createElementVNode as _createElementVNode210, openBlock as _openBlock210, createElementBlock as _createElementBlock210 } from "vue";
var quartz_watch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent210({
  name: "QuartzWatch",
  __name: "quartz-watch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock210(), _createElementBlock210("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode210("path", {
        fill: "currentColor",
        d: "M422.02 602.01v-.03c-6.68-5.99-14.35-8.83-23.01-8.51-8.67.32-16.17 3.66-22.5 10.02-6.33 6.36-9.5 13.7-9.5 22.02s3 15.82 8.99 22.5c8.68 8.68 19.02 11.35 31.01 8s19.49-10.85 22.5-22.5c3.01-11.65.51-22.15-7.49-31.49zM384 512c0-9.35-3-17.02-8.99-23.01-6-5.99-13.66-8.99-23.01-8.99-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.66 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.67 8.99-23.01m6.53-82.49c11.65 3.01 22.15.51 31.49-7.49h.04c5.99-6.68 8.83-14.34 8.51-23.01-.32-8.67-3.66-16.16-10.02-22.5-6.36-6.33-13.7-9.5-22.02-9.5s-15.82 3-22.5 8.99c-8.68 8.69-11.35 19.02-8 31.01 3.35 11.99 10.85 19.49 22.5 22.5zm242.94 0c11.67-3.03 19.01-10.37 22.02-22.02 3.01-11.65.51-22.15-7.49-31.49h.01c-6.68-5.99-14.18-8.99-22.5-8.99s-15.66 3.16-22.02 9.5c-6.36 6.34-9.7 13.84-10.02 22.5-.32 8.66 2.52 16.33 8.51 23.01 9.32 8.02 19.82 10.52 31.49 7.49M512 640c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.67 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.66 8.99-23.01s-3-17.02-8.99-23.01c-6-5.99-13.66-8.99-23.01-8.99m183.01-151.01c-6-5.99-13.66-8.99-23.01-8.99s-17.02 3-23.01 8.99c-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.66 8.99 23.01 8.99s17.02-3 23.01-8.99c5.99-6 8.99-13.67 8.99-23.01 0-9.35-3-17.02-8.99-23.01"
      }),
      _createElementVNode210("path", {
        fill: "currentColor",
        d: "M832 512c-2-90.67-33.17-166.17-93.5-226.5-20.43-20.42-42.6-37.49-66.5-51.23V64H352v170.26c-23.9 13.74-46.07 30.81-66.5 51.24-60.33 60.33-91.49 135.83-93.5 226.5 2 90.67 33.17 166.17 93.5 226.5 20.43 20.43 42.6 37.5 66.5 51.24V960h320V789.74c23.9-13.74 46.07-30.81 66.5-51.24 60.33-60.34 91.49-135.83 93.5-226.5M416 128h192v78.69c-29.85-9.03-61.85-13.93-96-14.69-34.15.75-66.15 5.65-96 14.68zm192 768H416v-78.68c29.85 9.03 61.85 13.93 96 14.68 34.15-.75 66.15-5.65 96-14.68zm-96-128c-72.66-2.01-132.99-27.01-180.99-75.01S258.01 584.66 256 512c2.01-72.66 27.01-132.99 75.01-180.99S439.34 258.01 512 256c72.66 2.01 132.99 27.01 180.99 75.01S765.99 439.34 768 512c-2.01 72.66-27.01 132.99-75.01 180.99S584.66 765.99 512 768"
      }),
      _createElementVNode210("path", {
        fill: "currentColor",
        d: "M512 320c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01 0 9.35 3 17.02 8.99 23.01 6 5.99 13.67 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.66 8.99-23.01 0-9.35-3-17.02-8.99-23.01-6-5.99-13.66-8.99-23.01-8.99m112.99 273.5c-8.66-.32-16.33 2.52-23.01 8.51-7.98 9.32-10.48 19.82-7.49 31.49s10.49 19.17 22.5 22.5 22.35.66 31.01-8v.04c5.99-6.68 8.99-14.18 8.99-22.5s-3.16-15.66-9.5-22.02-13.84-9.7-22.5-10.02"
      })
    ]));
  }
});

// src/components/quartz-watch.vue
var quartz_watch_default = quartz_watch_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/question-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent211 } from "vue";
import { createElementVNode as _createElementVNode211, openBlock as _openBlock211, createElementBlock as _createElementBlock211 } from "vue";
var question_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent211({
  name: "QuestionFilled",
  __name: "question-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock211(), _createElementBlock211("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode211("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m23.744 191.488c-52.096 0-92.928 14.784-123.2 44.352-30.976 29.568-45.76 70.4-45.76 122.496h80.256c0-29.568 5.632-52.8 17.6-68.992 13.376-19.712 35.2-28.864 66.176-28.864 23.936 0 42.944 6.336 56.32 19.712 12.672 13.376 19.712 31.68 19.712 54.912 0 17.6-6.336 34.496-19.008 49.984l-8.448 9.856c-45.76 40.832-73.216 70.4-82.368 89.408-9.856 19.008-14.08 42.24-14.08 68.992v9.856h80.96v-9.856c0-16.896 3.52-31.68 10.56-45.76 6.336-12.672 15.488-24.64 28.16-35.2 33.792-29.568 54.208-48.576 60.544-55.616 16.896-22.528 26.048-51.392 26.048-86.592 0-42.944-14.08-76.736-42.24-101.376-28.16-25.344-65.472-37.312-111.232-37.312zm-12.672 406.208a54.272 54.272 0 0 0-38.72 14.784 49.408 49.408 0 0 0-15.488 38.016c0 15.488 4.928 28.16 15.488 38.016A54.848 54.848 0 0 0 523.072 768c15.488 0 28.16-4.928 38.72-14.784a51.52 51.52 0 0 0 16.192-38.72 51.968 51.968 0 0 0-15.488-38.016 55.936 55.936 0 0 0-39.424-14.784z"
      })
    ]));
  }
});

// src/components/question-filled.vue
var question_filled_default = question_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/rank.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent212 } from "vue";
import { createElementVNode as _createElementVNode212, openBlock as _openBlock212, createElementBlock as _createElementBlock212 } from "vue";
var rank_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent212({
  name: "Rank",
  __name: "rank",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock212(), _createElementBlock212("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode212("path", {
        fill: "currentColor",
        d: "m186.496 544 41.408 41.344a32 32 0 1 1-45.248 45.312l-96-96a32 32 0 0 1 0-45.312l96-96a32 32 0 1 1 45.248 45.312L186.496 480h290.816V186.432l-41.472 41.472a32 32 0 1 1-45.248-45.184l96-96.128a32 32 0 0 1 45.312 0l96 96.064a32 32 0 0 1-45.248 45.184l-41.344-41.28V480H832l-41.344-41.344a32 32 0 0 1 45.248-45.312l96 96a32 32 0 0 1 0 45.312l-96 96a32 32 0 0 1-45.248-45.312L832 544H541.312v293.44l41.344-41.28a32 32 0 1 1 45.248 45.248l-96 96a32 32 0 0 1-45.312 0l-96-96a32 32 0 1 1 45.312-45.248l41.408 41.408V544H186.496z"
      })
    ]));
  }
});

// src/components/rank.vue
var rank_default = rank_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/reading-lamp.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent213 } from "vue";
import { createElementVNode as _createElementVNode213, openBlock as _openBlock213, createElementBlock as _createElementBlock213 } from "vue";
var reading_lamp_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent213({
  name: "ReadingLamp",
  __name: "reading-lamp",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock213(), _createElementBlock213("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode213("path", {
        fill: "currentColor",
        d: "M352 896h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m-44.672-768-99.52 448h608.384l-99.52-448zm-25.6-64h460.608a32 32 0 0 1 31.232 25.088l113.792 512A32 32 0 0 1 856.128 640H167.872a32 32 0 0 1-31.232-38.912l113.792-512A32 32 0 0 1 281.664 64z"
      }),
      _createElementVNode213("path", {
        fill: "currentColor",
        d: "M672 576q32 0 32 32v128q0 32-32 32t-32-32V608q0-32 32-32m-192-.064h64V960h-64z"
      })
    ]));
  }
});

// src/components/reading-lamp.vue
var reading_lamp_default = reading_lamp_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/reading.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent214 } from "vue";
import { createElementVNode as _createElementVNode214, openBlock as _openBlock214, createElementBlock as _createElementBlock214 } from "vue";
var reading_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent214({
  name: "Reading",
  __name: "reading",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock214(), _createElementBlock214("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode214("path", {
        fill: "currentColor",
        d: "m512 863.36 384-54.848v-638.72L525.568 222.72a96 96 0 0 1-27.136 0L128 169.792v638.72zM137.024 106.432l370.432 52.928a32 32 0 0 0 9.088 0l370.432-52.928A64 64 0 0 1 960 169.792v638.72a64 64 0 0 1-54.976 63.36l-388.48 55.488a32 32 0 0 1-9.088 0l-388.48-55.488A64 64 0 0 1 64 808.512v-638.72a64 64 0 0 1 73.024-63.36z"
      }),
      _createElementVNode214("path", {
        fill: "currentColor",
        d: "M480 192h64v704h-64z"
      })
    ]));
  }
});

// src/components/reading.vue
var reading_default = reading_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/refresh-left.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent215 } from "vue";
import { createElementVNode as _createElementVNode215, openBlock as _openBlock215, createElementBlock as _createElementBlock215 } from "vue";
var refresh_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent215({
  name: "RefreshLeft",
  __name: "refresh-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock215(), _createElementBlock215("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode215("path", {
        fill: "currentColor",
        d: "M289.088 296.704h92.992a32 32 0 0 1 0 64H232.96a32 32 0 0 1-32-32V179.712a32 32 0 0 1 64 0v50.56a384 384 0 0 1 643.84 282.88 384 384 0 0 1-383.936 384 384 384 0 0 1-384-384h64a320 320 0 1 0 640 0 320 320 0 0 0-555.712-216.448z"
      })
    ]));
  }
});

// src/components/refresh-left.vue
var refresh_left_default = refresh_left_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/refresh-right.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent216 } from "vue";
import { createElementVNode as _createElementVNode216, openBlock as _openBlock216, createElementBlock as _createElementBlock216 } from "vue";
var refresh_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent216({
  name: "RefreshRight",
  __name: "refresh-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock216(), _createElementBlock216("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode216("path", {
        fill: "currentColor",
        d: "M784.512 230.272v-50.56a32 32 0 1 1 64 0v149.056a32 32 0 0 1-32 32H667.52a32 32 0 1 1 0-64h92.992A320 320 0 1 0 524.8 833.152a320 320 0 0 0 320-320h64a384 384 0 0 1-384 384 384 384 0 0 1-384-384 384 384 0 0 1 643.712-282.88z"
      })
    ]));
  }
});

// src/components/refresh-right.vue
var refresh_right_default = refresh_right_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/refresh.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent217 } from "vue";
import { createElementVNode as _createElementVNode217, openBlock as _openBlock217, createElementBlock as _createElementBlock217 } from "vue";
var refresh_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent217({
  name: "Refresh",
  __name: "refresh",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock217(), _createElementBlock217("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode217("path", {
        fill: "currentColor",
        d: "M771.776 794.88A384 384 0 0 1 128 512h64a320 320 0 0 0 555.712 216.448H654.72a32 32 0 1 1 0-64h149.056a32 32 0 0 1 32 32v148.928a32 32 0 1 1-64 0v-50.56zM276.288 295.616h92.992a32 32 0 0 1 0 64H220.16a32 32 0 0 1-32-32V178.56a32 32 0 0 1 64 0v50.56A384 384 0 0 1 896.128 512h-64a320 320 0 0 0-555.776-216.384z"
      })
    ]));
  }
});

// src/components/refresh.vue
var refresh_default = refresh_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/refrigerator.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent218 } from "vue";
import { createElementVNode as _createElementVNode218, openBlock as _openBlock218, createElementBlock as _createElementBlock218 } from "vue";
var refrigerator_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent218({
  name: "Refrigerator",
  __name: "refrigerator",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock218(), _createElementBlock218("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode218("path", {
        fill: "currentColor",
        d: "M256 448h512V160a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32zm0 64v352a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V512zm32-448h448a96 96 0 0 1 96 96v704a96 96 0 0 1-96 96H288a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96m32 224h64v96h-64zm0 288h64v96h-64z"
      })
    ]));
  }
});

// src/components/refrigerator.vue
var refrigerator_default = refrigerator_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/remove-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent219 } from "vue";
import { createElementVNode as _createElementVNode219, openBlock as _openBlock219, createElementBlock as _createElementBlock219 } from "vue";
var remove_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent219({
  name: "RemoveFilled",
  __name: "remove-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock219(), _createElementBlock219("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode219("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896M288 512a38.4 38.4 0 0 0 38.4 38.4h371.2a38.4 38.4 0 0 0 0-76.8H326.4A38.4 38.4 0 0 0 288 512"
      })
    ]));
  }
});

// src/components/remove-filled.vue
var remove_filled_default = remove_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/remove.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent220 } from "vue";
import { createElementVNode as _createElementVNode220, openBlock as _openBlock220, createElementBlock as _createElementBlock220 } from "vue";
var remove_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent220({
  name: "Remove",
  __name: "remove",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock220(), _createElementBlock220("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode220("path", {
        fill: "currentColor",
        d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
      }),
      _createElementVNode220("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});

// src/components/remove.vue
var remove_default = remove_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/right.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent221 } from "vue";
import { createElementVNode as _createElementVNode221, openBlock as _openBlock221, createElementBlock as _createElementBlock221 } from "vue";
var right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent221({
  name: "Right",
  __name: "right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock221(), _createElementBlock221("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode221("path", {
        fill: "currentColor",
        d: "M754.752 480H160a32 32 0 1 0 0 64h594.752L521.344 777.344a32 32 0 0 0 45.312 45.312l288-288a32 32 0 0 0 0-45.312l-288-288a32 32 0 1 0-45.312 45.312z"
      })
    ]));
  }
});

// src/components/right.vue
var right_default = right_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/scale-to-original.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent222 } from "vue";
import { createElementVNode as _createElementVNode222, openBlock as _openBlock222, createElementBlock as _createElementBlock222 } from "vue";
var scale_to_original_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent222({
  name: "ScaleToOriginal",
  __name: "scale-to-original",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock222(), _createElementBlock222("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode222("path", {
        fill: "currentColor",
        d: "M813.176 180.706a60.235 60.235 0 0 1 60.236 60.235v481.883a60.235 60.235 0 0 1-60.236 60.235H210.824a60.235 60.235 0 0 1-60.236-60.235V240.94a60.235 60.235 0 0 1 60.236-60.235h602.352zm0-60.235H210.824A120.47 120.47 0 0 0 90.353 240.94v481.883a120.47 120.47 0 0 0 120.47 120.47h602.353a120.47 120.47 0 0 0 120.471-120.47V240.94a120.47 120.47 0 0 0-120.47-120.47zm-120.47 180.705a30.118 30.118 0 0 0-30.118 30.118v301.177a30.118 30.118 0 0 0 60.236 0V331.294a30.118 30.118 0 0 0-30.118-30.118zm-361.412 0a30.118 30.118 0 0 0-30.118 30.118v301.177a30.118 30.118 0 1 0 60.236 0V331.294a30.118 30.118 0 0 0-30.118-30.118M512 361.412a30.118 30.118 0 0 0-30.118 30.117v30.118a30.118 30.118 0 0 0 60.236 0V391.53A30.118 30.118 0 0 0 512 361.412M512 512a30.118 30.118 0 0 0-30.118 30.118v30.117a30.118 30.118 0 0 0 60.236 0v-30.117A30.118 30.118 0 0 0 512 512"
      })
    ]));
  }
});

// src/components/scale-to-original.vue
var scale_to_original_default = scale_to_original_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/school.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent223 } from "vue";
import { createElementVNode as _createElementVNode223, openBlock as _openBlock223, createElementBlock as _createElementBlock223 } from "vue";
var school_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent223({
  name: "School",
  __name: "school",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock223(), _createElementBlock223("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode223("path", {
        fill: "currentColor",
        d: "M224 128v704h576V128zm-32-64h640a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      _createElementVNode223("path", {
        fill: "currentColor",
        d: "M64 832h896v64H64zm256-640h128v96H320z"
      }),
      _createElementVNode223("path", {
        fill: "currentColor",
        d: "M384 832h256v-64a128 128 0 1 0-256 0zm128-256a192 192 0 0 1 192 192v128H320V768a192 192 0 0 1 192-192M320 384h128v96H320zm256-192h128v96H576zm0 192h128v96H576z"
      })
    ]));
  }
});

// src/components/school.vue
var school_default = school_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/scissor.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent224 } from "vue";
import { createElementVNode as _createElementVNode224, openBlock as _openBlock224, createElementBlock as _createElementBlock224 } from "vue";
var scissor_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent224({
  name: "Scissor",
  __name: "scissor",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock224(), _createElementBlock224("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode224("path", {
        fill: "currentColor",
        d: "m512.064 578.368-106.88 152.768a160 160 0 1 1-23.36-78.208L472.96 522.56 196.864 128.256a32 32 0 1 1 52.48-36.736l393.024 561.344a160 160 0 1 1-23.36 78.208l-106.88-152.704zm54.4-189.248 208.384-297.6a32 32 0 0 1 52.48 36.736l-221.76 316.672-39.04-55.808zm-376.32 425.856a96 96 0 1 0 110.144-157.248 96 96 0 0 0-110.08 157.248zm643.84 0a96 96 0 1 0-110.08-157.248 96 96 0 0 0 110.08 157.248"
      })
    ]));
  }
});

// src/components/scissor.vue
var scissor_default = scissor_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/search.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent225 } from "vue";
import { createElementVNode as _createElementVNode225, openBlock as _openBlock225, createElementBlock as _createElementBlock225 } from "vue";
var search_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent225({
  name: "Search",
  __name: "search",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock225(), _createElementBlock225("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode225("path", {
        fill: "currentColor",
        d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704"
      })
    ]));
  }
});

// src/components/search.vue
var search_default = search_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/select.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent226 } from "vue";
import { createElementVNode as _createElementVNode226, openBlock as _openBlock226, createElementBlock as _createElementBlock226 } from "vue";
var select_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent226({
  name: "Select",
  __name: "select",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock226(), _createElementBlock226("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode226("path", {
        fill: "currentColor",
        d: "M77.248 415.04a64 64 0 0 1 90.496 0l226.304 226.304L846.528 188.8a64 64 0 1 1 90.56 90.496l-543.04 543.04-316.8-316.8a64 64 0 0 1 0-90.496z"
      })
    ]));
  }
});

// src/components/select.vue
var select_default = select_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sell.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent227 } from "vue";
import { createElementVNode as _createElementVNode227, openBlock as _openBlock227, createElementBlock as _createElementBlock227 } from "vue";
var sell_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent227({
  name: "Sell",
  __name: "sell",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock227(), _createElementBlock227("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode227("path", {
        fill: "currentColor",
        d: "M704 288h131.072a32 32 0 0 1 31.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4h256zm201.408 483.84L768 698.496V928a32 32 0 1 1-64 0V698.496l-73.344 73.344a32 32 0 1 1-45.248-45.248l128-128a32 32 0 0 1 45.248 0l128 128a32 32 0 1 1-45.248 45.248z"
      })
    ]));
  }
});

// src/components/sell.vue
var sell_default = sell_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/semi-select.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent228 } from "vue";
import { createElementVNode as _createElementVNode228, openBlock as _openBlock228, createElementBlock as _createElementBlock228 } from "vue";
var semi_select_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent228({
  name: "SemiSelect",
  __name: "semi-select",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock228(), _createElementBlock228("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode228("path", {
        fill: "currentColor",
        d: "M128 448h768q64 0 64 64t-64 64H128q-64 0-64-64t64-64"
      })
    ]));
  }
});

// src/components/semi-select.vue
var semi_select_default = semi_select_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/service.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent229 } from "vue";
import { createElementVNode as _createElementVNode229, openBlock as _openBlock229, createElementBlock as _createElementBlock229 } from "vue";
var service_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent229({
  name: "Service",
  __name: "service",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock229(), _createElementBlock229("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode229("path", {
        fill: "currentColor",
        d: "M864 409.6a192 192 0 0 1-37.888 349.44A256.064 256.064 0 0 1 576 960h-96a32 32 0 1 1 0-64h96a192.064 192.064 0 0 0 181.12-128H736a32 32 0 0 1-32-32V416a32 32 0 0 1 32-32h32c10.368 0 20.544.832 30.528 2.432a288 288 0 0 0-573.056 0A193.235 193.235 0 0 1 256 384h32a32 32 0 0 1 32 32v320a32 32 0 0 1-32 32h-32a192 192 0 0 1-96-358.4 352 352 0 0 1 704 0M256 448a128 128 0 1 0 0 256zm640 128a128 128 0 0 0-128-128v256a128 128 0 0 0 128-128"
      })
    ]));
  }
});

// src/components/service.vue
var service_default = service_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/set-up.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent230 } from "vue";
import { createElementVNode as _createElementVNode230, openBlock as _openBlock230, createElementBlock as _createElementBlock230 } from "vue";
var set_up_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent230({
  name: "SetUp",
  __name: "set-up",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock230(), _createElementBlock230("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode230("path", {
        fill: "currentColor",
        d: "M224 160a64 64 0 0 0-64 64v576a64 64 0 0 0 64 64h576a64 64 0 0 0 64-64V224a64 64 0 0 0-64-64zm0-64h576a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V224A128 128 0 0 1 224 96"
      }),
      _createElementVNode230("path", {
        fill: "currentColor",
        d: "M384 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      _createElementVNode230("path", {
        fill: "currentColor",
        d: "M480 320h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32m160 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      _createElementVNode230("path", {
        fill: "currentColor",
        d: "M288 640h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/set-up.vue
var set_up_default = set_up_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/setting.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent231 } from "vue";
import { createElementVNode as _createElementVNode231, openBlock as _openBlock231, createElementBlock as _createElementBlock231 } from "vue";
var setting_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent231({
  name: "Setting",
  __name: "setting",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock231(), _createElementBlock231("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode231("path", {
        fill: "currentColor",
        d: "M600.704 64a32 32 0 0 1 30.464 22.208l35.2 109.376c14.784 7.232 28.928 15.36 42.432 24.512l112.384-24.192a32 32 0 0 1 34.432 15.36L944.32 364.8a32 32 0 0 1-4.032 37.504l-77.12 85.12a357.12 357.12 0 0 1 0 49.024l77.12 85.248a32 32 0 0 1 4.032 37.504l-88.704 153.6a32 32 0 0 1-34.432 15.296L708.8 803.904c-13.44 9.088-27.648 17.28-42.368 24.512l-35.264 109.376A32 32 0 0 1 600.704 960H423.296a32 32 0 0 1-30.464-22.208L357.696 828.48a351.616 351.616 0 0 1-42.56-24.64l-112.32 24.256a32 32 0 0 1-34.432-15.36L79.68 659.2a32 32 0 0 1 4.032-37.504l77.12-85.248a357.12 357.12 0 0 1 0-48.896l-77.12-85.248A32 32 0 0 1 79.68 364.8l88.704-153.6a32 32 0 0 1 34.432-15.296l112.32 24.256c13.568-9.152 27.776-17.408 42.56-24.64l35.2-109.312A32 32 0 0 1 423.232 64H600.64zm-23.424 64H446.72l-36.352 113.088-24.512 11.968a294.113 294.113 0 0 0-34.816 20.096l-22.656 15.36-116.224-25.088-65.28 113.152 79.68 88.192-1.92 27.136a293.12 293.12 0 0 0 0 40.192l1.92 27.136-79.808 88.192 65.344 113.152 116.224-25.024 22.656 15.296a294.113 294.113 0 0 0 34.816 20.096l24.512 11.968L446.72 896h130.688l36.48-113.152 24.448-11.904a288.282 288.282 0 0 0 34.752-20.096l22.592-15.296 116.288 25.024 65.28-113.152-79.744-88.192 1.92-27.136a293.12 293.12 0 0 0 0-40.256l-1.92-27.136 79.808-88.128-65.344-113.152-116.288 24.96-22.592-15.232a287.616 287.616 0 0 0-34.752-20.096l-24.448-11.904L577.344 128zM512 320a192 192 0 1 1 0 384 192 192 0 0 1 0-384m0 64a128 128 0 1 0 0 256 128 128 0 0 0 0-256"
      })
    ]));
  }
});

// src/components/setting.vue
var setting_default = setting_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/share.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent232 } from "vue";
import { createElementVNode as _createElementVNode232, openBlock as _openBlock232, createElementBlock as _createElementBlock232 } from "vue";
var share_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent232({
  name: "Share",
  __name: "share",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock232(), _createElementBlock232("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode232("path", {
        fill: "currentColor",
        d: "m679.872 348.8-301.76 188.608a127.808 127.808 0 0 1 5.12 52.16l279.936 104.96a128 128 0 1 1-22.464 59.904l-279.872-104.96a128 128 0 1 1-16.64-166.272l301.696-188.608a128 128 0 1 1 33.92 54.272z"
      })
    ]));
  }
});

// src/components/share.vue
var share_default = share_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/ship.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent233 } from "vue";
import { createElementVNode as _createElementVNode233, openBlock as _openBlock233, createElementBlock as _createElementBlock233 } from "vue";
var ship_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent233({
  name: "Ship",
  __name: "ship",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock233(), _createElementBlock233("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode233("path", {
        fill: "currentColor",
        d: "M512 386.88V448h405.568a32 32 0 0 1 30.72 40.768l-76.48 267.968A192 192 0 0 1 687.168 896H336.832a192 192 0 0 1-184.64-139.264L75.648 488.768A32 32 0 0 1 106.368 448H448V117.888a32 32 0 0 1 47.36-28.096l13.888 7.616L512 96v2.88l231.68 126.4a32 32 0 0 1-2.048 57.216zm0-70.272 144.768-65.792L512 171.84zM512 512H148.864l18.24 64H856.96l18.24-64zM185.408 640l28.352 99.2A128 128 0 0 0 336.832 832h350.336a128 128 0 0 0 123.072-92.8l28.352-99.2H185.408"
      })
    ]));
  }
});

// src/components/ship.vue
var ship_default = ship_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/shop.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent234 } from "vue";
import { createElementVNode as _createElementVNode234, openBlock as _openBlock234, createElementBlock as _createElementBlock234 } from "vue";
var shop_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent234({
  name: "Shop",
  __name: "shop",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock234(), _createElementBlock234("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode234("path", {
        fill: "currentColor",
        d: "M704 704h64v192H256V704h64v64h384zm188.544-152.192C894.528 559.616 896 567.616 896 576a96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0c0-8.384 1.408-16.384 3.392-24.192L192 128h640z"
      })
    ]));
  }
});

// src/components/shop.vue
var shop_default = shop_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/shopping-bag.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent235 } from "vue";
import { createElementVNode as _createElementVNode235, openBlock as _openBlock235, createElementBlock as _createElementBlock235 } from "vue";
var shopping_bag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent235({
  name: "ShoppingBag",
  __name: "shopping-bag",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock235(), _createElementBlock235("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode235("path", {
        fill: "currentColor",
        d: "M704 320v96a32 32 0 0 1-32 32h-32V320H384v128h-32a32 32 0 0 1-32-32v-96H192v576h640V320zm-384-64a192 192 0 1 1 384 0h160a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zm64 0h256a128 128 0 1 0-256 0"
      }),
      _createElementVNode235("path", {
        fill: "currentColor",
        d: "M192 704h640v64H192z"
      })
    ]));
  }
});

// src/components/shopping-bag.vue
var shopping_bag_default = shopping_bag_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/shopping-cart-full.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent236 } from "vue";
import { createElementVNode as _createElementVNode236, openBlock as _openBlock236, createElementBlock as _createElementBlock236 } from "vue";
var shopping_cart_full_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent236({
  name: "ShoppingCartFull",
  __name: "shopping-cart-full",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock236(), _createElementBlock236("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode236("path", {
        fill: "currentColor",
        d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.36 25.728L320.64 256H928a32 32 0 0 1 31.296 38.72l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.36-25.728L229.76 128zm314.24 576h395.904l82.304-384H333.44l76.8 384z"
      }),
      _createElementVNode236("path", {
        fill: "currentColor",
        d: "M699.648 256 608 145.984 516.352 256h183.296zm-140.8-151.04a64 64 0 0 1 98.304 0L836.352 320H379.648l179.2-215.04"
      })
    ]));
  }
});

// src/components/shopping-cart-full.vue
var shopping_cart_full_default = shopping_cart_full_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/shopping-cart.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent237 } from "vue";
import { createElementVNode as _createElementVNode237, openBlock as _openBlock237, createElementBlock as _createElementBlock237 } from "vue";
var shopping_cart_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent237({
  name: "ShoppingCart",
  __name: "shopping-cart",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock237(), _createElementBlock237("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode237("path", {
        fill: "currentColor",
        d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.36 25.728L320.64 256H928a32 32 0 0 1 31.296 38.72l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.36-25.728L229.76 128zm314.24 576h395.904l82.304-384H333.44l76.8 384z"
      })
    ]));
  }
});

// src/components/shopping-cart.vue
var shopping_cart_default = shopping_cart_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/shopping-trolley.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent238 } from "vue";
import { createElementVNode as _createElementVNode238, openBlock as _openBlock238, createElementBlock as _createElementBlock238 } from "vue";
var shopping_trolley_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent238({
  name: "ShoppingTrolley",
  __name: "shopping-trolley",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock238(), _createElementBlock238("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode238("path", {
        fill: "currentColor",
        d: "M368 833c-13.3 0-24.5 4.5-33.5 13.5S321 866.7 321 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5c13.3-.7 24.5-5.5 33.5-14.5S415 893.3 415 880s-4.5-24.5-13.5-33.5S381.3 833 368 833m439-193c7.4 0 13.8-2.2 19.5-6.5S836 623.3 838 616l112-448c2-10-.2-19.2-6.5-27.5S929 128 919 128H96c-9.3 0-17 3-23 9s-9 13.7-9 23 3 17 9 23 13.7 9 23 9h96v576h672c9.3 0 17-3 23-9s9-13.7 9-23-3-17-9-23-13.7-9-23-9H256v-64zM256 192h622l-96 384H256zm432 641c-13.3 0-24.5 4.5-33.5 13.5S641 866.7 641 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5c13.3-.7 24.5-5.5 33.5-14.5S735 893.3 735 880s-4.5-24.5-13.5-33.5S701.3 833 688 833"
      })
    ]));
  }
});

// src/components/shopping-trolley.vue
var shopping_trolley_default = shopping_trolley_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/smoking.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent239 } from "vue";
import { createElementVNode as _createElementVNode239, openBlock as _openBlock239, createElementBlock as _createElementBlock239 } from "vue";
var smoking_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent239({
  name: "Smoking",
  __name: "smoking",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock239(), _createElementBlock239("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode239("path", {
        fill: "currentColor",
        d: "M256 576v128h640V576zm-32-64h704a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32"
      }),
      _createElementVNode239("path", {
        fill: "currentColor",
        d: "M704 576h64v128h-64zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
      })
    ]));
  }
});

// src/components/smoking.vue
var smoking_default = smoking_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/soccer.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent240 } from "vue";
import { createElementVNode as _createElementVNode240, openBlock as _openBlock240, createElementBlock as _createElementBlock240 } from "vue";
var soccer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent240({
  name: "Soccer",
  __name: "soccer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock240(), _createElementBlock240("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode240("path", {
        fill: "currentColor",
        d: "M418.496 871.04 152.256 604.8c-16.512 94.016-2.368 178.624 42.944 224 44.928 44.928 129.344 58.752 223.296 42.24m72.32-18.176a573.056 573.056 0 0 0 224.832-137.216 573.12 573.12 0 0 0 137.216-224.832L533.888 171.84a578.56 578.56 0 0 0-227.52 138.496A567.68 567.68 0 0 0 170.432 532.48l320.384 320.384zM871.04 418.496c16.512-93.952 2.688-178.368-42.24-223.296-44.544-44.544-128.704-58.048-222.592-41.536zM149.952 874.048c-112.96-112.96-88.832-408.96 111.168-608.96C461.056 65.152 760.96 36.928 874.048 149.952c113.024 113.024 86.784 411.008-113.152 610.944-199.936 199.936-497.92 226.112-610.944 113.152m452.544-497.792 22.656-22.656a32 32 0 0 1 45.248 45.248l-22.656 22.656 45.248 45.248A32 32 0 1 1 647.744 512l-45.248-45.248L557.248 512l45.248 45.248a32 32 0 1 1-45.248 45.248L512 557.248l-45.248 45.248L512 647.744a32 32 0 1 1-45.248 45.248l-45.248-45.248-22.656 22.656a32 32 0 1 1-45.248-45.248l22.656-22.656-45.248-45.248A32 32 0 1 1 376.256 512l45.248 45.248L466.752 512l-45.248-45.248a32 32 0 1 1 45.248-45.248L512 466.752l45.248-45.248L512 376.256a32 32 0 0 1 45.248-45.248l45.248 45.248z"
      })
    ]));
  }
});

// src/components/soccer.vue
var soccer_default = soccer_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sold-out.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent241 } from "vue";
import { createElementVNode as _createElementVNode241, openBlock as _openBlock241, createElementBlock as _createElementBlock241 } from "vue";
var sold_out_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent241({
  name: "SoldOut",
  __name: "sold-out",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock241(), _createElementBlock241("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode241("path", {
        fill: "currentColor",
        d: "M704 288h131.072a32 32 0 0 1 31.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4h256zm201.408 476.16a32 32 0 1 1 45.248 45.184l-128 128a32 32 0 0 1-45.248 0l-128-128a32 32 0 1 1 45.248-45.248L704 837.504V608a32 32 0 1 1 64 0v229.504l73.408-73.408z"
      })
    ]));
  }
});

// src/components/sold-out.vue
var sold_out_default = sold_out_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sort-down.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent242 } from "vue";
import { createElementVNode as _createElementVNode242, openBlock as _openBlock242, createElementBlock as _createElementBlock242 } from "vue";
var sort_down_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent242({
  name: "SortDown",
  __name: "sort-down",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock242(), _createElementBlock242("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode242("path", {
        fill: "currentColor",
        d: "M576 96v709.568L333.312 562.816A32 32 0 1 0 288 608l297.408 297.344A32 32 0 0 0 640 882.688V96a32 32 0 0 0-64 0"
      })
    ]));
  }
});

// src/components/sort-down.vue
var sort_down_default = sort_down_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sort-up.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent243 } from "vue";
import { createElementVNode as _createElementVNode243, openBlock as _openBlock243, createElementBlock as _createElementBlock243 } from "vue";
var sort_up_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent243({
  name: "SortUp",
  __name: "sort-up",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock243(), _createElementBlock243("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode243("path", {
        fill: "currentColor",
        d: "M384 141.248V928a32 32 0 1 0 64 0V218.56l242.688 242.688A32 32 0 1 0 736 416L438.592 118.656A32 32 0 0 0 384 141.248"
      })
    ]));
  }
});

// src/components/sort-up.vue
var sort_up_default = sort_up_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sort.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent244 } from "vue";
import { createElementVNode as _createElementVNode244, openBlock as _openBlock244, createElementBlock as _createElementBlock244 } from "vue";
var sort_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent244({
  name: "Sort",
  __name: "sort",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock244(), _createElementBlock244("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode244("path", {
        fill: "currentColor",
        d: "M384 96a32 32 0 0 1 64 0v786.752a32 32 0 0 1-54.592 22.656L95.936 608a32 32 0 0 1 0-45.312h.128a32 32 0 0 1 45.184 0L384 805.632zm192 45.248a32 32 0 0 1 54.592-22.592L928.064 416a32 32 0 0 1 0 45.312h-.128a32 32 0 0 1-45.184 0L640 218.496V928a32 32 0 1 1-64 0V141.248z"
      })
    ]));
  }
});

// src/components/sort.vue
var sort_default = sort_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/stamp.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent245 } from "vue";
import { createElementVNode as _createElementVNode245, openBlock as _openBlock245, createElementBlock as _createElementBlock245 } from "vue";
var stamp_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent245({
  name: "Stamp",
  __name: "stamp",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock245(), _createElementBlock245("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode245("path", {
        fill: "currentColor",
        d: "M624 475.968V640h144a128 128 0 0 1 128 128H128a128 128 0 0 1 128-128h144V475.968a192 192 0 1 1 224 0M128 896v-64h768v64z"
      })
    ]));
  }
});

// src/components/stamp.vue
var stamp_default = stamp_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/star-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent246 } from "vue";
import { createElementVNode as _createElementVNode246, openBlock as _openBlock246, createElementBlock as _createElementBlock246 } from "vue";
var star_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent246({
  name: "StarFilled",
  __name: "star-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock246(), _createElementBlock246("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode246("path", {
        fill: "currentColor",
        d: "M283.84 867.84 512 747.776l228.16 119.936a6.4 6.4 0 0 0 9.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 0 0-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 0 0-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 0 0-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 0 0 9.28 6.72z"
      })
    ]));
  }
});

// src/components/star-filled.vue
var star_filled_default = star_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/star.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent247 } from "vue";
import { createElementVNode as _createElementVNode247, openBlock as _openBlock247, createElementBlock as _createElementBlock247 } from "vue";
var star_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent247({
  name: "Star",
  __name: "star",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock247(), _createElementBlock247("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode247("path", {
        fill: "currentColor",
        d: "m512 747.84 228.16 119.936a6.4 6.4 0 0 0 9.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 0 0-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 0 0-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 0 0-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 0 0 9.28 6.72zM313.6 924.48a70.4 70.4 0 0 1-102.144-74.24l37.888-220.928L88.96 472.96A70.4 70.4 0 0 1 128 352.896l221.76-32.256 99.2-200.96a70.4 70.4 0 0 1 126.208 0l99.2 200.96 221.824 32.256a70.4 70.4 0 0 1 39.04 120.064L774.72 629.376l37.888 220.928a70.4 70.4 0 0 1-102.144 74.24L512 820.096l-198.4 104.32z"
      })
    ]));
  }
});

// src/components/star.vue
var star_default = star_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/stopwatch.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent248 } from "vue";
import { createElementVNode as _createElementVNode248, openBlock as _openBlock248, createElementBlock as _createElementBlock248 } from "vue";
var stopwatch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent248({
  name: "Stopwatch",
  __name: "stopwatch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock248(), _createElementBlock248("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode248("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      _createElementVNode248("path", {
        fill: "currentColor",
        d: "M672 234.88c-39.168 174.464-80 298.624-122.688 372.48-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
      })
    ]));
  }
});

// src/components/stopwatch.vue
var stopwatch_default = stopwatch_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/success-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent249 } from "vue";
import { createElementVNode as _createElementVNode249, openBlock as _openBlock249, createElementBlock as _createElementBlock249 } from "vue";
var success_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent249({
  name: "SuccessFilled",
  __name: "success-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock249(), _createElementBlock249("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode249("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
      })
    ]));
  }
});

// src/components/success-filled.vue
var success_filled_default = success_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sugar.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent250 } from "vue";
import { createElementVNode as _createElementVNode250, openBlock as _openBlock250, createElementBlock as _createElementBlock250 } from "vue";
var sugar_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent250({
  name: "Sugar",
  __name: "sugar",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock250(), _createElementBlock250("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode250("path", {
        fill: "currentColor",
        d: "m801.728 349.184 4.48 4.48a128 128 0 0 1 0 180.992L534.656 806.144a128 128 0 0 1-181.056 0l-4.48-4.48-19.392 109.696a64 64 0 0 1-108.288 34.176L78.464 802.56a64 64 0 0 1 34.176-108.288l109.76-19.328-4.544-4.544a128 128 0 0 1 0-181.056l271.488-271.488a128 128 0 0 1 181.056 0l4.48 4.48 19.392-109.504a64 64 0 0 1 108.352-34.048l142.592 143.04a64 64 0 0 1-34.24 108.16l-109.248 19.2zm-548.8 198.72h447.168v2.24l60.8-60.8a63.808 63.808 0 0 0 18.752-44.416h-426.88l-89.664 89.728a64.064 64.064 0 0 0-10.24 13.248zm0 64c2.752 4.736 6.144 9.152 10.176 13.248l135.744 135.744a64 64 0 0 0 90.496 0L638.4 611.904zm490.048-230.976L625.152 263.104a64 64 0 0 0-90.496 0L416.768 380.928zM123.712 757.312l142.976 142.976 24.32-137.6a25.6 25.6 0 0 0-29.696-29.632l-137.6 24.256zm633.6-633.344-24.32 137.472a25.6 25.6 0 0 0 29.632 29.632l137.28-24.064-142.656-143.04z"
      })
    ]));
  }
});

// src/components/sugar.vue
var sugar_default = sugar_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/suitcase-line.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent251 } from "vue";
import { createElementVNode as _createElementVNode251, openBlock as _openBlock251, createElementBlock as _createElementBlock251 } from "vue";
var suitcase_line_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent251({
  name: "SuitcaseLine",
  __name: "suitcase-line",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock251(), _createElementBlock251("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode251("path", {
        fill: "currentColor",
        d: "M922.5 229.5c-24.32-24.34-54.49-36.84-90.5-37.5H704v-64c-.68-17.98-7.02-32.98-19.01-44.99S658.01 64.66 640 64H384c-17.98.68-32.98 7.02-44.99 19.01S320.66 110 320 128v64H192c-35.99.68-66.16 13.18-90.5 37.5C77.16 253.82 64.66 283.99 64 320v448c.68 35.99 13.18 66.16 37.5 90.5s54.49 36.84 90.5 37.5h640c35.99-.68 66.16-13.18 90.5-37.5s36.84-54.49 37.5-90.5V320c-.68-35.99-13.18-66.16-37.5-90.5M384 128h256v64H384zM256 832h-64c-17.98-.68-32.98-7.02-44.99-19.01S128.66 786.01 128 768V448h128zm448 0H320V448h384zm192-64c-.68 17.98-7.02 32.98-19.01 44.99S850.01 831.34 832 832h-64V448h128zm0-384H128v-64c.69-17.98 7.02-32.98 19.01-44.99S173.99 256.66 192 256h640c17.98.69 32.98 7.02 44.99 19.01S895.34 301.99 896 320z"
      })
    ]));
  }
});

// src/components/suitcase-line.vue
var suitcase_line_default = suitcase_line_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/suitcase.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent252 } from "vue";
import { createElementVNode as _createElementVNode252, openBlock as _openBlock252, createElementBlock as _createElementBlock252 } from "vue";
var suitcase_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent252({
  name: "Suitcase",
  __name: "suitcase",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock252(), _createElementBlock252("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode252("path", {
        fill: "currentColor",
        d: "M128 384h768v-64a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64zm0 64v320a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V448zm64-256h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
      }),
      _createElementVNode252("path", {
        fill: "currentColor",
        d: "M384 128v64h256v-64zm0-64h256a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64"
      })
    ]));
  }
});

// src/components/suitcase.vue
var suitcase_default = suitcase_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sunny.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent253 } from "vue";
import { createElementVNode as _createElementVNode253, openBlock as _openBlock253, createElementBlock as _createElementBlock253 } from "vue";
var sunny_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent253({
  name: "Sunny",
  __name: "sunny",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock253(), _createElementBlock253("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode253("path", {
        fill: "currentColor",
        d: "M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m0-704a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 768a32 32 0 0 1 32 32v64a32 32 0 1 1-64 0v-64a32 32 0 0 1 32-32M195.2 195.2a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 1 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm543.104 543.104a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 0 1-45.248 45.248l-45.248-45.248a32 32 0 0 1 0-45.248M64 512a32 32 0 0 1 32-32h64a32 32 0 0 1 0 64H96a32 32 0 0 1-32-32m768 0a32 32 0 0 1 32-32h64a32 32 0 1 1 0 64h-64a32 32 0 0 1-32-32M195.2 828.8a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248L240.448 828.8a32 32 0 0 1-45.248 0zm543.104-543.104a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248l-45.248 45.248a32 32 0 0 1-45.248 0"
      })
    ]));
  }
});

// src/components/sunny.vue
var sunny_default = sunny_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sunrise.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent254 } from "vue";
import { createElementVNode as _createElementVNode254, openBlock as _openBlock254, createElementBlock as _createElementBlock254 } from "vue";
var sunrise_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent254({
  name: "Sunrise",
  __name: "sunrise",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock254(), _createElementBlock254("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode254("path", {
        fill: "currentColor",
        d: "M32 768h960a32 32 0 1 1 0 64H32a32 32 0 1 1 0-64m129.408-96a352 352 0 0 1 701.184 0h-64.32a288 288 0 0 0-572.544 0h-64.32zM512 128a32 32 0 0 1 32 32v96a32 32 0 0 1-64 0v-96a32 32 0 0 1 32-32m407.296 168.704a32 32 0 0 1 0 45.248l-67.84 67.84a32 32 0 1 1-45.248-45.248l67.84-67.84a32 32 0 0 1 45.248 0zm-814.592 0a32 32 0 0 1 45.248 0l67.84 67.84a32 32 0 1 1-45.248 45.248l-67.84-67.84a32 32 0 0 1 0-45.248"
      })
    ]));
  }
});

// src/components/sunrise.vue
var sunrise_default = sunrise_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/sunset.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent255 } from "vue";
import { createElementVNode as _createElementVNode255, openBlock as _openBlock255, createElementBlock as _createElementBlock255 } from "vue";
var sunset_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent255({
  name: "Sunset",
  __name: "sunset",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock255(), _createElementBlock255("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode255("path", {
        fill: "currentColor",
        d: "M82.56 640a448 448 0 1 1 858.88 0h-67.2a384 384 0 1 0-724.288 0zM32 704h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m256 128h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      })
    ]));
  }
});

// src/components/sunset.vue
var sunset_default = sunset_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/switch-button.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent256 } from "vue";
import { createElementVNode as _createElementVNode256, openBlock as _openBlock256, createElementBlock as _createElementBlock256 } from "vue";
var switch_button_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent256({
  name: "SwitchButton",
  __name: "switch-button",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock256(), _createElementBlock256("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode256("path", {
        fill: "currentColor",
        d: "M352 159.872V230.4a352 352 0 1 0 320 0v-70.528A416.128 416.128 0 0 1 512 960a416 416 0 0 1-160-800.128z"
      }),
      _createElementVNode256("path", {
        fill: "currentColor",
        d: "M512 64q32 0 32 32v320q0 32-32 32t-32-32V96q0-32 32-32"
      })
    ]));
  }
});

// src/components/switch-button.vue
var switch_button_default = switch_button_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/switch-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent257 } from "vue";
import { createElementVNode as _createElementVNode257, openBlock as _openBlock257, createElementBlock as _createElementBlock257 } from "vue";
var switch_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent257({
  name: "SwitchFilled",
  __name: "switch-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock257(), _createElementBlock257("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode257("path", {
        fill: "currentColor",
        d: "M247.47 358.4v.04c.07 19.17 7.72 37.53 21.27 51.09s31.92 21.2 51.09 21.27c39.86 0 72.41-32.6 72.41-72.4s-32.6-72.36-72.41-72.36-72.36 32.55-72.36 72.36z"
      }),
      _createElementVNode257("path", {
        fill: "currentColor",
        d: "M492.38 128H324.7c-52.16 0-102.19 20.73-139.08 57.61a196.655 196.655 0 0 0-57.61 139.08V698.7c-.01 25.84 5.08 51.42 14.96 75.29s24.36 45.56 42.63 63.83 39.95 32.76 63.82 42.65a196.67 196.67 0 0 0 75.28 14.98h167.68c3.03 0 5.46-2.43 5.46-5.42V133.42c.6-2.99-1.83-5.42-5.46-5.42zm-56.11 705.88H324.7c-17.76.13-35.36-3.33-51.75-10.18s-31.22-16.94-43.61-29.67c-25.3-25.35-39.81-59.1-39.81-95.32V324.69c-.13-17.75 3.33-35.35 10.17-51.74a131.695 131.695 0 0 1 29.64-43.62c25.39-25.3 59.14-39.81 95.36-39.81h111.57zm402.12-647.67a196.655 196.655 0 0 0-139.08-57.61H580.48c-3.03 0-4.82 2.43-4.82 4.82v757.16c-.6 2.99 1.79 5.42 5.42 5.42h118.23a196.69 196.69 0 0 0 139.08-57.61A196.655 196.655 0 0 0 896 699.31V325.29a196.69 196.69 0 0 0-57.61-139.08zm-111.3 441.92c-42.83 0-77.82-34.99-77.82-77.82s34.98-77.82 77.82-77.82c42.83 0 77.82 34.99 77.82 77.82s-34.99 77.82-77.82 77.82z"
      })
    ]));
  }
});

// src/components/switch-filled.vue
var switch_filled_default = switch_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/switch.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent258 } from "vue";
import { createElementVNode as _createElementVNode258, openBlock as _openBlock258, createElementBlock as _createElementBlock258 } from "vue";
var switch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent258({
  name: "Switch",
  __name: "switch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock258(), _createElementBlock258("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode258("path", {
        fill: "currentColor",
        d: "M118.656 438.656a32 32 0 0 1 0-45.248L416 96l4.48-3.776A32 32 0 0 1 461.248 96l3.712 4.48a32.064 32.064 0 0 1-3.712 40.832L218.56 384H928a32 32 0 1 1 0 64H141.248a32 32 0 0 1-22.592-9.344zM64 608a32 32 0 0 1 32-32h786.752a32 32 0 0 1 22.656 54.592L608 928l-4.48 3.776a32.064 32.064 0 0 1-40.832-49.024L805.632 640H96a32 32 0 0 1-32-32"
      })
    ]));
  }
});

// src/components/switch.vue
var switch_default = switch_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/takeaway-box.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent259 } from "vue";
import { createElementVNode as _createElementVNode259, openBlock as _openBlock259, createElementBlock as _createElementBlock259 } from "vue";
var takeaway_box_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent259({
  name: "TakeawayBox",
  __name: "takeaway-box",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock259(), _createElementBlock259("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode259("path", {
        fill: "currentColor",
        d: "M832 384H192v448h640zM96 320h832V128H96zm800 64v480a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V384H64a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h896a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zM416 512h192a32 32 0 0 1 0 64H416a32 32 0 0 1 0-64"
      })
    ]));
  }
});

// src/components/takeaway-box.vue
var takeaway_box_default = takeaway_box_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/ticket.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent260 } from "vue";
import { createElementVNode as _createElementVNode260, openBlock as _openBlock260, createElementBlock as _createElementBlock260 } from "vue";
var ticket_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent260({
  name: "Ticket",
  __name: "ticket",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock260(), _createElementBlock260("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode260("path", {
        fill: "currentColor",
        d: "M640 832H64V640a128 128 0 1 0 0-256V192h576v160h64V192h256v192a128 128 0 1 0 0 256v192H704V672h-64zm0-416v192h64V416z"
      })
    ]));
  }
});

// src/components/ticket.vue
var ticket_default = ticket_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/tickets.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent261 } from "vue";
import { createElementVNode as _createElementVNode261, openBlock as _openBlock261, createElementBlock as _createElementBlock261 } from "vue";
var tickets_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent261({
  name: "Tickets",
  __name: "tickets",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock261(), _createElementBlock261("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode261("path", {
        fill: "currentColor",
        d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h192v64H320zm0 384h384v64H320z"
      })
    ]));
  }
});

// src/components/tickets.vue
var tickets_default = tickets_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/timer.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent262 } from "vue";
import { createElementVNode as _createElementVNode262, openBlock as _openBlock262, createElementBlock as _createElementBlock262 } from "vue";
var timer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent262({
  name: "Timer",
  __name: "timer",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock262(), _createElementBlock262("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode262("path", {
        fill: "currentColor",
        d: "M512 896a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
      }),
      _createElementVNode262("path", {
        fill: "currentColor",
        d: "M512 320a32 32 0 0 1 32 32l-.512 224a32 32 0 1 1-64 0L480 352a32 32 0 0 1 32-32"
      }),
      _createElementVNode262("path", {
        fill: "currentColor",
        d: "M448 576a64 64 0 1 0 128 0 64 64 0 1 0-128 0m96-448v128h-64V128h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64z"
      })
    ]));
  }
});

// src/components/timer.vue
var timer_default = timer_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/toilet-paper.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent263 } from "vue";
import { createElementVNode as _createElementVNode263, openBlock as _openBlock263, createElementBlock as _createElementBlock263 } from "vue";
var toilet_paper_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent263({
  name: "ToiletPaper",
  __name: "toilet-paper",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock263(), _createElementBlock263("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode263("path", {
        fill: "currentColor",
        d: "M595.2 128H320a192 192 0 0 0-192 192v576h384V352c0-90.496 32.448-171.2 83.2-224M736 64c123.712 0 224 128.96 224 288S859.712 640 736 640H576v320H64V320A256 256 0 0 1 320 64zM576 352v224h160c84.352 0 160-97.28 160-224s-75.648-224-160-224-160 97.28-160 224"
      }),
      _createElementVNode263("path", {
        fill: "currentColor",
        d: "M736 448c-35.328 0-64-43.008-64-96s28.672-96 64-96 64 43.008 64 96-28.672 96-64 96"
      })
    ]));
  }
});

// src/components/toilet-paper.vue
var toilet_paper_default = toilet_paper_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/tools.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent264 } from "vue";
import { createElementVNode as _createElementVNode264, openBlock as _openBlock264, createElementBlock as _createElementBlock264 } from "vue";
var tools_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent264({
  name: "Tools",
  __name: "tools",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock264(), _createElementBlock264("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode264("path", {
        fill: "currentColor",
        d: "M764.416 254.72a351.68 351.68 0 0 1 86.336 149.184H960v192.064H850.752a351.68 351.68 0 0 1-86.336 149.312l54.72 94.72-166.272 96-54.592-94.72a352.64 352.64 0 0 1-172.48 0L371.136 936l-166.272-96 54.72-94.72a351.68 351.68 0 0 1-86.336-149.312H64v-192h109.248a351.68 351.68 0 0 1 86.336-149.312L204.8 160l166.208-96h.192l54.656 94.592a352.64 352.64 0 0 1 172.48 0L652.8 64h.128L819.2 160l-54.72 94.72zM704 499.968a192 192 0 1 0-384 0 192 192 0 0 0 384 0"
      })
    ]));
  }
});

// src/components/tools.vue
var tools_default = tools_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/top-left.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent265 } from "vue";
import { createElementVNode as _createElementVNode265, openBlock as _openBlock265, createElementBlock as _createElementBlock265 } from "vue";
var top_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent265({
  name: "TopLeft",
  __name: "top-left",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock265(), _createElementBlock265("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode265("path", {
        fill: "currentColor",
        d: "M256 256h416a32 32 0 1 0 0-64H224a32 32 0 0 0-32 32v448a32 32 0 0 0 64 0z"
      }),
      _createElementVNode265("path", {
        fill: "currentColor",
        d: "M246.656 201.344a32 32 0 0 0-45.312 45.312l544 544a32 32 0 0 0 45.312-45.312l-544-544z"
      })
    ]));
  }
});

// src/components/top-left.vue
var top_left_default = top_left_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/top-right.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent266 } from "vue";
import { createElementVNode as _createElementVNode266, openBlock as _openBlock266, createElementBlock as _createElementBlock266 } from "vue";
var top_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent266({
  name: "TopRight",
  __name: "top-right",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock266(), _createElementBlock266("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode266("path", {
        fill: "currentColor",
        d: "M768 256H353.6a32 32 0 1 1 0-64H800a32 32 0 0 1 32 32v448a32 32 0 0 1-64 0z"
      }),
      _createElementVNode266("path", {
        fill: "currentColor",
        d: "M777.344 201.344a32 32 0 0 1 45.312 45.312l-544 544a32 32 0 0 1-45.312-45.312l544-544z"
      })
    ]));
  }
});

// src/components/top-right.vue
var top_right_default = top_right_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/top.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent267 } from "vue";
import { createElementVNode as _createElementVNode267, openBlock as _openBlock267, createElementBlock as _createElementBlock267 } from "vue";
var top_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent267({
  name: "Top",
  __name: "top",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock267(), _createElementBlock267("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode267("path", {
        fill: "currentColor",
        d: "M572.235 205.282v600.365a30.118 30.118 0 1 1-60.235 0V205.282L292.382 438.633a28.913 28.913 0 0 1-42.646 0 33.43 33.43 0 0 1 0-45.236l271.058-288.045a28.913 28.913 0 0 1 42.647 0L834.5 393.397a33.43 33.43 0 0 1 0 45.176 28.913 28.913 0 0 1-42.647 0l-219.618-233.23z"
      })
    ]));
  }
});

// src/components/top.vue
var top_default = top_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/trend-charts.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent268 } from "vue";
import { createElementVNode as _createElementVNode268, openBlock as _openBlock268, createElementBlock as _createElementBlock268 } from "vue";
var trend_charts_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent268({
  name: "TrendCharts",
  __name: "trend-charts",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock268(), _createElementBlock268("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode268("path", {
        fill: "currentColor",
        d: "M128 896V128h768v768zm291.712-327.296 128 102.4 180.16-201.792-47.744-42.624-139.84 156.608-128-102.4-180.16 201.792 47.744 42.624 139.84-156.608zM816 352a48 48 0 1 0-96 0 48 48 0 0 0 96 0"
      })
    ]));
  }
});

// src/components/trend-charts.vue
var trend_charts_default = trend_charts_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/trophy-base.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent269 } from "vue";
import { createElementVNode as _createElementVNode269, openBlock as _openBlock269, createElementBlock as _createElementBlock269 } from "vue";
var trophy_base_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent269({
  name: "TrophyBase",
  __name: "trophy-base",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock269(), _createElementBlock269("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode269("path", {
        fill: "currentColor",
        d: "M918.4 201.6c-6.4-6.4-12.8-9.6-22.4-9.6H768V96c0-9.6-3.2-16-9.6-22.4C752 67.2 745.6 64 736 64H288c-9.6 0-16 3.2-22.4 9.6C259.2 80 256 86.4 256 96v96H128c-9.6 0-16 3.2-22.4 9.6-6.4 6.4-9.6 16-9.6 22.4 3.2 108.8 25.6 185.6 64 224 34.4 34.4 77.56 55.65 127.65 61.99 10.91 20.44 24.78 39.25 41.95 56.41 40.86 40.86 91 65.47 150.4 71.9V768h-96c-9.6 0-16 3.2-22.4 9.6-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4c6.4 6.4 12.8 9.6 22.4 9.6h256c9.6 0 16-3.2 22.4-9.6 6.4-6.4 9.6-12.8 9.6-22.4s-3.2-16-9.6-22.4c-6.4-6.4-12.8-9.6-22.4-9.6h-96V637.26c59.4-7.71 109.54-30.01 150.4-70.86 17.2-17.2 31.51-36.06 42.81-56.55 48.93-6.51 90.02-27.7 126.79-61.85 38.4-38.4 60.8-112 64-224 0-6.4-3.2-16-9.6-22.4zM256 438.4c-19.2-6.4-35.2-19.2-51.2-35.2-22.4-22.4-35.2-70.4-41.6-147.2H256zm390.4 80C608 553.6 566.4 576 512 576s-99.2-19.2-134.4-57.6C342.4 480 320 438.4 320 384V128h384v256c0 54.4-19.2 99.2-57.6 134.4m172.8-115.2c-16 16-32 25.6-51.2 35.2V256h92.8c-6.4 76.8-19.2 124.8-41.6 147.2zM768 896H256c-9.6 0-16 3.2-22.4 9.6-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4c6.4 6.4 12.8 9.6 22.4 9.6h512c9.6 0 16-3.2 22.4-9.6 6.4-6.4 9.6-12.8 9.6-22.4s-3.2-16-9.6-22.4c-6.4-6.4-12.8-9.6-22.4-9.6"
      })
    ]));
  }
});

// src/components/trophy-base.vue
var trophy_base_default = trophy_base_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/trophy.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent270 } from "vue";
import { createElementVNode as _createElementVNode270, openBlock as _openBlock270, createElementBlock as _createElementBlock270 } from "vue";
var trophy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent270({
  name: "Trophy",
  __name: "trophy",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock270(), _createElementBlock270("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode270("path", {
        fill: "currentColor",
        d: "M480 896V702.08A256.256 256.256 0 0 1 264.064 512h-32.64a96 96 0 0 1-91.968-68.416L93.632 290.88a76.8 76.8 0 0 1 73.6-98.88H256V96a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v96h88.768a76.8 76.8 0 0 1 73.6 98.88L884.48 443.52A96 96 0 0 1 792.576 512h-32.64A256.256 256.256 0 0 1 544 702.08V896h128a32 32 0 1 1 0 64H352a32 32 0 1 1 0-64zm224-448V128H320v320a192 192 0 1 0 384 0m64 0h24.576a32 32 0 0 0 30.656-22.784l45.824-152.768A12.8 12.8 0 0 0 856.768 256H768zm-512 0V256h-88.768a12.8 12.8 0 0 0-12.288 16.448l45.824 152.768A32 32 0 0 0 231.424 448z"
      })
    ]));
  }
});

// src/components/trophy.vue
var trophy_default = trophy_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/turn-off.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent271 } from "vue";
import { createElementVNode as _createElementVNode271, openBlock as _openBlock271, createElementBlock as _createElementBlock271 } from "vue";
var turn_off_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent271({
  name: "TurnOff",
  __name: "turn-off",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock271(), _createElementBlock271("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode271("path", {
        fill: "currentColor",
        d: "M329.956 257.138a254.862 254.862 0 0 0 0 509.724h364.088a254.862 254.862 0 0 0 0-509.724zm0-72.818h364.088a327.68 327.68 0 1 1 0 655.36H329.956a327.68 327.68 0 1 1 0-655.36z"
      }),
      _createElementVNode271("path", {
        fill: "currentColor",
        d: "M329.956 621.227a109.227 109.227 0 1 0 0-218.454 109.227 109.227 0 0 0 0 218.454m0 72.817a182.044 182.044 0 1 1 0-364.088 182.044 182.044 0 0 1 0 364.088"
      })
    ]));
  }
});

// src/components/turn-off.vue
var turn_off_default = turn_off_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/umbrella.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent272 } from "vue";
import { createElementVNode as _createElementVNode272, openBlock as _openBlock272, createElementBlock as _createElementBlock272 } from "vue";
var umbrella_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent272({
  name: "Umbrella",
  __name: "umbrella",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock272(), _createElementBlock272("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode272("path", {
        fill: "currentColor",
        d: "M320 768a32 32 0 1 1 64 0 64 64 0 0 0 128 0V512H64a448 448 0 1 1 896 0H576v256a128 128 0 1 1-256 0m570.688-320a384.128 384.128 0 0 0-757.376 0z"
      })
    ]));
  }
});

// src/components/umbrella.vue
var umbrella_default = umbrella_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/unlock.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent273 } from "vue";
import { createElementVNode as _createElementVNode273, openBlock as _openBlock273, createElementBlock as _createElementBlock273 } from "vue";
var unlock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent273({
  name: "Unlock",
  __name: "unlock",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock273(), _createElementBlock273("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode273("path", {
        fill: "currentColor",
        d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
      }),
      _createElementVNode273("path", {
        fill: "currentColor",
        d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m178.304-295.296A192.064 192.064 0 0 0 320 320v64h352l96 38.4V448H256V320a256 256 0 0 1 493.76-95.104z"
      })
    ]));
  }
});

// src/components/unlock.vue
var unlock_default = unlock_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/upload-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent274 } from "vue";
import { createElementVNode as _createElementVNode274, openBlock as _openBlock274, createElementBlock as _createElementBlock274 } from "vue";
var upload_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent274({
  name: "UploadFilled",
  __name: "upload-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock274(), _createElementBlock274("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode274("path", {
        fill: "currentColor",
        d: "M544 864V672h128L512 480 352 672h128v192H320v-1.6c-5.376.32-10.496 1.6-16 1.6A240 240 0 0 1 64 624c0-123.136 93.12-223.488 212.608-237.248A239.808 239.808 0 0 1 512 192a239.872 239.872 0 0 1 235.456 194.752c119.488 13.76 212.48 114.112 212.48 237.248a240 240 0 0 1-240 240c-5.376 0-10.56-1.28-16-1.6v1.6z"
      })
    ]));
  }
});

// src/components/upload-filled.vue
var upload_filled_default = upload_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/upload.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent275 } from "vue";
import { createElementVNode as _createElementVNode275, openBlock as _openBlock275, createElementBlock as _createElementBlock275 } from "vue";
var upload_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent275({
  name: "Upload",
  __name: "upload",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock275(), _createElementBlock275("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode275("path", {
        fill: "currentColor",
        d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-578.304V704h-64V247.296L237.248 490.048 192 444.8 508.8 128l316.8 316.8-45.312 45.248z"
      })
    ]));
  }
});

// src/components/upload.vue
var upload_default = upload_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/user-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent276 } from "vue";
import { createElementVNode as _createElementVNode276, openBlock as _openBlock276, createElementBlock as _createElementBlock276 } from "vue";
var user_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent276({
  name: "UserFilled",
  __name: "user-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock276(), _createElementBlock276("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode276("path", {
        fill: "currentColor",
        d: "M288 320a224 224 0 1 0 448 0 224 224 0 1 0-448 0m544 608H160a32 32 0 0 1-32-32v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 0 1-32 32z"
      })
    ]));
  }
});

// src/components/user-filled.vue
var user_filled_default = user_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/user.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent277 } from "vue";
import { createElementVNode as _createElementVNode277, openBlock as _openBlock277, createElementBlock as _createElementBlock277 } from "vue";
var user_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent277({
  name: "User",
  __name: "user",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock277(), _createElementBlock277("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode277("path", {
        fill: "currentColor",
        d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m320 320v-96a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v96a32 32 0 1 1-64 0v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 1 1-64 0"
      })
    ]));
  }
});

// src/components/user.vue
var user_default = user_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/van.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent278 } from "vue";
import { createElementVNode as _createElementVNode278, openBlock as _openBlock278, createElementBlock as _createElementBlock278 } from "vue";
var van_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent278({
  name: "Van",
  __name: "van",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock278(), _createElementBlock278("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode278("path", {
        fill: "currentColor",
        d: "M128.896 736H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v96h164.544a32 32 0 0 1 31.616 27.136l54.144 352A32 32 0 0 1 922.688 736h-91.52a144 144 0 1 1-286.272 0H415.104a144 144 0 1 1-286.272 0zm23.36-64a143.872 143.872 0 0 1 239.488 0H568.32c17.088-25.6 42.24-45.376 71.744-55.808V256H128v416zm655.488 0h77.632l-19.648-128H704v64.896A144 144 0 0 1 807.744 672m48.128-192-14.72-96H704v96h151.872M688 832a80 80 0 1 0 0-160 80 80 0 0 0 0 160m-416 0a80 80 0 1 0 0-160 80 80 0 0 0 0 160"
      })
    ]));
  }
});

// src/components/van.vue
var van_default = van_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/video-camera-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent279 } from "vue";
import { createElementVNode as _createElementVNode279, openBlock as _openBlock279, createElementBlock as _createElementBlock279 } from "vue";
var video_camera_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent279({
  name: "VideoCameraFilled",
  __name: "video-camera-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock279(), _createElementBlock279("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode279("path", {
        fill: "currentColor",
        d: "m768 576 192-64v320l-192-64v96a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V480a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zM192 768v64h384v-64zm192-480a160 160 0 0 1 320 0 160 160 0 0 1-320 0m64 0a96 96 0 1 0 192.064-.064A96 96 0 0 0 448 288m-320 32a128 128 0 1 1 256.064.064A128 128 0 0 1 128 320m64 0a64 64 0 1 0 128 0 64 64 0 0 0-128 0"
      })
    ]));
  }
});

// src/components/video-camera-filled.vue
var video_camera_filled_default = video_camera_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/video-camera.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent280 } from "vue";
import { createElementVNode as _createElementVNode280, openBlock as _openBlock280, createElementBlock as _createElementBlock280 } from "vue";
var video_camera_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent280({
  name: "VideoCamera",
  __name: "video-camera",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock280(), _createElementBlock280("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode280("path", {
        fill: "currentColor",
        d: "M704 768V256H128v512zm64-416 192-96v512l-192-96v128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 71.552v176.896l128 64V359.552zM192 320h192v64H192z"
      })
    ]));
  }
});

// src/components/video-camera.vue
var video_camera_default = video_camera_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/video-pause.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent281 } from "vue";
import { createElementVNode as _createElementVNode281, openBlock as _openBlock281, createElementBlock as _createElementBlock281 } from "vue";
var video_pause_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent281({
  name: "VideoPause",
  __name: "video-pause",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock281(), _createElementBlock281("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode281("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-96-544q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32m192 0q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32"
      })
    ]));
  }
});

// src/components/video-pause.vue
var video_pause_default = video_pause_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/video-play.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent282 } from "vue";
import { createElementVNode as _createElementVNode282, openBlock as _openBlock282, createElementBlock as _createElementBlock282 } from "vue";
var video_play_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent282({
  name: "VideoPlay",
  __name: "video-play",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock282(), _createElementBlock282("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode282("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-48-247.616L668.608 512 464 375.616zm10.624-342.656 249.472 166.336a48 48 0 0 1 0 79.872L474.624 718.272A48 48 0 0 1 400 678.336V345.6a48 48 0 0 1 74.624-39.936z"
      })
    ]));
  }
});

// src/components/video-play.vue
var video_play_default = video_play_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/view.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent283 } from "vue";
import { createElementVNode as _createElementVNode283, openBlock as _openBlock283, createElementBlock as _createElementBlock283 } from "vue";
var view_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent283({
  name: "View",
  __name: "view",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock283(), _createElementBlock283("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode283("path", {
        fill: "currentColor",
        d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352m0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448m0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160"
      })
    ]));
  }
});

// src/components/view.vue
var view_default = view_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/wallet-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent284 } from "vue";
import { createElementVNode as _createElementVNode284, openBlock as _openBlock284, createElementBlock as _createElementBlock284 } from "vue";
var wallet_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent284({
  name: "WalletFilled",
  __name: "wallet-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock284(), _createElementBlock284("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode284("path", {
        fill: "currentColor",
        d: "M688 512a112 112 0 1 0 0 224h208v160H128V352h768v160zm32 160h-32a48 48 0 0 1 0-96h32a48 48 0 0 1 0 96m-80-544 128 160H384z"
      })
    ]));
  }
});

// src/components/wallet-filled.vue
var wallet_filled_default = wallet_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/wallet.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent285 } from "vue";
import { createElementVNode as _createElementVNode285, openBlock as _openBlock285, createElementBlock as _createElementBlock285 } from "vue";
var wallet_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent285({
  name: "Wallet",
  __name: "wallet",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock285(), _createElementBlock285("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode285("path", {
        fill: "currentColor",
        d: "M640 288h-64V128H128v704h384v32a32 32 0 0 0 32 32H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h512a32 32 0 0 1 32 32z"
      }),
      _createElementVNode285("path", {
        fill: "currentColor",
        d: "M128 320v512h768V320zm-32-64h832a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32"
      }),
      _createElementVNode285("path", {
        fill: "currentColor",
        d: "M704 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
      })
    ]));
  }
});

// src/components/wallet.vue
var wallet_default = wallet_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/warn-triangle-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent286 } from "vue";
import { createElementVNode as _createElementVNode286, openBlock as _openBlock286, createElementBlock as _createElementBlock286 } from "vue";
var warn_triangle_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent286({
  name: "WarnTriangleFilled",
  __name: "warn-triangle-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock286(), _createElementBlock286("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode286("path", {
        fill: "currentColor",
        d: "M928.99 755.83 574.6 203.25c-12.89-20.16-36.76-32.58-62.6-32.58s-49.71 12.43-62.6 32.58L95.01 755.83c-12.91 20.12-12.9 44.91.01 65.03 12.92 20.12 36.78 32.51 62.59 32.49h708.78c25.82.01 49.68-12.37 62.59-32.49 12.91-20.12 12.92-44.91.01-65.03M554.67 768h-85.33v-85.33h85.33zm0-426.67v298.66h-85.33V341.32z"
      })
    ]));
  }
});

// src/components/warn-triangle-filled.vue
var warn_triangle_filled_default = warn_triangle_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/warning-filled.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent287 } from "vue";
import { createElementVNode as _createElementVNode287, openBlock as _openBlock287, createElementBlock as _createElementBlock287 } from "vue";
var warning_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent287({
  name: "WarningFilled",
  __name: "warning-filled",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock287(), _createElementBlock287("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode287("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 192a58.432 58.432 0 0 0-58.24 63.744l23.36 256.384a35.072 35.072 0 0 0 69.76 0l23.296-256.384A58.432 58.432 0 0 0 512 256m0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4"
      })
    ]));
  }
});

// src/components/warning-filled.vue
var warning_filled_default = warning_filled_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/warning.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent288 } from "vue";
import { createElementVNode as _createElementVNode288, openBlock as _openBlock288, createElementBlock as _createElementBlock288 } from "vue";
var warning_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent288({
  name: "Warning",
  __name: "warning",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock288(), _createElementBlock288("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode288("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m48-176a48 48 0 1 1-96 0 48 48 0 0 1 96 0m-48-464a32 32 0 0 1 32 32v288a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
      })
    ]));
  }
});

// src/components/warning.vue
var warning_default = warning_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/watch.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent289 } from "vue";
import { createElementVNode as _createElementVNode289, openBlock as _openBlock289, createElementBlock as _createElementBlock289 } from "vue";
var watch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent289({
  name: "Watch",
  __name: "watch",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock289(), _createElementBlock289("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode289("path", {
        fill: "currentColor",
        d: "M512 768a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      _createElementVNode289("path", {
        fill: "currentColor",
        d: "M480 352a32 32 0 0 1 32 32v160a32 32 0 0 1-64 0V384a32 32 0 0 1 32-32"
      }),
      _createElementVNode289("path", {
        fill: "currentColor",
        d: "M480 512h128q32 0 32 32t-32 32H480q-32 0-32-32t32-32m128-256V128H416v128h-64V64h320v192zM416 768v128h192V768h64v192H352V768z"
      })
    ]));
  }
});

// src/components/watch.vue
var watch_default = watch_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/watermelon.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent290 } from "vue";
import { createElementVNode as _createElementVNode290, openBlock as _openBlock290, createElementBlock as _createElementBlock290 } from "vue";
var watermelon_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent290({
  name: "Watermelon",
  __name: "watermelon",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock290(), _createElementBlock290("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode290("path", {
        fill: "currentColor",
        d: "m683.072 600.32-43.648 162.816-61.824-16.512 53.248-198.528L576 493.248l-158.4 158.4-45.248-45.248 158.4-158.4-55.616-55.616-198.528 53.248-16.512-61.824 162.816-43.648L282.752 200A384 384 0 0 0 824 741.248zm231.552 141.056a448 448 0 1 1-632-632l632 632"
      })
    ]));
  }
});

// src/components/watermelon.vue
var watermelon_default = watermelon_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/wind-power.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent291 } from "vue";
import { createElementVNode as _createElementVNode291, openBlock as _openBlock291, createElementBlock as _createElementBlock291 } from "vue";
var wind_power_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent291({
  name: "WindPower",
  __name: "wind-power",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock291(), _createElementBlock291("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode291("path", {
        fill: "currentColor",
        d: "M160 64q32 0 32 32v832q0 32-32 32t-32-32V96q0-32 32-32m416 354.624 128-11.584V168.96l-128-11.52v261.12zm-64 5.824V151.552L320 134.08V160h-64V64l616.704 56.064A96 96 0 0 1 960 215.68v144.64a96 96 0 0 1-87.296 95.616L256 512V224h64v217.92zm256-23.232 98.88-8.96A32 32 0 0 0 896 360.32V215.68a32 32 0 0 0-29.12-31.872l-98.88-8.96z"
      })
    ]));
  }
});

// src/components/wind-power.vue
var wind_power_default = wind_power_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/zoom-in.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent292 } from "vue";
import { createElementVNode as _createElementVNode292, openBlock as _openBlock292, createElementBlock as _createElementBlock292 } from "vue";
var zoom_in_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent292({
  name: "ZoomIn",
  __name: "zoom-in",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock292(), _createElementBlock292("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode292("path", {
        fill: "currentColor",
        d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704m-32-384v-96a32 32 0 0 1 64 0v96h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64z"
      })
    ]));
  }
});

// src/components/zoom-in.vue
var zoom_in_default = zoom_in_vue_vue_type_script_setup_true_lang_default;

// unplugin-vue:/home/runner/work/element-plus-icons/element-plus-icons/packages/vue/src/components/zoom-out.vue?vue&type=script&setup=true&lang.ts
import { defineComponent as _defineComponent293 } from "vue";
import { createElementVNode as _createElementVNode293, openBlock as _openBlock293, createElementBlock as _createElementBlock293 } from "vue";
var zoom_out_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ _defineComponent293({
  name: "ZoomOut",
  __name: "zoom-out",
  setup(__props) {
    return (_ctx, _cache) => (_openBlock293(), _createElementBlock293("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      _createElementVNode293("path", {
        fill: "currentColor",
        d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704M352 448h256a32 32 0 0 1 0 64H352a32 32 0 0 1 0-64"
      })
    ]));
  }
});

// src/components/zoom-out.vue
var zoom_out_default = zoom_out_vue_vue_type_script_setup_true_lang_default;
export {
  add_location_default as AddLocation,
  aim_default as Aim,
  alarm_clock_default as AlarmClock,
  apple_default as Apple,
  arrow_down_default as ArrowDown,
  arrow_down_bold_default as ArrowDownBold,
  arrow_left_default as ArrowLeft,
  arrow_left_bold_default as ArrowLeftBold,
  arrow_right_default as ArrowRight,
  arrow_right_bold_default as ArrowRightBold,
  arrow_up_default as ArrowUp,
  arrow_up_bold_default as ArrowUpBold,
  avatar_default as Avatar,
  back_default as Back,
  baseball_default as Baseball,
  basketball_default as Basketball,
  bell_default as Bell,
  bell_filled_default as BellFilled,
  bicycle_default as Bicycle,
  bottom_default as Bottom,
  bottom_left_default as BottomLeft,
  bottom_right_default as BottomRight,
  bowl_default as Bowl,
  box_default as Box,
  briefcase_default as Briefcase,
  brush_default as Brush,
  brush_filled_default as BrushFilled,
  burger_default as Burger,
  calendar_default as Calendar,
  camera_default as Camera,
  camera_filled_default as CameraFilled,
  caret_bottom_default as CaretBottom,
  caret_left_default as CaretLeft,
  caret_right_default as CaretRight,
  caret_top_default as CaretTop,
  cellphone_default as Cellphone,
  chat_dot_round_default as ChatDotRound,
  chat_dot_square_default as ChatDotSquare,
  chat_line_round_default as ChatLineRound,
  chat_line_square_default as ChatLineSquare,
  chat_round_default as ChatRound,
  chat_square_default as ChatSquare,
  check_default as Check,
  checked_default as Checked,
  cherry_default as Cherry,
  chicken_default as Chicken,
  chrome_filled_default as ChromeFilled,
  circle_check_default as CircleCheck,
  circle_check_filled_default as CircleCheckFilled,
  circle_close_default as CircleClose,
  circle_close_filled_default as CircleCloseFilled,
  circle_plus_default as CirclePlus,
  circle_plus_filled_default as CirclePlusFilled,
  clock_default as Clock,
  close_default as Close,
  close_bold_default as CloseBold,
  cloudy_default as Cloudy,
  coffee_default as Coffee,
  coffee_cup_default as CoffeeCup,
  coin_default as Coin,
  cold_drink_default as ColdDrink,
  collection_default as Collection,
  collection_tag_default as CollectionTag,
  comment_default as Comment,
  compass_default as Compass,
  connection_default as Connection,
  coordinate_default as Coordinate,
  copy_document_default as CopyDocument,
  cpu_default as Cpu,
  credit_card_default as CreditCard,
  crop_default as Crop,
  d_arrow_left_default as DArrowLeft,
  d_arrow_right_default as DArrowRight,
  d_caret_default as DCaret,
  data_analysis_default as DataAnalysis,
  data_board_default as DataBoard,
  data_line_default as DataLine,
  delete_default as Delete,
  delete_filled_default as DeleteFilled,
  delete_location_default as DeleteLocation,
  dessert_default as Dessert,
  discount_default as Discount,
  dish_default as Dish,
  dish_dot_default as DishDot,
  document_default as Document,
  document_add_default as DocumentAdd,
  document_checked_default as DocumentChecked,
  document_copy_default as DocumentCopy,
  document_delete_default as DocumentDelete,
  document_remove_default as DocumentRemove,
  download_default as Download,
  drizzling_default as Drizzling,
  edit_default as Edit,
  edit_pen_default as EditPen,
  eleme_default as Eleme,
  eleme_filled_default as ElemeFilled,
  element_plus_default as ElementPlus,
  expand_default as Expand,
  failed_default as Failed,
  female_default as Female,
  files_default as Files,
  film_default as Film,
  filter_default as Filter,
  finished_default as Finished,
  first_aid_kit_default as FirstAidKit,
  flag_default as Flag,
  fold_default as Fold,
  folder_default as Folder,
  folder_add_default as FolderAdd,
  folder_checked_default as FolderChecked,
  folder_delete_default as FolderDelete,
  folder_opened_default as FolderOpened,
  folder_remove_default as FolderRemove,
  food_default as Food,
  football_default as Football,
  fork_spoon_default as ForkSpoon,
  fries_default as Fries,
  full_screen_default as FullScreen,
  goblet_default as Goblet,
  goblet_full_default as GobletFull,
  goblet_square_default as GobletSquare,
  goblet_square_full_default as GobletSquareFull,
  gold_medal_default as GoldMedal,
  goods_default as Goods,
  goods_filled_default as GoodsFilled,
  grape_default as Grape,
  grid_default as Grid,
  guide_default as Guide,
  handbag_default as Handbag,
  headset_default as Headset,
  help_default as Help,
  help_filled_default as HelpFilled,
  hide_default as Hide,
  histogram_default as Histogram,
  home_filled_default as HomeFilled,
  hot_water_default as HotWater,
  house_default as House,
  ice_cream_default as IceCream,
  ice_cream_round_default as IceCreamRound,
  ice_cream_square_default as IceCreamSquare,
  ice_drink_default as IceDrink,
  ice_tea_default as IceTea,
  info_filled_default as InfoFilled,
  iphone_default as Iphone,
  key_default as Key,
  knife_fork_default as KnifeFork,
  lightning_default as Lightning,
  link_default as Link,
  list_default as List,
  loading_default as Loading,
  location_default as Location,
  location_filled_default as LocationFilled,
  location_information_default as LocationInformation,
  lock_default as Lock,
  lollipop_default as Lollipop,
  magic_stick_default as MagicStick,
  magnet_default as Magnet,
  male_default as Male,
  management_default as Management,
  map_location_default as MapLocation,
  medal_default as Medal,
  memo_default as Memo,
  menu_default as Menu,
  message_default as Message,
  message_box_default as MessageBox,
  mic_default as Mic,
  microphone_default as Microphone,
  milk_tea_default as MilkTea,
  minus_default as Minus,
  money_default as Money,
  monitor_default as Monitor,
  moon_default as Moon,
  moon_night_default as MoonNight,
  more_default as More,
  more_filled_default as MoreFilled,
  mostly_cloudy_default as MostlyCloudy,
  mouse_default as Mouse,
  mug_default as Mug,
  mute_default as Mute,
  mute_notification_default as MuteNotification,
  no_smoking_default as NoSmoking,
  notebook_default as Notebook,
  notification_default as Notification,
  odometer_default as Odometer,
  office_building_default as OfficeBuilding,
  open_default as Open,
  operation_default as Operation,
  opportunity_default as Opportunity,
  orange_default as Orange,
  paperclip_default as Paperclip,
  partly_cloudy_default as PartlyCloudy,
  pear_default as Pear,
  phone_default as Phone,
  phone_filled_default as PhoneFilled,
  picture_default as Picture,
  picture_filled_default as PictureFilled,
  picture_rounded_default as PictureRounded,
  pie_chart_default as PieChart,
  place_default as Place,
  platform_default as Platform,
  plus_default as Plus,
  pointer_default as Pointer,
  position_default as Position,
  postcard_default as Postcard,
  pouring_default as Pouring,
  present_default as Present,
  price_tag_default as PriceTag,
  printer_default as Printer,
  promotion_default as Promotion,
  quartz_watch_default as QuartzWatch,
  question_filled_default as QuestionFilled,
  rank_default as Rank,
  reading_default as Reading,
  reading_lamp_default as ReadingLamp,
  refresh_default as Refresh,
  refresh_left_default as RefreshLeft,
  refresh_right_default as RefreshRight,
  refrigerator_default as Refrigerator,
  remove_default as Remove,
  remove_filled_default as RemoveFilled,
  right_default as Right,
  scale_to_original_default as ScaleToOriginal,
  school_default as School,
  scissor_default as Scissor,
  search_default as Search,
  select_default as Select,
  sell_default as Sell,
  semi_select_default as SemiSelect,
  service_default as Service,
  set_up_default as SetUp,
  setting_default as Setting,
  share_default as Share,
  ship_default as Ship,
  shop_default as Shop,
  shopping_bag_default as ShoppingBag,
  shopping_cart_default as ShoppingCart,
  shopping_cart_full_default as ShoppingCartFull,
  shopping_trolley_default as ShoppingTrolley,
  smoking_default as Smoking,
  soccer_default as Soccer,
  sold_out_default as SoldOut,
  sort_default as Sort,
  sort_down_default as SortDown,
  sort_up_default as SortUp,
  stamp_default as Stamp,
  star_default as Star,
  star_filled_default as StarFilled,
  stopwatch_default as Stopwatch,
  success_filled_default as SuccessFilled,
  sugar_default as Sugar,
  suitcase_default as Suitcase,
  suitcase_line_default as SuitcaseLine,
  sunny_default as Sunny,
  sunrise_default as Sunrise,
  sunset_default as Sunset,
  switch_default as Switch,
  switch_button_default as SwitchButton,
  switch_filled_default as SwitchFilled,
  takeaway_box_default as TakeawayBox,
  ticket_default as Ticket,
  tickets_default as Tickets,
  timer_default as Timer,
  toilet_paper_default as ToiletPaper,
  tools_default as Tools,
  top_default as Top,
  top_left_default as TopLeft,
  top_right_default as TopRight,
  trend_charts_default as TrendCharts,
  trophy_default as Trophy,
  trophy_base_default as TrophyBase,
  turn_off_default as TurnOff,
  umbrella_default as Umbrella,
  unlock_default as Unlock,
  upload_default as Upload,
  upload_filled_default as UploadFilled,
  user_default as User,
  user_filled_default as UserFilled,
  van_default as Van,
  video_camera_default as VideoCamera,
  video_camera_filled_default as VideoCameraFilled,
  video_pause_default as VideoPause,
  video_play_default as VideoPlay,
  view_default as View,
  wallet_default as Wallet,
  wallet_filled_default as WalletFilled,
  warn_triangle_filled_default as WarnTriangleFilled,
  warning_default as Warning,
  warning_filled_default as WarningFilled,
  watch_default as Watch,
  watermelon_default as Watermelon,
  wind_power_default as WindPower,
  zoom_in_default as ZoomIn,
  zoom_out_default as ZoomOut
};
